import { ChangeDetectorRef, Component, EventEmitter, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { QuestionUpdateService } from '../shared/services/question-update.service';
import { UserServiceService } from '../user/survey-main/service/user-service.service';
import { SurveyViewModel } from 'src/app/shared/models/surveyview.model';
import { CreateSurvey, Question, QuestionAnswer } from 'src/app/shared/components/page/page.model';
import { CardService } from 'src/app/shared/components/view/card/card.service';
import { SectionViewModel, GridViewModel, ResponseModel } from 'src/app/shared/models/sectionview.model';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';
import { FileUploadRequest } from 'src/app/shared/models/questionview.model';
import { SurveyResponseClass } from '../user/survey-main/start/start.model';
import { SurveySubmissionStatus } from 'src/app/shared/survey-submission-status.enum';
import { Constants } from 'src/app/shared/constants';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { NotificationService } from 'src/app/shared/services/notifications.service';
import { Router } from '@angular/router';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { SurveyResponse, SurveyUserResponse } from 'src/app/create/models/serveyResponses.model';
import { WorkflowView } from 'src/app/create/models/workflowView.model';
import { WorkflowSteps, WorkflowStepSection } from 'src/app/create/models/workflowSteps.model';
import { WFStatusResult, WorkflowStepAssignedView } from '../create/models/workflowStepAssignedView.model';
import { faAlignJustify, faAngleLeft, faAngleRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { CreateBusinessProcessModel } from '../create/models/businessProcess.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserActivityLogModel } from '../shared/models/userActivityLog.model';
import { ModalSize } from '../shared/components/view/modal/modal.model';
import { ButtonSize, ButtonStyle, ButtonType } from '../shared/components/inputs/button/button.model';
import { lookup } from 'dns';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { EntityMaster } from '../shared/models/entityMaster.model';
import { EntityField } from '../create/models/entity.model';
import { entitySearchModel, SearchFilter } from '../business-process/business-process.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment'
import DOMPurify from 'dompurify';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConsentDialogComponent } from '../shared/components/incident-consent-dialog/consent-dialog.component';
import { ConsentSignDialogComponent } from '../shared/components/incident-consent-sign-dialog/consent-sign-dialog.component';
import { CommonMessageComponent } from '../shared/components/common-message/common-message.component';
import { AgencyModel } from '../shared/models/agency.model';
import { DisputeService } from '../shared/services/dispute.service';
import { GeneratePdfService } from '../shared/services/generate-pdf-service';
import { DownloadAsService } from '../shared/services/downloadAs.service';
import { SyncSurveyService } from '../shared/services/sync-survey.service';
import { IDispute, IDisputeSignResponse } from '../shared/models/dispute/dispute.model';
import { IDisputeConfig } from '../shared/models/dispute/disputeConfig.model';
import { IDisputeQuestion } from '../shared/models/dispute/disputeQuestion.model';
import { AppConstants } from '../shared/appconstants';
import { DisputeSignatureComponent } from '../incident-dispute/dispute-signature/dispute-signature.component';
import { StorageService } from '../shared/services/token-storage.service';

@Component({
  selector: 'app-incident',
  templateUrl: './incident.component.html',
  styleUrls: ['./incident.component.scss']
,  standalone: false
})
export class IncidentComponent implements OnInit, OnDestroy {
  // Event emitter for resetting questions
  @Output() resetQuestionsEvent = new EventEmitter<any[]>();

  // Exposed for template button bindings (savebtnClick(..., SurveySubmissionStatus.Save/.Submit))
  protected readonly SurveySubmissionStatus = SurveySubmissionStatus;

  constant: Constants = new Constants();
  appConstants: AppConstants = new AppConstants();
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faAlignJustify = faAlignJustify;
  faPlus = faPlus;
  arrowIconToggle: boolean = false;
  surveyId: string;
  groupId: string;
  isAnonymusUser: boolean = false;
  surveyDetails: CreateSurvey;
  WorkflowAssignment: WorkflowStepAssignedView[] = [];
  ResponsesurveyDetails: CreateSurvey;
  IsWorkflow: boolean = false;
  surveyViewModel: SurveyViewModel;
  userResponse: SurveyUserResponse;
  IsReadOnly: boolean = false;
  isCommentsEditable: boolean = false;
  esignConsent: string = "By participating in a survey, you consent to the transfer of the information you submit to the Health Slice. The information collected is for internal purposes only. However, we may share the results of this survey with the public in anonymized or aggregated forms.";
  surveyResponseId: number = 0;
  selectedSectionIndex: number;
  selectedStepIndex: number;
  prevSelectedSectionIndex: number;
  prevSelectedStepIndex: number;
  isSaveAndClose: boolean = false;
  conditionQues: ConditionalQues[] = [];
  conditionSections: ConditionalSections[] = [];
  isCond: boolean = false;
  newConditionalQuestions: ConditionalQues[] = [];
  IsTotalSection: boolean = false;
  totalSections: number = 0;
  selectedIndex: number = 1;
  selectedIndexDisplay: number = 1;
  hidesection: boolean = false;
  hiddenSectionCount: number = 0;
  lastQuestionIndex: number;
  questionCommentBackUp: QuestionResponsesdata[] = [];
  responsesBackUp: QuestionResponsesdata[] = [];
  questionList: number[] = [];
  showClearResponsesPopUp: boolean = false;
  clearPopupText: string = "Information in dependent questions will be cleared. Do you wish to proceed?";
  clearResponsesSelected: boolean = false;
  //percentage: number = 0;
  bpWFdetails: WorkflowView;
  selectedSection: SectionViewModel;
  AllFieldsValid: boolean = true;
  AllResponsesValid :boolean = true;
  matrixErrorMessage: string[] = [];
  signaturePad: any;
  selectedUser: any;
  IsAnyESignPresent: boolean = false;
  OptionSelectedToDrawSign: any;
  canvasEl: any;
  surveyResponseClass: SurveyResponseClass = new SurveyResponseClass();
  addedsurveyResponses: SurveyResponseClass[] = [];
  addedStandalonesurveyResponses: SurveyResponseClass[] = [];
  surveyInstanceId: string;
  businessProcessId: string;
  processDetails: CreateBusinessProcessModel;
  selectedStep: WorkflowSteps;
  SurveyId: string;
  isSectionReadOnly: boolean = false;
  isBusinessprocessExists = true;
  hideDisclaimerPopUp: boolean = true;
  isSurveyCompleted: boolean = false;
  displayInfoData: any; colWidth: any;
  quesFieldDataSource: any;
  signAvailable: boolean = true;
  imagePath: any;
  quesCommBackUp: QuestionResponsesdata[] = [];
  displayedColumns: string[] = [];
  AllWorkflowReport: WFStatusResult[] = [];
  currStp: WorkflowStepAssignedView;
  wfSteps: WorkflowSteps[] = [];
  pendingStepId: number;
  stepNavigated: any;
  isStandaloneSurvey: boolean = false;
  standaloneSurveyDetails: CreateSurvey;
  isAnonymous = false;
  surveyresponseclass: SurveyResponseClass;
  standaloneSurveyStatus: SurveySubmissionStatus;
  processName: string;
  modalDisclaimerSize: ModalSize.Medium;
  modalDisclaimerText: string = "Disclaimer";
  noBtnText: string = "DECLINE";
  yesBtnText: string = "ACCEPT";
  cancelBtntext: string = "CANCEL";
  proceedBtntext: string = "PROCEED";
  modalClearRespPopupText: string = "Confirmation";
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;
  btnXlarge = ButtonSize.Medium;
  btnSmall = ButtonSize.Small;
  buttontype: string;

  showEntityInstancePopUp: boolean = false;
  modalInstanceSize: ModalSize.Large;
  modalInstanceText: string = "Action";
  showExtraComments:boolean = false;
  //btnWithText = ButtonStyle.Textonly;
  //btnRect = ButtonType.Rectangle;
  //btnXlarge = ButtonSize.Medium;
  failedQuestionIds=new Set<string>();
  selectedEntityInstanceElement: any;
  selectedEntityInstanceId: string;
  // entityInstancesList : EntityInstance[] = [{entityInstanceId :"1",entityInstanceName :"Entity Instance 1"},
  // {entityInstanceId :"1",entityInstanceName :"Entity Instance 2"},
  // {entityInstanceId :"1",entityInstanceName :"Entity Instance 3"}];
  noLookUpInstances: boolean = false;
  //lookUpEntityInstancesList: EntityInstance[] = [];
  processSurveyId: string;
  entityDetails: EntityMaster;
  entityFields: EntityField[] = [];
  searchableFields: EntityField[] = [];
  resultFields: EntityField[] = [];
  infoBarFields: EntityField[] = [];

  displayedEntityInstanceColumns: string[] = [];
  dataEntityInstanceSource = new MatTableDataSource([]);
  pageIndex = 0;
  size = 5;
  totalItems: any;
  entitySearchModel = new entitySearchModel();
  instancesFieldData: any;
  entitySurveyId: string = "";
  lookUpDisplayInfo: boolean = false;
  lookupInstances: string[] = [];
selectedOrgName: any;
resetFlag: any;
  //@ViewChild(MatSort, { static: false }) sort: MatSort;
  incidentCreateShouldLog : boolean = false;
  surveyDueDate:Date;
  userRole :string = "";
  consentQuestions : QuestionViewModel[] = [];
  consentModalSize:ModalSize = ModalSize.CustomConsentPopup;
  agencyDetails : AgencyModel;
  isSaveRequired:boolean = false;
  isScrolled:Boolean = false;
  openCondQuesPopup:boolean = false
  openCondSecPopup:boolean = false

  raiseDisputeMode: boolean = false;
  dispute: IDispute;
  surveyDisputeConfig: IDisputeConfig;
  isDisputeRaised: boolean = false;
  FileUploading: boolean = false;
  disputeQuestionBackup: IDisputeQuestion[] = [];
  mappedMeasuresMap: Record<number, any> = {};
  private destroy$ = new Subject<void>();

  constructor(private cardservice: CardService,
    private baseHttpService: BaseHttpService, private globalSession: GlobalsessionhandlerService,
    private notificationService: NotificationService, private router: Router, private changeDetectorRef: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService, private fb: FormBuilder,
    private sanitizer:DomSanitizer, private dialog : MatDialog,
    private questionUpdateService: QuestionUpdateService, private cdr: ChangeDetectorRef, private zone: NgZone,
    private downloadService: DownloadAsService,
    private syncSurveyService: SyncSurveyService, private disputeService: DisputeService,
    private storage: StorageService) {

  }
  searchForm = new FormGroup({
    entityControl: new FormControl(new EntityMaster()),
    search: new FormControl(''),
    dynamicControls: this.fb.group({})
  });


  changeArrowIcon() {
    this.arrowIconToggle = !this.arrowIconToggle;
  }
  getDisplayInfoDetails() {
    try {
      let templist: any;
      this.cardservice._tempDisplayInfoBarMessage.subscribe((message) => templist = message);
      if (templist != null && Object.keys(templist).length > 0) {
        this.displayInfoData = templist;
        this.displayedColumns = Object.keys(this.displayInfoData.value);
      }
      else {
        if(this.displayInfoData == undefined || this.displayInfoData == null) {
          this.displayInfoData;
          this.displayInfoData = {
            value: {
              "Master Provider Index (MPI)": this.storage.get("LoggedInUserAgencyId"),
              "Provider Legal Entity Name": this.storage.get("LoggedInUserAgency")
            }
          };
        }
        this.displayedColumns = Object.keys(this.displayInfoData.value);
        //this.displayedColumns = [];
        //this.displayInfoData = null;
      }
    } catch (error) {
      console.error('[IncidentComponent] getDisplayInfoDetails - Error:', error);
    }
  }
  async ngOnInit() {
    try {
      this.spinnerService.show();
      let bindResult = [];
      let isViewMode = this.globalSession.getViewIconFlag();
      let IsBindUserResponse = false;
      this.currStp = this.globalSession.getNavigatedStep();
      this.userRole = this.storage.get("LoggedInUserTypeDesc") as string ;

    this.cardservice.tempUserRespMessage.subscribe((message: SurveyUserResponse) => this.userResponse = message);
    this.standaloneSurveyDetails = this.globalSession.getSurvey();
    if (this.standaloneSurveyDetails == null || this.standaloneSurveyDetails == undefined || Object.keys(this.standaloneSurveyDetails).length == 0) {
      this.cardservice._tempBProcessDetailsMessage.subscribe((message: CreateBusinessProcessModel) => this.processDetails = message);
      this.cardservice.currentMessage.subscribe((message: CreateSurvey) => this.surveyDetails = message);
      this.cardservice._tempBPWorkflowDetailsMessage.subscribe((message) => this.bpWFdetails = message);
      this.cardservice.tempWFAssignmentDetailMessage.subscribe((message: WorkflowStepAssignedView[]) => this.WorkflowAssignment = message);
      //let incidentParam = JSON.parse(localStorage.getItem("BPIncidentParamOnEdit"));
      // this.baseHttpService.post(this.constant.getProcessWFStepAssignedNew, incidentParam).subscribe((data: WorkflowStepAssignedView[]) => {
      //   
      //   this.WorkflowAssignment = data;
      //   console.log("wof flow data", data);
      // });

      if (this.processDetails.businessProcessID != null && this.processDetails.businessProcessID != undefined) {

        this.groupId = this.storage.get("UserGroupId");
        this.isAnonymusUser = this.globalSession.getAnonymousUser();
        this.surveyId = this.globalSession.getSurveyId();
        this.businessProcessId = this.globalSession.getBussinessProcessId();
        this.surveyInstanceId = this.globalSession.getSurveyInstanceId();
        this.surveyDueDate = this.surveyDetails.dueDate;
        this.checkIfBusinessprocessExists();
        this.CheckSurveyStatus();
        this.checkIfWorkFlowExists();
        this.getDisplayInfoDetails();
        if (!this.globalSession.getViewIconFlag()) {
           // Only call for edit mode
           this.setEditableStepForCurrentUser();
        }
        if (this.processDetails.logoImage) {
          this.imagePath = 'data:image/jpg;base64,' + this.processDetails.logoImage;
        }
        this.cardservice.tempUserRespMessage.subscribe((message: SurveyUserResponse) => this.userResponse = message);
        this.cardservice.tempAgencyMessage.subscribe((message: AgencyModel) => this.agencyDetails = message);


        let surveyDetails = this.surveyDetails;
        if (surveyDetails.eSignConsentText && surveyDetails.eSignConsentText.length > 0) {
          this.esignConsent = surveyDetails.eSignConsentText;
        }
        if (this.userResponse && this.userResponse.responses) {
          IsBindUserResponse = true;
          (this.userResponse.isSurveyCompleted || this.userRole?.toLowerCase() == 'group admin') ? this.IsReadOnly = true : this.IsReadOnly = false;
          bindResult = this.userResponse.responses;
        }
        else {
          this.IsReadOnly = false;
        }

        this.bindSurveyViewModel(surveyDetails, bindResult, isViewMode , IsBindUserResponse);
        this.processName = this.processDetails.businessProcessName;
        this.processSurveyId = (this.processDetails != null && this.processDetails.surveyModel != null) ? this.processDetails.surveyModel.surveyId : "";

      }
      else {
       let surveyresponsePageFlag = this.storage.get("surveyResponsePageFlag");
       if(surveyresponsePageFlag != null && surveyresponsePageFlag == "true"){
        return this.router.navigateByUrl("/dashboard/mysurveydashboard"); 
       }
       else{
        return this.router.navigateByUrl("/businessProcess"); 
       }          
      }
      this.IsReadOnly = isViewMode
    }
    else {
      this.isStandaloneSurvey = true;
      this.IsReadOnly = true;
      this.isAnonymous = this.globalSession.getAnonymousUser();
      this.surveyId = this.globalSession.getSurveyId();
      this.ResponsesurveyDetails = this.standaloneSurveyDetails;
      this.surveyresponseclass = new SurveyResponseClass();
      if (this.standaloneSurveyDetails.logoImage) {
        this.imagePath = 'data:image/jpg;base64,' + this.standaloneSurveyDetails.logoImage;
      }
      if (this.standaloneSurveyDetails.eSignConsentText && this.standaloneSurveyDetails.eSignConsentText.length > 0) {
        this.esignConsent = this.standaloneSurveyDetails.eSignConsentText;
      }

      let loggedInUserId = this.storage.get("LoggedInuserId");
      if(loggedInUserId != null){       
        loggedInUserId = loggedInUserId.replace(/["']/g, "");
      }
     
      if (this.userResponse && this.userResponse.responses) {
        IsBindUserResponse = true;
        (this.userResponse.isSurveyCompleted || (loggedInUserId != null && loggedInUserId != this.userResponse.userId) || this.userRole?.toLowerCase() == 'group admin') ? this.IsReadOnly = true : this.IsReadOnly = false;
        bindResult = this.userResponse.responses;
      }
      else {
        this.IsReadOnly = false;
      }

      this.bindSurveyViewModel(this.standaloneSurveyDetails, bindResult, true, IsBindUserResponse);
    }

      this.setSafeHtmlForQuestions();
      await this.setInitialSection();
      this.setSectionDotColor_NEW();
      this.resetTempVariables();
      document.querySelector('#surveyForm').addEventListener('keydown', function (event) {
        const keyboardEvent = event as KeyboardEvent;
        if (keyboardEvent.key === 'Enter') {
          keyboardEvent.preventDefault();
        }
      });

      this.setDisputeDetailsonLoad();
      this.applyFailedMeasureRedDots();
      this.spinnerService.hide();
    } catch (error) {
      console.error('[IncidentComponent] ngOnInit - Error:', error);
      this.spinnerService.hide();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
 

  isSurveyExpired(deadline:any): boolean{
        let dueDate: Date;
        if(!deadline) {
        dueDate=new Date('9999-12-31T23:59:59');
        } else{
        dueDate=new Date(deadline);
        }
        return new Date()>dueDate;
  }
  

  // isInputChanged(value:any){
  //   this.isSaveRequired = true;
  //   const ChildQues = this.surveyViewModel.sections[this.selectedSectionIndex].questions.filter(x=>x.parentQuestionGuid == value.questionGuid);
  //   const condSection = this.surveyViewModel.sections.filter(x=>x.parentQuestionGuid == value.questionGuid);
  //   if(ChildQues.length > 0){
  //     const parResp = value.responseText.split("||")
  //     ChildQues.forEach((item)=>{
  //       // const childResp = item.parentQuesResponse.split("||")
  //       // if(value.inputType === 'chk'){
  //       //   if(item.isParentQuestionVisible && !parResp.some(r=>childResp.includes(r))){
  //       //   this.openCondQuesPopup = true;
  //       // }
  //       // }
  //       // else{
  //       //   if (parResp.some(r => !childResp.includes(r))) {
  //       //     this.openCondQuesPopup = true;
  //       //   }
  //       // }
  //       this.openCondQuesPopup ||= this.isChildQuestionVisible(item,value);
  //     })
  //   }
  //   if (condSection.length > 0) {
  //     condSection.forEach((item) => {
  //       // const childResp = item.parentQuesResponse.split("||")
  //       // if(value.inputType === 'chk'){
  //       //   if(item.isParentQuestionVisible && !parResp.some(r=>childResp.includes(r))){
  //       //   this.openCondQuesPopup = true;
  //       // }
  //       // }
  //       // else{
  //       //   if (parResp.some(r => !childResp.includes(r))) {
  //       //     this.openCondQuesPopup = true;
  //       //   }
  //       // }
  //       this.openCondSecPopup ||= this.isChildSectionVisible(item, value);
  //     })
  //   }



  //   if(this.openCondQuesPopup || this.openCondSecPopup){
  //     const dialogConfig = new MatDialogConfig();
  //     dialogConfig.width = '350px';
  //     dialogConfig.position = { top: '5px' };
  //     dialogConfig.data = "Information in dependent questions will be cleared. Do you wish to proceed?";
  //     const ref = this.dialog.open(CommonMessageComponent, dialogConfig)

  //     ref.afterClosed().subscribe((res) => {
  //       if (res) {
  //         this.clearResponses(value)
  //       }
  //       else {
  //         // this.surveyViewModel.sections[this.selectedSectionIndex].questions.forEach((q) => {
  //         //   if (q.parentQuestionGuid == value.questionGuid) {
  //         //     if(this.isChildQuestionVisible(q,value)){
  //         //       q.isParentQuestionVisible = true;
  //         //     }
  //         //   }
  //         // });
  //         if(!this.openCondSecPopup && this.openCondQuesPopup){
  //           this.surveyViewModel.sections[this.selectedSectionIndex].questions.forEach((q) => {
  //           if (q.parentQuestionGuid == value.questionGuid) {
  //             if(this.isChildQuestionVisible(q,value)){
  //               q.isParentQuestionVisible = true;
  //             }
  //           }
  //         });
  //         this.closeClearResponsesPopup(value)
  //         }
  //         else{
  //           this.ResetSection(value);
  //           this.ToggleSections();
  //           this.closeClearResponsesPopup(value)
  //         }
  //         // this.closeClearResponsesPopup(value)
  //         // this.GetChildDataAndSetVisibility_NEW(value);
  //         // this.ToggleSections();
  //       }
  //       this.openCondQuesPopup = false;
  //       this.openCondSecPopup = false;
  //     })
  //   }
  //   else{
  //     this.GetChildDataAndSetVisibility_NEW(value);
  //   }

  // }

  // isChildQuestionVisible(child: QuestionViewModel, value: QuestionViewModel): boolean {
  //   const childResp = child.parentQuesResponse.split("||")
  //   const parResp = value.responseText.split("||")
  //   var parBackResp = this.questionCommentBackUp.find(x=>x.questionId == value.questionId).questionReponse
  //   let visible = false
  //   if (value.inputType === 'chk') {
  //     if(parBackResp!=undefined && parBackResp.length > 0){
  //       if(parBackResp.split("||").some(y=>childResp.includes(y)) && !parResp.some(r => childResp.includes(r))){
  //         visible = true
  //     }
  //     }
  //     else{
  //       if (child.isParentQuestionVisible && !parResp.some(r => childResp.includes(r))) {
  //         visible = true
  //       }
  //     }
  //   }
  //   else {
  //     if (parResp.some(r => !childResp.includes(r))) {
  //       visible = true;
  //     }
  //   }
  //   return visible;
  // }

  // isChildSectionVisible(child: SectionViewModel, value: QuestionViewModel): boolean {
  //   const childResp = child.parentQuesResponse.split("||")
  //   const parResp = value.responseText.split("||")
  //   var parBackResp = this.questionCommentBackUp.find(x=>x.questionId == value.questionId).questionReponse
  //   let visible = false
  //   if (value.inputType === 'chk') {
  //     if(parBackResp!=undefined && parBackResp.length > 0){
  //       if(parBackResp.split("||").some(y=>childResp.includes(y)) && parResp.some(r => !childResp.includes(r))){
  //         visible = true
  //     }
  //     }
  //     else{
  //       if (child.isSecParentQuestionVisible && !parResp.some(r => childResp.includes(r))) {
  //         visible = true
  //       }
  //     }
  //   }
  //   else {
  //     if (parResp.some(r => !childResp.includes(r))) {
  //       visible = true;
  //     }
  //   }
  //   return visible;
  // }

  isInputChanged(value:any) {
    this.isSaveRequired = true;
  }
  isConditionalCheck(data: ResponseChangeModel) {
    try {
      if(data == null || data.question == null){
        console.warn('[IncidentComponent] isConditionalCheck - data or data.question is null/undefined');
        return;
      }
      const currQues: QuestionViewModel = data.question;
      const proceedCallback = data.proceed || (() => {});

      if(currQues.inputType === 'mul' || currQues.inputType === 'chk' || currQues.inputType === 'rdo' || currQues.inputType === 'cmb') {
        const openDialog = this.checkIfChildQuesOrSecExists(data);
        if (openDialog) {
          const dialogRef = this.dialog.open(CommonMessageComponent, {
            width: '650px',
            position: { top: '5px' },
            disableClose : true,
            data: "Information in dependent sections or questions will be cleared. Do you wish to proceed?"
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.isSaveRequired = true;
              currQues.responseText = data.newResponse;
              this.clearDependingQuestions(currQues);
              proceedCallback(true);
            } else {
              proceedCallback(false);
            }
          });
        } else {
          proceedCallback(true);
        }
      }
    } catch (error) {
      console.error('[IncidentComponent] isConditionalCheck - Error:', error);
    }
  }  
  checkIfChildQuesOrSecExists(data: any): boolean {   
    try {
      let currQues = data.question;
      let openDialog = false;
      if((data.oldResponse == null || data.oldResponse.length == 0) && data.newResponse && data.newResponse.length > 0){
        return false;
      }   
      const parentResp = data.newResponse.includes("||") ? data.newResponse.split("||") : [data.newResponse];
      const allChildQuestions = this.surveyViewModel && this.surveyViewModel.sections ? this.surveyViewModel.sections.flatMap(s => s.questions || []).filter(q => q.parentQuestionGuid === currQues.questionGuid) : [];
      const allChildSections = this.surveyViewModel && this.surveyViewModel.sections ? this.surveyViewModel.sections.filter(s => s.ParentSectionGuid === currQues.sectionGuid) : [];

         //check conditional questions
        allChildQuestions.forEach((childQ) => {
          let valuesExitstsIngrid = false;
          if(childQ.inputType == "table"){
            valuesExitstsIngrid = this.CheckIfGridHasData(childQ);
          }
          if((childQ.responseText != null && childQ.responseText.length > 0) || valuesExitstsIngrid){
             let childRespExpected = childQ.parentQuesResponse.includes("||") ? childQ.parentQuesResponse.split("||") : [childQ.parentQuesResponse];
            if (childRespExpected.length > 0 && !childRespExpected.some(v => parentResp.indexOf(v) !== -1)) {
              openDialog = true;
            }        
          }                  
        });

        //check conditional sections --not working
        allChildSections.forEach((childSec) => {
          let anyRespAvailable = childSec.questions.some(q=> q.responseText != null && q.responseText.length > 0);
          let condQues = this.selectedSection && this.selectedSection.questions ? this.selectedSection.questions.find(q => q.questionGuid === childSec.parentQuestionGuid) : null;
          if(condQues && currQues.questionId == condQues.questionId){
            let childRespExpected = childSec.parentQuesResponse.includes("||") ? childSec.parentQuesResponse.split("||") : [childSec.parentQuesResponse];
            if (anyRespAvailable && childRespExpected.length > 0 && !childRespExpected.some(v => parentResp.indexOf(v) !== -1)) {
              openDialog = true;
            }
              
          }        
        });
      return openDialog;
    } catch (error) {
      console.error('[IncidentComponent] checkIfChildQuesOrSecExists - Error:', error);
      return false;
    }
  }
  CheckIfGridHasData(gridChildQ: QuestionViewModel) {
    try {
      let valueExists = false;
      if(gridChildQ.subQuestions.length > 0){
        gridChildQ.subQuestions.forEach((row) => {
          if(row.responseText != null && row.responseText.length > 0) {
            valueExists = true;
          }

          if(row.subQuestions && row.subQuestions.length > 0) {
            row.subQuestions.forEach((subRow) => {
              if(subRow.responseText != null && subRow.responseText.length > 0) {
                valueExists = true;
              }
            });
          }
        });
      }    
      return valueExists;
    } catch (error) {
      console.error('[IncidentComponent] CheckIfGridHasData - Error:', error);
      return false;
    }
  }
  clearDependingQuestions(currQues: any) {
    try {
      this.clearChildQuestions(currQues, this.selectedSection);
      this.clearChildSections(currQues.sectionGuid, currQues);
    } catch (error) {
      console.error('[IncidentComponent] clearDependingQuestions - Error:', error);
    }
  }
  clearChildQuestions(currQues: QuestionViewModel, section: any) {
    try {
      // if (!currQues) {
      //   return; // No parent question GUID provided to stop recursion
      // }
      const parentResp = (currQues.responseText || "").split("||");
      const childQuestions = section && section.questions ? section.questions.filter(q => q.parentQuestionGuid === currQues.questionGuid) : [];
      // Clear each child question and its dependencies
      childQuestions.forEach(childQ => {   
        let childQResp = childQ.parentQuesResponse.includes("||") ? childQ.parentQuesResponse.split("||") : [childQ.parentQuesResponse];
        
        if(childQResp.length > 0 && !childQResp.some(v => parentResp.indexOf(v) !== -1)) {
          this.clearQuestionResponses(childQ);  // Clear those child questions whose parent responses contains current parent ques response
        }      
        this.clearChildQuestions(childQ, section);  // find and Clear child questions recursively
      });
    } catch (error) {
      console.error('[IncidentComponent] clearChildQuestions - Error:', error);
    }
  }  
  clearChildSections(sectionGuid: string, currQues: QuestionViewModel) {
    try {
      if (!sectionGuid || !currQues) {
        console.warn('[IncidentComponent] clearChildSections - sectionGuid or currQues is null/undefined');
        return; // No parent section GUID or question provided
      }

      // Find all questions that are direct or indirect children of the current question
      const allChildQuestions: QuestionViewModel[] = [];
      const findChildQuestionsRecursive = (parentQuestion: QuestionViewModel) => {
        const directChildren = this.surveyViewModel && this.surveyViewModel.sections ?
          this.surveyViewModel.sections
          .flatMap(s => s.questions || [])
          .filter(q => q.parentQuestionGuid === parentQuestion.questionGuid) : [];

        directChildren.forEach(child => {
          if (!allChildQuestions.some(cq => cq.questionId === child.questionId)) {
            allChildQuestions.push(child);
            findChildQuestionsRecursive(child);
          }
        });
      };

      findChildQuestionsRecursive(currQues);

      // Now, find all sections that are dependent on any of these child questions
      const allDependentQuestions = [currQues, ...allChildQuestions];
      const allDependentQuestionGuids = allDependentQuestions && allDependentQuestions.length > 0 ? allDependentQuestions.map(q => q.questionGuid) : [];

      if (this.surveyViewModel && this.surveyViewModel.sections) {
        this.surveyViewModel.sections.forEach(sectionToClear => {
        if (sectionToClear.parentQuestionGuid && allDependentQuestionGuids.includes(sectionToClear.parentQuestionGuid)) {
          const parentQuestion = allDependentQuestions.find(q => q.questionGuid === sectionToClear.parentQuestionGuid);
          if (parentQuestion) {
            const parentResp = (parentQuestion.responseText || "").split("||");
            const sectionConditionResp = (sectionToClear.parentQuesResponse || "").split("||");

            // If the condition to show the section is no longer met, clear its responses.
            if (!sectionConditionResp.some(v => parentResp.includes(v))) {
              this.clearSectionResponses(sectionToClear);
            }
          }
        }
      });
      }
    } catch (error) {
      console.error('[IncidentComponent] clearChildSections - Error:', error);
    }
  }




  
  private setEditableStepForCurrentUser() {
    try {
      if (!this.WorkflowAssignment || !this.bpWFdetails || !this.bpWFdetails.workflowSteps) {
        console.warn('[IncidentComponent] setEditableStepForCurrentUser - WorkflowAssignment, bpWFdetails, or workflowSteps is null/undefined');
        return;
      }

      // Get all step IDs assigned to the current user
      const assignedStepIds = this.WorkflowAssignment
        .filter(a => a.isAssigned)
        .map(a => a.workflowStepId);

      this.bpWFdetails.workflowSteps.forEach(step => {
        if (assignedStepIds.includes(step.workflowStepId)) {
          // Enable editing for assigned steps
          step.sectionsList.forEach(section => section.workflowStepSectionAccessLevel = "RW");
        } else {
          // Set to read-only for others
          step.sectionsList.forEach(section => section.workflowStepSectionAccessLevel = "RE");
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] setEditableStepForCurrentUser - Error:', error);
    }
  }


  setSafeHtmlForQuestions() {
    try {
      this.surveyViewModel.sections.forEach(section => {
        if (section.questions && section.questions.length > 0) {
          section.questions.forEach(question => {
            if (question.questionRichEditorText && question.questionRichEditorText.trim()) {
              question.safeHtmlContent = this.getSafeHtml(question);
            } else {
              question.questionRichEditorText = question.questionText;
              question.safeHtmlContent = this.getSafeHtml(question);
            }
          });
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] setSafeHtmlForQuestions - Error:', error);
    }
  }

  getSafeHtml(currentQuestion:any): SafeHtml {      
    try {
      // Configure DOMPurify to allow target="_blank" on <a> tags      
      // This approach is standard for Angular apps to prevent XSS while allowing safe HTML
      let purifiedHtml = DOMPurify.sanitize(currentQuestion.questionRichEditorText, {
        ADD_ATTR: ['target']
      });
      // Add rel="noopener noreferrer" to all <a target="_blank">
      purifiedHtml = purifiedHtml.replace(
        /<a([^>]*target="_blank"[^>]*)>/gi,
        (match) => {
          // If rel already exists, append noopener noreferrer
          if (/rel\s*=/.test(match)) {
            return match.replace(
              /rel\s*=\s*(['"])(.*?)\1/,
              (relMatch, quote, relValue) =>
                `rel=${quote}${relValue} noopener noreferrer${quote}`
            );
          }
          // Otherwise, add rel attribute
          return match.replace(
            />/,
            ' rel="noopener noreferrer">'
          );
        }
      );
      let finalHtml = purifiedHtml;
      if (currentQuestion.isQuestionRequired === 'Y'
         || currentQuestion.isQuestionRequired === 'C' || this.isMandatoryGrid(currentQuestion) ) {
      // Parse the HTML string into a DOM
      const parser = new DOMParser();
      const doc = parser.parseFromString(finalHtml, 'text/html');
      const body = doc.body;
      const star = doc.createElement('span');
      star.className = 'required-star';
      star.style.color = 'red';
      star.textContent = '*';
      // Append the star to the last element
        if (body.firstElementChild) {
          body.firstElementChild.insertBefore(star, body.firstElementChild.firstChild);
        } else {
          body.appendChild(star); // Fallback if no children exist
        }
      finalHtml = body.innerHTML;
      }
      return this.sanitizer.bypassSecurityTrustHtml(finalHtml);
    } catch (error) {
      console.error('[IncidentComponent] getSafeHtml - Error:', error);
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
  }

  isMandatoryGrid(currentQuestion:QuestionViewModel):Boolean{
    try {
      let isMandatory: Boolean = false
      if (currentQuestion.dataType === 'fixed-grid' && currentQuestion.subQuestions && currentQuestion.subQuestions.length > 0) {
        currentQuestion.subQuestions.forEach(sub => {
          if (sub.subQuestions && sub.subQuestions.length > 0) {
            sub.subQuestions.forEach(subsub => {
              if (subsub.isQuestionRequired == 'Y') {
                isMandatory = true;
              }
            });
          }
        });
      }
      else if (currentQuestion.dataType === 'dynamic-grid' && currentQuestion.subQuestions && currentQuestion.subQuestions.length > 0) {
        currentQuestion.subQuestions.forEach(sub => {
            if (sub.isQuestionRequired == 'Y') {
              isMandatory = true;
            }
        });
      }
      return isMandatory;
    } catch (error) {
      console.error('[IncidentComponent] isMandatoryGrid - Error:', error);
      return false;
    }
  }
  // ngAfterContentChecked(): void {
  //   this.changeDetector.detectChanges();
  //   if(!this.isScrolled){
  //     this.moveScrollToFirstError();
  //     this.isScrolled = true;
  //   }
  // }
  resetTempVariables() {
    try {
      this.globalSession.setBussinessProcessId("");
      this.globalSession.setSurveyInstanceId("");
      this.cardservice.getSurveyDetails(new CreateSurvey());
      this.cardservice.getUserResponseSurvey(new SurveyUserResponse());
      this.cardservice.getUserRespIsReadonly(false);
      this.cardservice.getDisplayInfoBarDetails([]);
      this.cardservice.tempHoldWFAssignmentDetail([]);
      this.globalSession.setNavigatedStep(new WFStatusResult());
      this.cardservice.getProcessdetails(new CreateBusinessProcessModel());
    } catch (error) {
      console.error('[IncidentComponent] resetTempVariables - Error:', error);
    }
  }
  checkIfBusinessprocessExists() {
    try {
      if (this.surveyDetails.businessProcessID != null && this.surveyDetails.businessProcessID.length > 0) {
        this.isBusinessprocessExists = true;
      }
      else {
        this.isBusinessprocessExists = false;
      }
    } catch (error) {
      console.error('[IncidentComponent] checkIfBusinessprocessExists - Error:', error);
    }
  }
  CheckSurveyStatus() {
    try {
      if (this.surveyDetails.surveyId == null || this.surveyDetails.surveyId == "" || this.surveyDetails.status == "D") {
        this.notificationService.showError("Survey not published or found", "Error");
        this.router.navigate(["/businessProcess"]);
        return;
      }
      else {
        this.surveyId = this.surveyDetails.surveyId;
      }
    } catch (error) {
      console.error('[IncidentComponent] CheckSurveyStatus - Error:', error);
    }
  }
  checkIfWorkFlowExists() {
    try {
    if (this.bpWFdetails && this.bpWFdetails.workflowId > 0) {
      this.IsWorkflow = true;
      const bpDetCopy = JSON.parse(JSON.stringify(this.bpWFdetails));
      //filter duplicate sections in next steps
      if (this.bpWFdetails && this.bpWFdetails.workflowSteps && this.bpWFdetails.workflowSteps.length > 0) {
        this.bpWFdetails.workflowSteps.forEach((x, i) => {
        if (i > 0) {
          let removalbleIds: any = [];
          x.sectionsList.forEach(a => {
            this.bpWFdetails.workflowSteps.forEach(c => {
              c.sectionsList.forEach(d => {
                if (c.workflowStepId != x.workflowStepId && c.sequenceNumber < x.sequenceNumber && d.sectionId == a.sectionId) {
                  removalbleIds.push(a.sectionId);
                }
              })
            })
          })
          x.sectionsList = x.sectionsList.filter(z => !removalbleIds.includes(z.sectionId));
        }
      });
      }
      this.wfSteps = [];

      if (this.WorkflowAssignment != null && this.WorkflowAssignment.length > 0) {
        this.stepNavigated = this.globalSession.getNavigatedStep();

        if (this.stepNavigated != null && this.stepNavigated.workflowStepId > 0) {
          this.bpWFdetails.workflowSteps = this.bpWFdetails.workflowSteps.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
          let ind = this.bpWFdetails.workflowSteps.findIndex(x => x.workflowStepId == this.stepNavigated.workflowStepId);
          this.bpWFdetails.workflowSteps.forEach((ele, i) => {
            if (i <= ind) {
              this.wfSteps.push(ele);
            }
          })
          if (this.stepNavigated.stepStatus == "CP") {
            this.wfSteps.forEach(x => x.sectionsList.forEach(y => y.workflowStepSectionAccessLevel = 'RE'));
          }
          else {
            this.pendingStepId = this.stepNavigated.workflowStepId;
          }

          //set comments flag         
          if (this.stepNavigated.stepStatus != "CP" && this.stepNavigated.wfStatus != "CP" && this.stepNavigated.sequenceNumber > 1) {
            this.isCommentsEditable = true;
          }
          if (this.stepNavigated.stepStatus != "CP") {
            let filteredSteps = bpDetCopy.workflowSteps ? bpDetCopy.workflowSteps.filter(x => x.workflowStepId == this.stepNavigated.workflowStepId) : [];
            if (filteredSteps && filteredSteps.length > 0 && filteredSteps[0]) {
              let lststep: WorkflowSteps = filteredSteps[0];
              let lststepsec: QuestionAnswer[] = filteredSteps[0].sectionsList;

            if (lststepsec && lststepsec.length > 0) {
              lststepsec.forEach(p => {
              this.wfSteps.forEach(q => {
                q.sectionsList.forEach(s => {
                  if (s.sectionId == p.sectionId && q.sequenceNumber < lststep.sequenceNumber) {
                    s.workflowStepSectionAccessLevel = p.workflowStepSectionAccessLevel;
                  }
                })
              })
            })
            }
            }
          }
        }
        else {
          this.WorkflowAssignment.forEach(x => {
            this.bpWFdetails.workflowSteps.forEach(y => {
              if (x.workflowStepId == y.workflowStepId) {
                if (x.stepStatus == "CP") {
                  y.stepStatus = "CP";
                  y.sectionsList.forEach(x => x.workflowStepSectionAccessLevel = "RE");
                }
                else {
                  y.stepStatus = "PE";
                  this.pendingStepId = y.workflowStepId;
                  if (!x.isAssigned) {
                    y.sectionsList.forEach(x => x.workflowStepSectionAccessLevel = "RE");
                  }
                }
                this.wfSteps.push(y);
              }
            })
          })
          //set comments flag
          let sortedsteps = this.WorkflowAssignment.sort((a, b) => b.sequenceNumber - a.sequenceNumber);
          if (sortedsteps && sortedsteps.length > 0 && sortedsteps[0]) {
            let currStep = sortedsteps[0];//get last step details
          if (currStep.stepStatus != "CP" && currStep.wfStatus != "CP" && currStep.sequenceNumber > 1) {
            this.isCommentsEditable = true;
          }
          if (currStep.stepStatus != "CP") {
            // this.wfSteps.forEach(x => x.sectionsList.forEach(y => y.workflowStepSectionAccessLevel = 'RW'));

            let filteredCurrSteps = bpDetCopy.workflowSteps ? bpDetCopy.workflowSteps.filter(x => x.workflowStepId == currStep.workflowStepId) : [];
            if (filteredCurrSteps && filteredCurrSteps.length > 0 && filteredCurrSteps[0]) {
              let lststep: WorkflowSteps = filteredCurrSteps[0];
              let lststepsec: QuestionAnswer[] = filteredCurrSteps[0].sectionsList;

            // lststepsec.forEach(p => {
            //   this.wfSteps.forEach(q => {
            //     q.sectionsList.forEach(s => {
            //       if (s.sectionId == p.sectionId && q.sequenceNumber < lststep.sequenceNumber) {
            //         s.workflowStepSectionAccessLevel = p.workflowStepSectionAccessLevel;
            //       }
            //     })
            //   })
            // })
            }
          }
          }


        }

        
      }

    }
    //if(this.currStp)
    } catch (error) {
      console.error('[IncidentComponent] checkIfWorkFlowExists - Error:', error);
    }
  } 
  questionMapping(question, subQuestion, IsBindUserResponse, bindResult, sections) {
    try {
    subQuestion.forEach((childobj, index) => {
      let questions = new QuestionViewModel
      questions.questionId = childobj["questionId"];
      questions.displayMode = childobj["displayMode"];
      questions.sequenceNumber = childobj["sequenceNumber"];
      questions.dataType = childobj["dataType"];
      questions.inputType = childobj["inputType"];
      questions.refTableName = childobj["refTableName"];
      questions.questionText = childobj["questionText"];
      questions.questionRichEditorText = childobj["questionRichEditorText"];
      questions.questionTextShort = childobj["questionTextShort"];
      questions.isQuestionRequired = childobj["isQuestionRequired"];
      questions.questionToolTip = childobj["questionToolTip"];
      questions.parentQuestionGuid = childobj["parentQuestionGuid"];
      questions.parentQuestionId = childobj["parentQuestionId"];
      questions.parentQuesResponse = childobj["parentQuesResponse"];
      questions.defaultResponse = childobj["defaultResponse"];
      questions.maxLength = childobj["maxLength"];
      questions.sectionId = childobj["sectionId"];
      questions.options = childobj["options"];
      questions.questionImage = childobj["questionImage"];
      questions.questionImageName = childobj["questionImageName"];
      questions.responseText = childobj["responseText"];
      questions["initialText"] = childobj["initialText"];
      questions["finalText"] = childobj["finalText"];
      questions.validations = childobj["validations"];
      questions.validationDetails = childobj["validationDetails"];
      questions.futureDateEnabled = childobj["futureDateEnabled"];
      questions.pastDateEnabled = childobj["pastDateEnabled"];
      questions.todayDateEnabled = childobj["todayDateEnabled"];
      questions.questionGuid = childobj["questionGuid"];

      if (IsBindUserResponse && bindResult && bindResult.length > 0) {
        let resultQques = bindResult.find(x => x.questionId == questions.questionId);
        if (resultQques) {
          questions.responseText = resultQques.responseText;
          questions.comments = resultQques.comments;
          questions.surveyResponseRelId = resultQques.surveyResponseRelId;
          let quesComments = new QuestionResponsesdata();
          quesComments.comments = resultQques.comments;
          quesComments.questionId = resultQques.questionId;
          this.questionCommentBackUp.push(quesComments);
        }
      }

      if (questions.isQuestionRequired == "N") {
        questions["IsValid"] = true
      }
      else if (questions.isQuestionRequired == "Y" && questions.responseText && questions.responseText.trim().length > 0) {
        questions["IsValid"] = true;
      }
      else {
        questions["IsValid"] = false
      }


      if (questions.parentQuesResponse == undefined || questions.parentQuesResponse === "") {
        this.conditionQues.push({ questionId: questions.questionId, que: questions.questionTextShort, value: questions.parentQuesResponse, isSelected: true, parentQuestionGuid: childobj["parentQuestionGuid"] });
        questions["isParentQuestionVisible"] = true;


      }
      else {
        this.conditionQues.push({ questionId: questions.questionId, que: questions.questionTextShort, value: questions.parentQuesResponse, isSelected: false, parentQuestionGuid: childobj["parentQuestionGuid"] });
        //set if question should be visible if its display-mode is Show/Hide(SH)

        questions.isParentQuestionVisible = true;
        if (questions.displayMode == "SH") {
          questions["isParentQuestionVisible"] = false;
        }


        if (questions.isQuestionRequired == "Y") {
          questions["isQuestionRequired"] = "C";
        }
        //handling grids
        if(questions.inputType == "table" && questions.dataType == "fixed-grid") {
          questions.subQuestions = [];
          if(questions.subQuestions && questions.subQuestions.length > 0) {
            questions.subQuestions.forEach(q => {
              q.isParentQuestionVisible = true;
              if(q.isQuestionRequired == "Y") {
                q.isQuestionRequired = "C";
                  q["IsValid"] = true;
              }
            });
          }
        }

        if(questions.inputType == "table" && questions.dataType == "dynamic-grid") {
          questions.responses = [];
          if(questions.responses && questions.responses.length > 0) {
            questions.responses.forEach(r => {
              r.questions.forEach(q => {
                q.isParentQuestionVisible = true;
                if(q.isQuestionRequired == "Y") {
                  q.isQuestionRequired = "C";
                  q["IsValid"] = true;
                }
              });
            });
          }
        }



        questions["IsValid"] = true;
      }

      if (IsBindUserResponse && bindResult && questions["isParentQuestionVisible"] == false
        || (IsBindUserResponse && bindResult && questions.displayMode == "ED" && questions.isParentQuestionVisible == undefined)) {
        // finding the parent question of the current question
        let parentQue = bindResult.find(x => x.questionGuid == questions["parentQuestionGuid"]);
        if (parentQue && parentQue.responseText) {
          //checking for parent's response if it matches the conditional question's required response to set its display mode
          let parentResp = parentQue.responseText ? parentQue.responseText.split("||") : [];
          let parQuesRespText = questions.parentQuesResponse ? questions.parentQuesResponse.split("||") : [];
          //if(parentResp.indexOf(questions.parentQuesResponse)!=-1)
          if(parentResp.some(v => parQuesRespText.indexOf(v) !== -1))
          //if(parentResp.includes(parQuesRespText))
          {
            //Enable Question and set its visibility property(isParentQuestionVisible) to true
            questions.enableQuestion = true;
            questions["isParentQuestionVisible"] = true;
            if (questions.isQuestionRequired == "C") {
              questions["isQuestionRequired"] = "Y";
              
            }
            if (questions.isQuestionRequired == "N") {
              questions["IsValid"] = true
            }
            else if (questions.isQuestionRequired == "Y" && questions.responseText && questions.responseText.trim().length > 0) {
              questions["IsValid"] = true;
            }
            else {
              questions["IsValid"] = false
            }

            //handling grids
            if(questions.inputType == "table" && questions.dataType == "fixed-grid") {
              questions.subQuestions = [];
              if(questions.subQuestions && questions.subQuestions.length > 0) {
                questions.subQuestions.forEach(q => {
                  q.isParentQuestionVisible = true;
                  if(q.isQuestionRequired == "Y") {
                    q.isQuestionRequired = "C";
                    questions["IsValid"] = false;
                  }
                });
              }
            }
            if(questions.inputType == "table" && questions.dataType == "dynamic-grid") {
              questions.responses = [];
              if(questions.responses && questions.responses.length > 0) {
                questions.responses.forEach(r => {
                  r.questions.forEach(q => {
                    q.isParentQuestionVisible = true;
                    if(q.isQuestionRequired == "Y") {
                      q.isQuestionRequired = "C";
                      questions["IsValid"] = false;
                    }
                  });
                });
              }
            }

          }
          else {

            questions["isParentQuestionVisible"] = false;
            questions["IsValid"] = true;
            if (questions.displayMode == "ED") {
              questions.enableQuestion = false;
              questions["isParentQuestionVisible"] = false;
            }
          }
        }
      }
      if (questions.isParentQuestionVisible == true) {
        questions.questionIndex = this.lastQuestionIndex;
        this.lastQuestionIndex++;
      }

      if (childobj.subQuestions && childobj.subQuestions.length > 0) {
        this.questionMapping(questions, childobj.subQuestions, IsBindUserResponse, bindResult, sections);
      }
      if (question.subQuestions) {
        question.subQuestions.push(questions);
      }
      if (!sections.IsReadOnly && sections.IsAccessiibleInWFStep) {
        this.questionList.push(questions.questionId);
      }
    });
    } catch (error) {
      console.error('[IncidentComponent] questionMapping - Error:', error);
    }
  }
  /** No more used Toggle questions and section using below new recursive methods --starts */
  // ToggleQuestions(ele, parobj) {
  //   //this.isSaveAndClose = false;
  //   //get the current question details and the details of the current question's parent
  //   let currentQues = parobj.questions.find(x => x.questionId == ele.questionId);
  //   if (currentQues) {
  //     let currentQuesParent = parobj.questions.find(x => x.questionGuid == currentQues.parentQuestionGuid);
  //     if (currentQuesParent) {
  //       if (currentQuesParent.isParentQuestionVisible == true) {
  //         if (currentQuesParent) {
  //           let resp = currentQuesParent.responseText;
  //           if (!resp) {
  //             resp = "";
  //           }
  //           let parentResp = resp.split("||");
  //           let parQuesRespText = (currentQues.parentQuesResponse != null && currentQues.parentQuesResponse.length > 0) ? currentQues.parentQuesResponse.split("||") : currentQues.parentQuesResponse;
  //           if (resp.length > 0 && parQuesRespText != null && parQuesRespText.length > 0 && parentResp.some(v => parQuesRespText.indexOf(v) !== -1)) {

  //             currentQues.enableQuestion = true;
  //             currentQues["isParentQuestionVisible"] = true;

  //             if (currentQues.isQuestionRequired == "C") {
  //               currentQues["isQuestionRequired"] = "Y";
  //               currentQues.IsValid = false;
  //             }
  //             if(currentQues.inputType == "table" && currentQues.dataType == "fixed-grid") {
  //               currentQues.subQuestions.forEach(q => {
  //                 q.subQuestions.forEach(ele => {
  //                   if(ele.isQuestionRequired == "C") {
  //                     ele.isQuestionRequired = "Y";
  //                   }
  //                 });
  //               })
  //             }
  //             if(currentQues.inputType == "table" && currentQues.dataType == "dynamic-grid") {
  //               (currentQues.responses || []).forEach(r => {
  //                 r.questions.forEach(ele => {
  //                   if(ele.isQuestionRequired == "C") {
  //                     ele.isQuestionRequired = "Y";
  //                   }
  //                 });
  //               })
  //             }

  //             if (currentQues.inputType == "displaytext") {
  //               currentQues["isQuestionRequired"] = "N";
  //               currentQues.IsValid = false;
  //             }

  //             if (! currentQuesParent.enableQuestion && currentQuesParent.displayMode == "ED") {
  //               currentQues.enableQuestion = false;
  //               currentQues.responseText = "";
  //               if (this.clearResponsesSelected) {

  //                 if (currentQues.inputType == 'rating') {
  //                   currentQues.rating = null;
  //                 }
  //                 if (currentQues.inputType == "mul" || currentQues.inputType == "chk") {
  //                   currentQues.responseText = null;
  //                   currentQues.options.forEach(ele => {
  //                     if (ele.value == currentQues.responseText) {
  //                       ele.selected = false;
  //                     }
  //                   });
  //                 }
  //               }
  //               if (currentQues.displayMode == "SH") {
  //                 currentQues.isParentQuestionVisible = false;
  //               }
  //             }
  //           }
  //           else {
  //             currentQues.isParentQuestionVisible = false;
  //             if (this.clearResponsesSelected == true) {
  //               if (currentQues.inputType == 'rating') {
  //                 currentQues.rating = null;
  //               }
  //               if (currentQues.inputType == "mul" || currentQues.inputType == "chk") {
  //                 currentQues.options.forEach(ele => {
  //                   if (ele.value == currentQues.responseText) {
  //                     ele.selected = false;
  //                   }
  //                 });
  //               }
  //                //handling fixed grid
  //           if (currentQues.inputType == "table" && currentQues.dataType == "fixed-grid") {
  //             currentQues.subQuestions.forEach(q => {
  //               q.responseText = null;
  //               q.subQuestions.forEach(ele => {
  //                 ele.responseText = null;
  //                 if(ele.isQuestionRequired == "Y") {
  //                 ele.isQuestionRequired = "C";
  //                 ele.errorMessage = null;
  //                 }
  //               });
  //             });
  //           }
  //           if(currentQues.inputType == "table" && currentQues.dataType == "dynamic-grid") {
  //               (currentQues.responses || []).forEach(r => {
  //                 r.questions.forEach(ele => {
  //                   if(ele.isQuestionRequired == "Y") {
  //                     ele.isQuestionRequired = "C";
  //                   }
  //                 });
  //               })
  //             }

  //               currentQues.responseText = null;
  //             }
  //             if (currentQues.displayMode == "ED") {
  //               currentQues.enableQuestion = false;
  //               currentQues.isParentQuestionVisible = true;
  //             }
  //             if (currentQues.isQuestionRequired == "Y") {
  //               currentQues["isQuestionRequired"] = "C";
  //               currentQues["IsValid"] = true;
  //             }
  //           }
  //         }
  //       }
  //       else {
  //         currentQues.isParentQuestionVisible = false;
  //         if (this.clearResponsesSelected == true) {

  //           currentQues.responseText = null;
  //           if (currentQues.inputType == 'rating') {
  //             currentQues.rating = null;
  //           }
  //           if (currentQues.inputType == "mul" || currentQues.inputType == "chk") {
  //             currentQues.options.forEach(ele => {
  //               if (ele.value == currentQues.responseText) {
  //                 ele.selected = false;
  //               }
  //             });

  //           }
  //           currentQues.responseText = null;
  //         }


  //         if (currentQues.isQuestionRequired == "Y") {
  //           currentQues["isQuestionRequired"] = "C";
  //           currentQues["IsValid"] = true;
  //         }
  //       }

      
  //       //find conditional options if any for current question
  //       if(currentQues.options != null && currentQues.options.length > 0) {
  //         //need clarification on this condition 
  //         let mapsFound = currentQues.options.findIndex(f=> f.optionMappings != null && f.optionMappings.length > 0)
  //         if(mapsFound != -1){
  //           currentQues.options.forEach(qOpt => {
  //             if(qOpt.optionMappings != null && qOpt.optionMappings.length > 0){
  //               let mappedParentGuidList = qOpt.optionMappings.map(m=> m.parentOptionGuid);
  //               let selectedParentQuesOptions = currentQuesParent.options.filter(x=> x.selected == true);
  //               let selectedParentQuesOptionGuids = selectedParentQuesOptions.map(m=> m.optionGuid);
  //               if(mappedParentGuidList.some(id => selectedParentQuesOptionGuids.includes(id))){
  //                 qOpt["isQuesOptionVisible"] = true;
  //               }
  //               else{
  //                 qOpt["isQuesOptionVisible"] = false;
  //               }
  //             }
  //             else{
  //               qOpt["isQuesOptionVisible"] = false;
  //             }           
  //           });
  //         }
  //         else{
  //           currentQues.options.forEach(qOpt => {
  //             qOpt["isQuesOptionVisible"] = true;
  //           });
  //         }
         
  //       }
  //     }
  //     else{
  //       if(currentQues.options != null && currentQues.options.length > 0) {
  //         currentQues.options.forEach(qOpt => {
  //           qOpt["isQuesOptionVisible"] = true;
  //         });
  //       }
  //     }
  //     //find the current question's child and if it exists, recursively call the method with child question
  //     // let currentQuesChild = parobj.questions.filter(x => x.parentQuestionGuid == currentQues.questionGuid);
  //     // if (currentQuesChild.length > 0) {
  //     //   currentQuesChild.forEach((childObj, childindex) => {
  //     //     this.ToggleQuestions(childObj, parobj);
  //     //   }
  //     //   );
  //     // }
  //     // this.ToggleSections();
  //   }

  // }
  // ToggleSections() {
  //   this.surveyViewModel.sections.forEach((parobj, parindex) => {      
      
  //     if (parobj.ParentSectionGuid) {
  //       let sec = this.surveyViewModel.sections.find(x => x.SectionGuid == parobj.ParentSectionGuid);
  //       let parQues = sec.questions.find(x => x.questionGuid == parobj.parentQuestionGuid);
   
  //       //this.ToggleQuestions(parQues, sec);
  //       if (sec["isSecParentQuestionVisible"] == true && parQues != undefined && parQues.responseText 
  //       && (parQues.responseText.split('||').some(v => parobj.parentQuesResponse.split("||").indexOf(v) != -1) || 
  //       (parobj.parentQuesResponse.split('||').some(v => v.trim() == parQues.responseText)))
  //       /*parQues.responseText.split('||').indexOf(parobj.parentQuesResponse)!=-1 */) {
  //         parobj["isSecParentQuestionVisible"] = true;
  //         this.wfSteps.forEach(step => {
  //           step.sectionsList.forEach(sec=>{
  //             //if(sec.parentSectionGuid == parobj.ParentSectionGuid){
  //             if(sec.sectionGuid == parobj.SectionGuid) {
  //               sec["isSecParentQuestionVisible"] = true;
  //             }             
  //           });         
  //         });
  //       }
  //       else {
  //         parobj["isSecParentQuestionVisible"] = false;
  //         //this.clearSectionResponses(parobj); //CLEAR RESPONSES ONLY AFTER CONFIRMATION POP UP
  //         this.wfSteps.forEach(step => {
  //           step.sectionsList.forEach(sec=>{
  //             //if(sec.parentSectionGuid == parobj.ParentSectionGuid){
  //             if(sec.sectionGuid == parobj.SectionGuid) {
  //               sec["isSecParentQuestionVisible"] = false;
  //             }             
  //           });         
  //         });
  //         // parobj.questions.forEach((item) => {
  //         //   item.responseText = null;
  //         // });
  //         //this.percentage = this.selectedIndex / this.totalSections * 100;
  //       }
  //     }

  //     this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;// this.totalSections -1;


  //   })


  //   // //check for SubmitClose button visibility
  //   // if(this.isLastStep() && this.isLastSection()) {
  //   //   this.isSaveAndClose = true;
  //   // }
  // }
  /** No more used Toggle questions and section using below new recursive methods --ends */

  ToggleConditionalQuestions(parentQuestion: QuestionViewModel, section: SectionViewModel) {
    try {
    const childQuestions = section.questions.filter(q => q.parentQuestionGuid === parentQuestion.questionGuid);  
    childQuestions.forEach(childQues => {
      const parentResp = (parentQuestion.responseText || "").split("||");
      const childReqResp = (childQues.parentQuesResponse || "").split("||");
      const isVisible = parentResp.some(v => childReqResp.includes(v));
  
  
      if (isVisible) {
        childQues.isParentQuestionVisible = true;
        childQues.enableQuestion = true;


        /** Need to re-check why this code is used for  isQuestionRequired === "C" condition*/
        if (childQues.isQuestionRequired === "C") {
          childQues.isQuestionRequired = "Y";
          childQues["IsValid"] = false;
        }
        // Handle grids becoming visible
        if (childQues.inputType === "table" && childQues.dataType === "fixed-grid") {
          childQues.subQuestions.forEach(q => q.subQuestions.forEach(ele => {
            if (ele.isQuestionRequired === "C") ele.isQuestionRequired = "Y";
          }));
        }
        if (childQues.inputType === "table" && childQues.dataType === "dynamic-grid") {
          (childQues.responses || []).forEach(r => r.questions.forEach(ele => {
            if (ele.isQuestionRequired === "C") ele.isQuestionRequired = "Y";
          }));
        }
      } else {
        childQues.isParentQuestionVisible = false;
        childQues.enableQuestion = childQues.displayMode !== "SH";
        if (childQues.isQuestionRequired === "Y") {
          childQues.isQuestionRequired = "C";
          childQues["IsValid"] = true;
        }
      }
  
      // Toggle conditional options for the child question
      this.ToggleConditionalOptions(parentQuestion, childQues);
  
      // If visibility changed or the question is now visible, recurse to its children
      // if (wasVisible !== childQues.isParentQuestionVisible || childQues.isParentQuestionVisible) {
      //   this.ToggleConditionalQuestions(childQues, section);
      // }
      this.ToggleConditionalQuestions(childQues, section);
    });
    } catch (error) {
      console.error('[IncidentComponent] ToggleConditionalQuestions - Error:', error);
    }
  }
  ToggleConditionalOptions(parentQuestion: QuestionViewModel, childQues: QuestionViewModel) {
    try {
    if (childQues.options && childQues.options.length > 0) {
      const hasMappings = childQues.options.some(o => o.optionMappings && o.optionMappings.length > 0);
      if (hasMappings) {
        const selectedParentOptionGuids = parentQuestion.options?.filter(o => o["selected"]).map(o => o.optionGuid) || [];
        childQues.options.forEach(qOpt => {
          if (qOpt.optionMappings && qOpt.optionMappings.length > 0) {
            const mappedParentGuids = qOpt.optionMappings.map(m => m.parentOptionGuid);
            qOpt["isQuesOptionVisible"] = mappedParentGuids.some(id => selectedParentOptionGuids.includes(id));
          } else {
            qOpt["isQuesOptionVisible"] = false; // Or true, depending on default behavior
          }
        });
      } else {
        childQues.options.forEach(qOpt => qOpt["isQuesOptionVisible"] = true);
      }
    }
    } catch (error) {
      console.error('[IncidentComponent] ToggleConditionalOptions - Error:', error);
    }
  }
  ToggleConditionalSections(section: SectionViewModel) {
    try {
    const childSections = this.surveyViewModel.sections.filter(s => s.ParentSectionGuid === section.SectionGuid);
    childSections.forEach(childSec => {
      const parentQuestion = section.questions.find(q => q.questionGuid === childSec.parentQuestionGuid);

      // Store previous visibility state
      //const wasVisible = childSec["isSecParentQuestionVisible"];
      let isVisible = false;

      if (parentQuestion && parentQuestion.responseText) {
        const parentResponses = parentQuestion.responseText ? parentQuestion.responseText.split('||') : [];
        const childRequiredResponses = childSec.parentQuesResponse ? childSec.parentQuesResponse.split('||') : [];

        // Check if any of the parent's responses match the required responses for the child section
        isVisible = parentResponses.some(pr => childRequiredResponses.includes(pr.trim()));
      }

      // Update visibility on the main survey view model
      childSec["isSecParentQuestionVisible"] = isVisible;
      childSec.questions.forEach(q => q.isParentQuestionVisible = isVisible);

      // Update visibility in workflow steps
      this.wfSteps.forEach(step => {
        const stepSection = step.sectionsList.find(s => s.sectionGuid === childSec.SectionGuid);
        if (stepSection) {
          stepSection["isSecParentQuestionVisible"] = isVisible;
        }
      });

      // If visibility changed or section is now visible, recursively check its child sections
      if (!isVisible) {
        // First toggle conditional questions within this section
        childSec.questions.forEach(question => {
          if (question.responseText) {
            this.ToggleConditionalQuestions(question, childSec);
          }
        });

        // Then recursively check child sections
        this.ToggleConditionalSections(childSec);
      }
    });

    // Recalculate total visible sections
    this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] !== false && x.IsAccessiibleInWFStep).length;
    } catch (error) {
      console.error('[IncidentComponent] ToggleConditionalSections - Error:', error);
    }
  }


  clearSectionResponses(section: any) {
    try {
    // First, make a copy of all questions to trigger change detection
    section.questions = section.questions.map(q => ({...q}));
    section.isparentSectionVisible = false; //on clearing response section should be hidden**

    // Clear all responses
    section.questions.forEach(q => {
      this.clearQuestionResponses(q);
    });

    var childSections = this.surveyViewModel.sections.filter(s => s.ParentSectionGuid === section.SectionGuid);
    childSections.forEach(childSec => {
      // Clear responses for child sections
      this.clearSectionResponses(childSec);
    });
    
    // Force change detection
    this.changeDetectorRef.detectChanges();
    
    // Notify all child components about the reset
    this.questionUpdateService.notifyQuestionsReset();
    } catch (error) {
      console.error('[IncidentComponent] clearSectionResponses - Error:', error);
    }
  }

  clearQuestionResponses(question: QuestionViewModel) {
    try {
    // Clear main question properties
    question.responseText = null;
    question.comments = null;
    question.responses = []; // for dynamic grid
    question.isParentQuestionVisible = false; //on clearing response section should be hidden**

    // Clear validation state
    if ('IsValid' in question) {
      // A question is valid if it's not required and empty,
      // or if it's conditionally required but currently hidden.
      question.IsValid = question.isQuestionRequired === 'N' || question.isQuestionRequired === 'C';
    }

    // Clear options for multiple choice questions
    if (question.options && question.options.length > 0) {
      question.options.forEach(opt => opt['selected'] = false);
    }

    // Recursively clear subquestions (for matrix, fixed-grid, etc.)
    if (question.subQuestions && question.subQuestions.length > 0) {
      question.subQuestions.forEach(subQ => {
        this.clearQuestionResponses(subQ);
        subQ.subQuestions.forEach(subSubQ => this.clearQuestionResponses(subSubQ));
      });
    }

    // Find and clear child questions that are conditionally dependent on this question
    const childQuestions = this.surveyViewModel.sections
        .flatMap(s => s.questions)
        .filter(q => q.parentQuestionGuid === question.questionGuid);

    childQuestions.forEach(childQ => {
      this.clearQuestionResponses(childQ);
    });
    } catch (error) {
      console.error('[IncidentComponent] clearQuestionResponses - Error:', error);
    }
  }

  /* Check if the currently selected step is the last step in the workflow */
  isLastStep(): boolean {

    if (!this.wfSteps || this.wfSteps.length === 0 || this.selectedStepIndex < 0) {
      return false;
    }
    return this.selectedStepIndex === this.wfSteps.length - 1;
  }

  /* Check if the currently selected section is the last section in the step */
  isLastSection() : boolean {
    try {
    let dispayedSections = this.selectedStep.sectionsList.filter(x => x["isSecParentQuestionVisible"] == true);
    //let selSecIndexinWfStep = this.selectedStep.sectionsList.findIndex(x => x.sectionGuid == this.selectedSection.SectionGuid);
    
    if (this.selectedSectionIndex  === dispayedSections.length - 1) {
      return true;
    }
    else {
      return false;
    }
    } catch (error) {
      console.error('[IncidentComponent] isLastSection - Error:', error);
      return false;
    }
  }

  async bindSurveyViewModel(surveyDetails, bindResult,isViewMode, IsBindUserResponse) {
    try {
    this.isSectionReadOnly = false;
    if (surveyDetails != null) {


      this.surveyViewModel = new SurveyViewModel();

      (this.bpWFdetails && this.bpWFdetails.workflowId > 0) ? this.surveyViewModel.isWorkflow = true : this.surveyViewModel.isWorkflow = false;

      this.surveyViewModel.isEsignReq = surveyDetails["isESignReq"];

      this.surveyViewModel.surveyId = surveyDetails["surveyId"];

      this.surveyViewModel.name = surveyDetails["name"];

      this.surveyViewModel.status = surveyDetails["status"];

      this.surveyViewModel.description = surveyDetails["description"];

      this.surveyViewModel.resultsCount = surveyDetails["resultsCount"];

      this.surveyViewModel.isFavourite = surveyDetails["isFavourite"];

      this.surveyViewModel.isLiked = surveyDetails["isLiked"];

      this.surveyViewModel.categoryName = surveyDetails["categoryName"];

      this.surveyViewModel.surveyType = surveyDetails["surveyType"];

      this.surveyViewModel.logoFormat = surveyDetails["logoFormat"];

      this.surveyViewModel.logoImage = surveyDetails["logoImage"];

      this.surveyViewModel.redirectionUrl = surveyDetails["redirectionUrl"];


      if (surveyDetails["SurveyResponseId"] && surveyDetails["SurveyResponseId"] != '') {

        this.surveyResponseId = surveyDetails["SurveyResponseId"];

      }

      else {

        if (this.userResponse != null) {
          // parseInt(undefined) is NaN, which JSON.stringify silently turns into
          // null - the backend's non-nullable SurveyResponseID rejects that.
          const parsedResponseId = parseInt(this.userResponse.surveyUserResponseRel);
          this.surveyResponseId = isNaN(parsedResponseId) ? 0 : parsedResponseId;

        }

      }

      this.surveyViewModel.surveyAdmins = surveyDetails["surveyAdmins"];

      this.surveyViewModel.sections = [];


      if (this.isStandaloneSurvey == true) {
        this.surveyDetails = surveyDetails;
      }
      if (this.surveyDetails != null && this.surveyDetails.sections != null && this.surveyDetails.sections.length > 0) {

        let surveysectionlist = surveyDetails["sections"];

        surveysectionlist.forEach((obj, index) => {

          let sections = new SectionViewModel();

          sections.IsReadOnly = this.IsReadOnly;

          sections.sectionId = obj["sectionId"];

          sections.sectionName = obj["sectionName"];

          sections.sequenceNumber = obj["sequenceNumber"];

          sections.sectionDescription = obj["sectionDescription"];

          sections.sectionToolTip = obj["sectionToolTip"];

          sections.parentQuesResponse = obj["parentQuesResponse"];

          sections.parentQuestionGuid = obj["parentQuestionGuid"];

          sections.ParentSectionGuid = obj["parentSectionGuid"];

          sections.SectionGuid = obj["sectionGuid"];

          sections.sectionLookUpEntityId = obj["sectionLookUpEntityId"];

          sections.hasValidation = obj["hasValidation"];

          if (sections.parentQuesResponse === "" || sections.parentQuesResponse == null) {

            this.conditionQues.push({ questionId: null, que: sections.sectionName, value: sections.parentQuesResponse, isSelected: true, parentQuestionGuid: obj["parentQuestionGuid"] });



            sections["isSecParentQuestionVisible"] = true;

            if (sections.IsAccessiibleInWFStep) {

              this.totalSections = this.totalSections + 1;

            }

          }

          else {

            this.conditionQues.push({ questionId: null, que: sections.sectionName, value: sections.parentQuesResponse, isSelected: false, parentQuestionGuid: obj["parentQuestionGuid"] });

            sections["isSecParentQuestionVisible"] = false;



          }

          if (IsBindUserResponse && sections.parentQuesResponse != null && sections.parentQuesResponse != "") {

            let secdet = this.surveyDetails && this.surveyDetails.sections ? this.surveyDetails.sections.find(x => x.sectionId == sections.sectionId) : null;

            let ValidParentResponse = this.userResponse && this.userResponse.responses ? this.userResponse.responses.find(x => x.questionGuid == sections.parentQuestionGuid) : null;

            let parentResponseMatch = false;

            if (ValidParentResponse) {

              if (ValidParentResponse.responseText && ValidParentResponse.responseText.split("||").indexOf(sections.parentQuesResponse) != -1) {

                parentResponseMatch = true;

              }



            }

            if (secdet && parentResponseMatch) {
              sections["isSecParentQuestionVisible"] = true;//secdet.isSecParentQuestionVisible;

              if (sections["isSecParentQuestionVisible"] == true && sections.IsAccessiibleInWFStep == true) {

                this.totalSections = this.totalSections + 1;

              }

            }

          }



          if (index === 0) {

            sections["Ishidden"] = false;

          }

          else {

            sections["Ishidden"] = true;

            //Wf should have 1st accessible section visible

            if (sections.IsAccessiibleInWFStep && this.surveyViewModel.sections.filter(x => x.IsAccessiibleInWFStep && x["Ishidden"] == false).length <= 0) {

              sections["Ishidden"] = false;

            }

          }


          sections.questions = [];

          this.lastQuestionIndex = 1;

          obj.questions.forEach((childobj, index) => {

            let questions = new QuestionViewModel

            questions.questionId = childobj["questionId"];
            questions.lookUpQuestionId = childobj["lookUpQuestionId"];

            questions.displayMode = childobj["displayMode"];

            questions.sequenceNumber = childobj["sequenceNumber"];

            questions.dataType = childobj["dataType"];

            questions.inputType = childobj["inputType"];

            questions.refTableName = childobj["refTableName"];

            questions.questionText = childobj["questionText"];

            questions.questionRichEditorText = childobj["questionRichEditorText"];

            questions.questionTextShort = childobj["questionTextShort"];

            questions.isQuestionRequired = childobj["isQuestionRequired"];

            questions.questionToolTip = childobj["questionToolTip"];

            questions.parentQuestionGuid = childobj["parentQuestionGuid"];

            questions.parentQuestionId = childobj["parentQuestionId"];

            questions.parentQuesResponse = childobj["parentQuesResponse"];

            questions.defaultResponse = childobj["defaultResponse"];

            questions.maxLength = childobj["maxLength"];

            questions.sectionId = childobj["sectionId"];
            
            questions.sectionGuid = childobj["sectionGuid"];

            questions.options = childobj["options"];

            questions.questionImage = childobj["questionImage"];

            questions.questionImageName = childobj["questionImageName"];

            questions.responseText = childobj["responseText"];
            
            //setting the responseText for specific questions //IDD Specific change
            if (childobj["questionText"] == environment.PRE_POPULATED_QUESTION_RESPONSE_1) {
              questions.responseText = this.storage.get("LoggedInUserAgency");
            }
            if(childobj["questionText"] == environment.PRE_POPULATED_QUESTION_RESPONSE_2) {
              questions.responseText = this.storage.get("LoggedInUserAgencyId");
            }
            if(childobj["questionText"] == environment.PRE_POPULATED_READONLY_QUESTION_1 || childobj["questionText"] == environment.PRE_POPULATED_READONLY_QUESTION_2) {
              questions.isReadOnly = true;
            }
            questions["initialText"] = childobj["initialText"];

            questions["finalText"] = childobj["finalText"];

            questions.validations = childobj["validations"];

            questions.validationDetails = childobj["validationDetails"];

            questions.futureDateEnabled = childobj["futureDateEnabled"];

            questions.pastDateEnabled = childobj["pastDateEnabled"];

            questions.todayDateEnabled = childobj["todayDateEnabled"];

            questions.questionGuid = childobj["questionGuid"];
            questions.timeEnabled = childobj["timeEnabled"];
            questions.entityFieldId = childobj["entityFieldId"];


            
            questions.questionFileConfig = childobj["questionFileConfig"];
            questions.isConsentQuestion = childobj["isConsentQuestion"];
            questions.consentQuestionLabel = childobj["consentQuestionLabel"];

            questions.questionSignTypes = childobj["questionSignTypes"];
            questions.isESignRequired = childobj["isESignRequired"];
            questions.isSSignRequired = childobj["isSSignRequired"];
            
            if (IsBindUserResponse) {

              let resultQques = bindResult.find(x => x.questionId == questions.questionId);

              if (resultQques) {

                questions.responseText = resultQques.responseText;
                //setting the responseText for specific questions //IDD Specific change
                if (childobj["questionText"] == environment.PRE_POPULATED_QUESTION_RESPONSE_1) {
                  questions.responseText = this.storage.get("LoggedInUserAgency");
                }
                if(childobj["questionText"] == environment.PRE_POPULATED_QUESTION_RESPONSE_2) {
                  questions.responseText = this.storage.get("LoggedInUserAgencyId");
                }
                if(childobj["questionText"] == environment.PRE_POPULATED_READONLY_QUESTION_1 || childobj["questionText"] == environment.PRE_POPULATED_READONLY_QUESTION_2) {
                  questions.isReadOnly = true;
                }
                questions.comments = resultQques.comments;
                questions.surveyResponseRelId = resultQques.surveyResponseRelId;
                //questions["responseReadOnly"] = resultQques.responseReadOnly;

                let quesComments = new QuestionResponsesdata();

                quesComments.comments = resultQques.comments;

                quesComments.questionId = resultQques.questionId;

                quesComments.questionReponse = resultQques.responseText;
                quesComments.surveyResponseRelId = resultQques.surveyResponseRelId;

                this.questionCommentBackUp.push(quesComments);



              }

            }


            if(questions.isQuestionRequired == "N"){
                questions["IsValid"] = true;
            }
            else if (questions.isQuestionRequired == "Y" && questions.responseText && questions.responseText.trim().length > 0 ) {
                questions["IsValid"] = true;
            }
            else {

              questions["IsValid"] = false;

            }



            if (questions.parentQuesResponse == undefined || questions.parentQuesResponse === "") {

              this.conditionQues.push({ questionId: questions.questionId, que: questions.questionTextShort, value: questions.parentQuesResponse, isSelected: true, parentQuestionGuid: childobj["parentQuestionGuid"] });

              questions["isParentQuestionVisible"] = true;





            }

            else {

              this.conditionQues.push({ questionId: questions.questionId, que: questions.questionTextShort, value: questions.parentQuesResponse, isSelected: false, parentQuestionGuid: childobj["parentQuestionGuid"] });

              //set if question should be visible if its display-mode is Show/Hide(SH)



              questions.isParentQuestionVisible = true;

              if (questions.displayMode == "SH") {

                questions["isParentQuestionVisible"] = false;

              }





              if (questions.isQuestionRequired == "Y") {

                questions["isQuestionRequired"] = "C";



              }

              questions["IsValid"] = true;

            }



            if (IsBindUserResponse && questions["isParentQuestionVisible"] == false

              || (IsBindUserResponse && questions.displayMode == "ED" && questions.isParentQuestionVisible == undefined)) {

              // finding the parent question of the current question

              let parentQue = bindResult.find(x => x.questionGuid == questions["parentQuestionGuid"]);

              if (parentQue && parentQue.responseText) {

                //checking for parent's response if it matches the conditional question's required response to set its display mode

                let parentResp = parentQue.responseText ? parentQue.responseText.split("||") : [];

                let parQuesRespText = questions.parentQuesResponse ? questions.parentQuesResponse.split("||") : [];

                if (parentResp.some(v => parQuesRespText.indexOf(v) !== -1))

                // if(parentResp.includes(parQuesRespText))

                {

                  //Enable Question and set its visibility property(isParentQuestionVisible) to true

                  questions.enableQuestion = true;

                  questions["isParentQuestionVisible"] = true;

                  if (questions.isQuestionRequired == "C") {

                    questions["isQuestionRequired"] = "Y";

                  }
                  if(questions.isQuestionRequired == "N"){
                    questions["IsValid"] = true
                  }
                  else if(questions.isQuestionRequired == "Y" && questions.responseText && questions.responseText.trim().length > 0 ){
                          questions["IsValid"] = true;
                  }
                  else{
                    questions["IsValid"] = false
                  }



                }

                else {



                  questions["isParentQuestionVisible"] = false;

                  questions["IsValid"] = true;

                  if (questions.isQuestionRequired == "Y") {

                    questions["isQuestionRequired"] = "C";

                  }

                  if (questions.displayMode == "ED") {

                    questions.enableQuestion = false;

                    questions["isParentQuestionVisible"] = false;

                  }

                }

              }

            }

            if (questions.isParentQuestionVisible == true) {

              questions.questionIndex = this.lastQuestionIndex;

              this.lastQuestionIndex++;

            }
            questions.subQuestions = [];
            this.questionMapping(questions, childobj.subQuestions, IsBindUserResponse, bindResult, sections);
            sections.questions.push(questions);
            if (!sections.IsReadOnly && sections.IsAccessiibleInWFStep) {

              this.questionList.push(questions.questionId);
            }
          });

          sections.gridQuestions = [];
          sections.totalQuestionVisible = sections.questions.filter(x => x.isParentQuestionVisible).length;
          if (isViewMode) {
            sections.IsReadOnly = true;
          }
          this.surveyViewModel.sections.push(sections);
        });

        this.surveyViewModel.sections.forEach(section => {
          section.questions.forEach(element => {
            //this.ToggleQuestions(element, section);
            this.ToggleConditionalQuestions(element, section);
          });
          section.totalQuestionVisible = section.questions.filter(x => x.isParentQuestionVisible).length;
        });
      }
      // await this.setSectionDotColor();
      // await this.setInitialSection();


      /* Maintaining a backup of the original responses if user doesnt want to save the changes responses and view older respones */
      this.responsesBackUp = [];
      this.prepareOrUpdateResponsesBackUp(bindResult, "BeforeSave");
    }
    } catch (error) {
      console.error('[IncidentComponent] bindSurveyViewModel - Error:', error);
      this.spinnerService.hide();
    }
  }



  async setInitialSection() {
    try {
    const bpCopy = this.bpWFdetails;
    
    this.isSaveAndClose = false; this.isSectionReadOnly = false;
    this.selectedSection = new SectionViewModel();
    this.selectedStepIndex = 0; this.selectedSectionIndex = 0;
    if (this.isStandaloneSurvey) {
      if (this.standaloneSurveyDetails.sections.length == 1) {
        this.isSaveAndClose = true;
      }
      if (this.surveyViewModel && this.surveyViewModel.sections && this.surveyViewModel.sections.length > 0) {
        this.selectedSection = this.surveyViewModel.sections[0];
        this.surveyViewModel.sections[0].isSectionSelected = true;
      }
      this.getCondQuesForSelSection();
    }
    else {
      if (this.surveyViewModel.isWorkflow && this.bpWFdetails != null && this.bpWFdetails.workflowSteps && this.bpWFdetails.workflowSteps.length > 0) {
        if (this.bpWFdetails.workflowSteps.length == 1 && this.bpWFdetails.workflowSteps[0] && this.bpWFdetails.workflowSteps[0].sectionsList && this.bpWFdetails.workflowSteps[0].sectionsList.length == 1) {
          this.isSaveAndClose = true;
        }
        let secId = this.bpWFdetails.workflowSteps[0] && this.bpWFdetails.workflowSteps[0].sectionsList && this.bpWFdetails.workflowSteps[0].sectionsList[0] ? this.bpWFdetails.workflowSteps[0].sectionsList[0].sectionId : null;

        if (this.bpWFdetails.workflowSteps && this.bpWFdetails.workflowSteps.length > 0) {
          this.selectedStep = this.bpWFdetails.workflowSteps[0];
        }
        this.stepNavigated = this.globalSession.getNavigatedStep();
        if (this.stepNavigated != undefined && this.stepNavigated != null && this.stepNavigated.hasOwnProperty("stepName")) {
          let i = this.bpWFdetails.workflowSteps.findIndex(x => x.workflowStepId == this.stepNavigated.workflowStepId);
          if (i != -1 && this.bpWFdetails.workflowSteps[i]) {
            this.selectedStep = this.bpWFdetails.workflowSteps[i];
            if (this.bpWFdetails.workflowSteps[i].sectionsList && this.bpWFdetails.workflowSteps[i].sectionsList.length > 0) {
              this.selectedSection = this.surveyViewModel.sections.find(x => x.sectionId == this.bpWFdetails.workflowSteps[i].sectionsList[0].sectionId);
            }
            if (this.selectedSection) {
              this.selectedSection.isSectionSelected = true;
            }
            if (this.bpWFdetails.workflowSteps[i].sectionsList && this.bpWFdetails.workflowSteps[i].sectionsList.length > 0 && this.bpWFdetails.workflowSteps[i].sectionsList[0]) {
              this.bpWFdetails.workflowSteps[i].sectionsList[0].isSectionSelected = true;
            }
            // this.selectedSection = this.surveyViewModel.sections.filter(x => x.sectionId == this.bpWFdetails.)[0];
            if (this.bpWFdetails.workflowSteps[i].sectionsList && this.bpWFdetails.workflowSteps[i].sectionsList.length > 0 && this.bpWFdetails.workflowSteps[i].sectionsList[0] &&
              this.bpWFdetails.workflowSteps[i].sectionsList[0].workflowStepSectionAccessLevel != undefined &&
              this.bpWFdetails.workflowSteps[i].sectionsList[0].workflowStepSectionAccessLevel.length > 0) {
                //console.log(" this.bpWFdetails.workflowSteps line 1445: ", this.bpWFdetails.workflowSteps);
                //console.log("bpCopy",bpCopy);
              this.isSectionReadOnly = this.bpWFdetails.workflowSteps[i].sectionsList[0].workflowStepSectionAccessLevel == "RW" ? false : true;
            }
            else {
              this.isSectionReadOnly = false;
            }
            
            if(this.bpWFdetails.workflowSteps[i].sectionsList.length == 1){
              this.isSaveAndClose = true;
            }

          }
        } else {
          //console.log(this.WorkflowAssignment);
          let i = this.WorkflowAssignment && this.WorkflowAssignment.length > 0 ? this.WorkflowAssignment.find(x => x.stepStatus == "Not Started" || x.stepStatus == "PE" || x.stepStatus == "NE") : null;
          if (i != null) {
            let index = this.bpWFdetails.workflowSteps.findIndex(x => x.workflowStepId == i.workflowStepId);
            if (index != -1 && this.bpWFdetails.workflowSteps[index] && this.bpWFdetails.workflowSteps[index].sectionsList && this.bpWFdetails.workflowSteps[index].sectionsList.length > 0) {
              this.selectedStep = this.bpWFdetails.workflowSteps[index];
              this.selectedSection = this.surveyViewModel.sections.find(x => x.sectionId == this.bpWFdetails.workflowSteps[index].sectionsList[0].sectionId)
              if (this.selectedSection) {
                this.selectedSection.isSectionSelected = true;
              }
              // this.selectedSection.IsReadOnly
              if (this.bpWFdetails.workflowSteps[index].sectionsList[0]) {
                this.bpWFdetails.workflowSteps[index].sectionsList[0].isSectionSelected = true;
              }
              if (this.bpWFdetails.workflowSteps[index].sectionsList[0] &&
                this.bpWFdetails.workflowSteps[index].sectionsList[0].workflowStepSectionAccessLevel != undefined &&
                this.bpWFdetails.workflowSteps[index].sectionsList[0].workflowStepSectionAccessLevel.length > 0) {
                this.isSectionReadOnly = this.bpWFdetails.workflowSteps[index].sectionsList[0].workflowStepSectionAccessLevel == "RW" ? false : true;
              }
              else {
                this.isSectionReadOnly = false;
              }

              if(this.bpWFdetails.workflowSteps[index].sectionsList.length == 1){
                this.isSaveAndClose = true;
              }
            }
          } else {
            let i = this.WorkflowAssignment && this.WorkflowAssignment.length > 0 ? this.WorkflowAssignment.find(x => x.stepStatus == "CP") : null;
            if (i != null) {
              let index = this.bpWFdetails.workflowSteps.findIndex(x => x.workflowStepId == i.workflowStepId);
              if (index != -1 && this.bpWFdetails.workflowSteps[index] && this.bpWFdetails.workflowSteps[index].sectionsList && this.bpWFdetails.workflowSteps[index].sectionsList.length > 0) {
                this.selectedSection = this.surveyViewModel.sections.find(x => x.sectionId == this.bpWFdetails.workflowSteps[index].sectionsList[0].sectionId)
                if (this.selectedSection) {
                  this.selectedSection.isSectionSelected = true;
                }
                // this.selectedSection.IsReadOnly
                if (this.bpWFdetails.workflowSteps[index].sectionsList[0]) {
                  this.bpWFdetails.workflowSteps[index].sectionsList[0].isSectionSelected = true;
                }
                if (this.bpWFdetails.workflowSteps[index].sectionsList[0] &&
                  this.bpWFdetails.workflowSteps[index].sectionsList[0].workflowStepSectionAccessLevel != undefined &&
                  this.bpWFdetails.workflowSteps[index].sectionsList[0].workflowStepSectionAccessLevel.length > 0) {
                  this.isSectionReadOnly = this.bpWFdetails.workflowSteps[index].sectionsList[0].workflowStepSectionAccessLevel == "RW" ? false : true;
                }
                else {
                  this.isSectionReadOnly = false;
                }

                if(this.bpWFdetails.workflowSteps[index].sectionsList.length == 1){
                  this.isSaveAndClose = true;
                }
              }
            }
            else{
              if (this.bpWFdetails.workflowSteps && this.bpWFdetails.workflowSteps.length > 0 && this.bpWFdetails.workflowSteps[0].sectionsList && this.bpWFdetails.workflowSteps[0].sectionsList.length > 0) {
                this.selectedSection = this.surveyViewModel.sections.find(x => x.sectionId == this.bpWFdetails.workflowSteps[0].sectionsList[0].sectionId);
                if (this.selectedSection) {
                  this.selectedSection.isSectionSelected = true;
                }
                this.bpWFdetails.workflowSteps[0].sectionsList[0].isSectionSelected = true;
              }
              this.isSectionReadOnly = false;
            }
          }
        }
        //this.isSectionReadOnly = this.selectedSection.IsAccessiibleInWFStep;
        // if (this.bpWFdetails.workflowSteps[0].sectionsList[0].workflowStepSectionAccessLevel != undefined &&
        //   this.bpWFdetails.workflowSteps[0].sectionsList[0].workflowStepSectionAccessLevel.length > 0) {
        //   this.isSectionReadOnly = this.bpWFdetails.workflowSteps[0].sectionsList[0].workflowStepSectionAccessLevel == "RW" ? false : true;
        // }
        // else {
        //   this.isSectionReadOnly = false;
        // }

        this.wfSteps = this.wfSteps.sort((a,b)=> a.sequenceNumber - b.sequenceNumber);
        if(this.wfSteps && this.wfSteps.length == 1 && this.wfSteps[0] && this.wfSteps[0].sectionsList && this.wfSteps[0].sectionsList.length == 1){
          this.isSaveAndClose = true;
        }
        this.lookupEntityDetails(); 
        this.conditionQues = [];         
        this.getCondQuesForSelSection();
        this.setParentSectionData();

        this.getConsentQuestions();
      }
      else {
        if (this.surveyViewModel && this.surveyViewModel.sections && this.surveyViewModel.sections.length == 1) {
          this.isSaveAndClose = true;
        }
        if (this.surveyViewModel && this.surveyViewModel.sections && this.surveyViewModel.sections.length > 0) {
          this.selectedSection = this.surveyViewModel.sections[0];
          this.surveyViewModel.sections[0].isSectionSelected = true;
        }
        this.isSectionReadOnly = this.selectedSection ? this.selectedSection.IsReadOnly : false;      
         this.lookupEntityDetails();
        this.getCondQuesForSelSection();
      }

      if (this.selectedSection.sectionLookUpEntityId != null && this.surveyInstanceId != null && this.surveyInstanceId.length > 0) {
        this.isSectionReadOnly = true;
      }
    }

    //this.setPareQuestionVisible();
    
    this.performConditionalToggle(); /* To set visibility of all level questions */
    if(this.selectedSection != null && this.selectedSection.questions != null && this.selectedSection.questions.length > 0){     
    this.selectedSection.questions.forEach(ele => {
      if (ele.responseText == undefined) {
        ele.responseText = "";
      }
    })
    this.selectedSection.questions.sort((a, b) => a['sequenceNumber'] - b['sequenceNumber']);
    }


    //console.log("this.isSectionReadOnly",this.isSectionReadOnly);
  } catch (error) {
    console.error('[IncidentComponent] setInitialSection - Error:', error);
    this.spinnerService.hide();
  }
}

  performConditionalToggle(){
    try {
      if (!this.selectedSection) {
        console.warn('[IncidentComponent] performConditionalToggle - selectedSection is null/undefined');
        return;
      }
      
      this.ToggleConditionalSections(this.selectedSection);
      
      if (this.selectedSection.questions && this.selectedSection.questions.length > 0) {
        this.selectedSection.questions.forEach(question => {
          if (question) {
            this.ToggleConditionalQuestions(question, this.selectedSection);
          }
        });
      }
    } catch (error) {
      console.error('[IncidentComponent] performConditionalToggle - Error:', error);
    }
  }
  setPareQuestionVisible(){
    try {
      if (!this.selectedSection || !this.selectedSection.questions || this.selectedSection.questions.length === 0) {
        console.warn('[IncidentComponent] setPareQuestionVisible - selectedSection or questions is null/undefined/empty');
        return;
      }
      
      this.selectedSection.questions.forEach(childQ => {
        if (!childQ) {
          return;
        }
        
        if (childQ.parentQuestionGuid != null) {
          const parentQ = this.selectedSection.questions.find(
            q => q && q.questionGuid === childQ.parentQuestionGuid
          );
          
          if (parentQ) {
            const parentResponses = (parentQ.responseText || "").split("||");
            const expectedResponses = (childQ.parentQuesResponse || "").split("||");
            
            const isMatch = parentResponses.some(resp =>
              expectedResponses.includes(resp)
            );
            
            if (isMatch) {
              childQ.isParentQuestionVisible = true;
              childQ.enableQuestion = true;
            } else {
              childQ.isParentQuestionVisible = false;
              childQ.enableQuestion = false;
            }
          } else {
            if (childQ.displayMode == 'SH') {
              childQ.isParentQuestionVisible = false;
            } else if (childQ.displayMode == 'ED') {
              childQ.isParentQuestionVisible = true;
              childQ.enableQuestion = false;
            }
          }
        } else {
          childQ.isParentQuestionVisible = true;
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] setPareQuestionVisible - Error:', error);
    }
  }
  // setPareQuestionVisible_old(){
   
  //   if(this.selectedSection != null && this.selectedSection.questions != null && this.selectedSection.questions.length > 0){
  //     // if(this.selectedSection.ParentSectionGuid != null){
  //     //   this.selectedSection['isSecParentQuestionVisible']=false;
  //     // }
  //     // else{
  //     //   this.selectedSection['isSecParentQuestionVisible']=true;
  //     // }
  //     this.selectedSection.questions.forEach(x=>{
  //       if(x.parentQuestionGuid != null){
  //         if(x.displayMode == 'SH'){
  //           x.isParentQuestionVisible = false;
  //         }
  //         else if(x.displayMode == 'ED'){
  //           x.isParentQuestionVisible = true;
  //           x.enableQuestion = false;
  //         }      
  //       }
  //       else{
  //         x.isParentQuestionVisible = true;
  //       }
  //     })

  //   }
  // }
  setParentSectionData(){
    try {
    //this.conditionQues =[];    
    if(this.wfSteps != null && this.wfSteps.length > 0){
      this.wfSteps.forEach(step =>{
        if(step.sectionsList!=null &&step.sectionsList.length>0){
          step.sectionsList.forEach(sec => {
            if(sec.parentSectionGuid != null && sec.parentQuestionGuid != null && sec.parentQuesResponse != null){
  
              let parentSection = this.surveyViewModel.sections.find(x=> x.SectionGuid == sec.parentSectionGuid);
              let parentQuestion = parentSection && parentSection.questions ? parentSection.questions.find(x=> x.questionGuid ==  sec.parentQuestionGuid) : null;
              let parentResp = sec.parentQuesResponse ? sec.parentQuesResponse.split("||") : [];
             
              if(parentQuestion != undefined  && parentQuestion.responseText  != undefined && parentQuestion.responseText != null &&  parentQuestion.responseText.length > 0){
                let curreResponse = parentQuestion.responseText;
                if(parentResp.some(v => (curreResponse ? curreResponse.split("||") : []).indexOf(v) != -1) || 
                parentResp.some(v => v.trim() ==  curreResponse)){
                  sec["isSecParentQuestionVisible"] = true;
                }
                else{
                  //this.conditionQues.push({ questionId: null, que: sec.sectionName, value: sec.parentQuesResponse, isSelected: true, parentQuestionGuid: sec["parentQuestionGuid"] });
                  sec["isSecParentQuestionVisible"] = false;
                }
                this.conditionQues.push({ questionId: null, que: sec.sectionName, value: sec.parentQuesResponse, isSelected: true, parentQuestionGuid: sec["parentQuestionGuid"] });
  
              }
              else{
                this.conditionQues.push({ questionId: null, que: sec.sectionName, value: sec.parentQuesResponse, isSelected: true, parentQuestionGuid: sec["parentQuestionGuid"] });
                sec["isSecParentQuestionVisible"] = false;
              }
                     
            }
            else{
              sec["isSecParentQuestionVisible"] = true;
            }         
          });    
        }
          
      });
    }
    } catch (error) {
      console.error('[IncidentComponent] setParentSectionData - Error:', error);
    }
  }
  getCondQuesForSelSection(){
    try {
    //console.log("Section",this.selectedSection);
    
    this.conditionQues =[];
    if(this.selectedSection != null && this.selectedSection.questions != null && this.selectedSection.questions.length>0){
      this.selectedSection.questions.forEach(q =>{
        if(q.parentQuestionGuid != null && q.parentQuestionGuid.length  > 0){
          this.conditionQues.push({ questionId: q.questionId, que: q.questionTextShort, value: q.parentQuesResponse, isSelected: false, parentQuestionGuid: q["parentQuestionGuid"] });
        }
      })
    }
    } catch (error) {
      console.error('[IncidentComponent] getCondQuesForSelSection - Error:', error);
    }
  }
  GetChildData(selectedChild: QuestionViewModel) {
    try {
      if (!selectedChild) {
        console.warn('[IncidentComponent] GetChildData - selectedChild is null/undefined');
        return;
      }
      
      if (!this.selectedSection || !this.selectedSection.questions) {
        console.warn('[IncidentComponent] GetChildData - selectedSection or questions is null/undefined');
        return;
      }
      
      this.isSaveAndClose = false;
      
      // Update in consent questions if available
      if (this.consentQuestions && this.consentQuestions.length > 0) {
        this.consentQuestions.forEach((element: QuestionViewModel) => {
          if (element && element.questionId == selectedChild.questionId) {
            Object.assign(element, selectedChild);
          }
        });
      }
      
      // Assign latest question obj to existing question
      this.selectedSection.questions.forEach((element: QuestionViewModel) => {
        if (element && element.questionId == selectedChild.questionId) {
          Object.assign(element, selectedChild);
        }
        this.ToggleConditionalQuestions(selectedChild, this.selectedSection);
      });
      
      this.ToggleConditionalSections(this.selectedSection);
      
      this.ToggleConditionalSections(this.selectedSection);
      
      // Check for SubmitClose button visibility
      if (this.isLastStep() && this.isLastSection()) {
        this.isSaveAndClose = true;
      }
      
      this.setSectionDotColor_NEW();
    } catch (error) {
      console.error('[IncidentComponent] GetChildData - Error:', error);
    }
  }
  // childDataResp(element) {
  //   //for each on SurveyView model, check conditional sections
  //   this.surveyViewModel.sections.forEach((parobj, parindex) => {
  //     if(parobj.sectionId == this.selectedSection.sectionId){
  //       if (parobj.ParentSectionGuid) {
  //         let sec = this.surveyViewModel.sections.find(x => x.SectionGuid == parobj.ParentSectionGuid);
  //         let parQues = sec.questions.find(x => x.questionGuid == parobj.parentQuestionGuid);
  
  //         if (sec["isSecParentQuestionVisible"] == true && parobj["isSecParentQuestionVisible"] == true
  //           && parQues.responseText 
  //           && ( parQues.responseText.includes("||") ? 
  //              parQues.responseText.split('||').some(v => parobj.parentQuesResponse.split("||").indexOf(v) == -1) 
  //           : (!parobj.parentQuesResponse.split('||').some(v => v.trim() == parQues.responseText))
  //           )
  //           /*parQues.responseText.split('||').indexOf(parobj.parentQuesResponse)!=-1 */) {
  //           parobj.questions.forEach((item) => {
  //             if (item.responseText != null) {
  //               this.showClearResponsesPopUp = true;
  //               return;
  //             }
  //           });
  
  //         }
  //       }
  //       //modify here
  //       let currentQues = parobj.questions.find(x => x.questionId == element.questionId);
  //       if (currentQues) {
  //         let currentQuesCh = parobj.questions.filter(x => x.parentQuestionGuid == currentQues.questionGuid);
  //         if (currentQuesCh != null && currentQuesCh.length > 0) {
  //           currentQuesCh.forEach((child, i) => {
  //             let resp = currentQues.responseText;
  //             if (!resp) {
  //               resp = "";
  //             }
  //             let parentResp = resp.split("||");
  //             let parQuesRespText = (child.parentQuesResponse != null && child.parentQuesResponse.length > 0 && child.parentQuesResponse.includes("||")) ? child.parentQuesResponse.split("||") : child.parentQuesResponse;
  //             if (parQuesRespText != null && parQuesRespText.length > 0 && parentResp.some(v => parQuesRespText.indexOf(v) == -1) && child.responseText != null && child.responseText!=""
  //               && child.isParentQuestionVisible == true) {
  //               this.showClearResponsesPopUp = true;
  //               return;
  //             }
  //           });
  //         }
  //       }
  
  //     }
    
  //   });
  // }
  // GetChildDataAndSetVisibility(selectedChild) {
    
  //   if (this.questionCommentBackUp.find(x => x.questionId == selectedChild.questionId)) {
  //     this.questionCommentBackUp.find(item => item.questionId == selectedChild.questionId).questionReponse = selectedChild.responseText;
  //   }
  //   else {
  //     let quesComments = new QuestionResponsesdata();
  //     quesComments.questionId = selectedChild.questionId;
  //     quesComments.questionReponse = selectedChild.responseText;
  //     this.questionCommentBackUp.push(quesComments);
  //   }
  //   if (selectedChild.options != null && selectedChild.options.length > 0) {
  //     selectedChild.options.forEach((e) => {
  //       if (this.conditionQues.filter(x => x.parentQuestionGuid == selectedChild["questionGuid"]).length > 0) {
  //         this.newConditionalQuestions = this.conditionQues.filter(x => x.parentQuestionGuid == selectedChild["questionGuid"]);
  //       }
  //       else {
  //         this.newConditionalQuestions = [];
  //       }
        
  //       //Update value as selected in conditional ques arr
  //       this.newConditionalQuestions.forEach((element) => {
  //         let parRes = [];
  //         if (element.value) {
  //           parRes = element.value.split("||");
  //         }
  //         //let parQuesRespText = child.parentQuesResponse.split("||");
  //         //if( parentResp.some(v=> parQuesRespText.indexOf(v) == -1)
  //         if (parRes.some(v => e.value.split("||").indexOf(v) != -1)
  //           /* element.value == e.value */
  //           && e.selected == true && (selectedChild["isParentQuestionVisible"] == undefined || selectedChild["isParentQuestionVisible"] == true)) {
  //           element.isSelected = true;

  //           this.surveyViewModel.sections.forEach((parobj, parindex) => {
              
  //             // if(parobj.sectionId ==  this.selectedSection.sectionId){
  //             //   if (parobj["sectionName"] === element.que && element.isSelected == true) {                
  //             //     parobj["isSecParentQuestionVisible"] = true;  
  //             //     this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //             //     this.ToggleSections();
  //             //   }
  //             //   //method to set Display Mode for current question based on its parent's visibility and display mode
  //             //   this.ToggleQuestions(element, parobj);
  //             //   parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             //   this.ToggleSections();
  //             // }
  //             if(parobj["sectionName"] === element.que){
  //               parobj["isSecParentQuestionVisible"] = true;  
  //               this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //               this.ToggleSections();
  //             } 
  //             else if(parobj.sectionId ==  this.selectedSection.sectionId && parobj["sectionName"] != element.que){
  //               this.ToggleQuestions(element, parobj);
  //               parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             } 
             
  //             // this.ToggleQuestions(element, parobj);
  //             // parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             this.ToggleSections();          
  //           });
  //         }
  //         else if (parRes.some(v => e.value.indexOf(v) != -1) /* element.value == e.value */
  //           && (e.selected == false || e.selected == undefined)) {
  //           element.isSelected = false;
  //           this.surveyViewModel.sections.forEach((parobj, parindex) => {
  //             // if(parobj.sectionId ==  this.selectedSection.sectionId){
  //             //   if (parobj["sectionName"] === element.que && element.isSelected == false) {
  //             //     parobj["isSecParentQuestionVisible"] = false;
  
  //             //     this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;// this.totalSections -1;
  //             //     this.ToggleSections();
  //             //   }
  
  
  //             //   // method to set Display Mode for current question based on its parent's visibility and display mode
  //             //   this.ToggleQuestions(element, parobj);
  //             //   parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             // }
              
  //             if(parobj["sectionName"] === element.que){
  //               parobj["isSecParentQuestionVisible"] = true;  
  //               this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //               this.ToggleSections();
  //             }
  //             else if(parobj.sectionId ==  this.selectedSection.sectionId && parobj["sectionName"] != element.que){
  //               this.ToggleQuestions(element, parobj);
  //               parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             } 
  //             //this.ToggleQuestions(element, parobj);
  //             //parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             //this.ToggleSections();
  //           });
  //         }


  //       });
  //     });
  //   }

  //   this.resetQuestionIndex();
  // }
  // GetChildDataAndSetVisibility_NEW(selectedChild) {
    
  //   if (this.questionCommentBackUp.find(x => x.questionId == selectedChild.questionId)) {
  //     this.questionCommentBackUp.find(item => item.questionId == selectedChild.questionId).questionReponse = selectedChild.responseText;
  //   }
  //   else {
  //     let quesComments = new QuestionResponsesdata();
  //     quesComments.questionId = selectedChild.questionId;
  //     quesComments.questionReponse = selectedChild.responseText;
  //     this.questionCommentBackUp.push(quesComments);
  //   }
  //   if (selectedChild.options != null && selectedChild.options.length > 0) {
  //     selectedChild.options.forEach((e) => {
  //       if (this.conditionQues.filter(x => x.parentQuestionGuid == selectedChild["questionGuid"]).length > 0) {
  //         this.newConditionalQuestions = this.conditionQues.filter(x => x.parentQuestionGuid == selectedChild["questionGuid"]);
  //       }
  //       else {
  //         this.newConditionalQuestions = [];
  //       }
       
  //       //Update value as selected in conditional ques arr
  //       this.newConditionalQuestions.forEach((element) => {
          
  //         let parRes = [];
  //         if (element.value) {         
  //           parRes = element.value.split("||");
  //         }
         
  //         if ((parRes.some(v => e.value.split("||").indexOf(v) != -1) || parRes.some(x => x.trim() == e.value))
  //           /* element.value == e.value */
  //           && e.selected == true && (selectedChild["isParentQuestionVisible"] == undefined || selectedChild["isParentQuestionVisible"] == true)) {
  //           element.isSelected = true;

  //           this.surveyViewModel.sections.forEach((parobj, parindex) => {
             
  //             if(parobj.sectionId ==  this.selectedSection.sectionId){
  //               if (parobj["sectionName"] === element.que && element.isSelected == true) {                
  //                 parobj["isSecParentQuestionVisible"] = true;  
  //                 this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //                 this.ToggleSections();
  //               }
  //               //method to set Display Mode for current question based on its parent's visibility and display mode
  //               this.ToggleQuestions(element, parobj);
  //               parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //               this.ToggleSections();
  //             }
  //             else if(parobj["sectionName"] === element.que){
  //               parobj["isSecParentQuestionVisible"] = true;  
  //               this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //               this.ToggleSections();
  //             }              
                   
  //           });
  //         }
  //         else if ((parRes.some(v => e.value.indexOf(v) != -1) /* element.value == e.value */
  //           && (e.selected == false || e.selected == undefined) ) || 
  //           (e.selected == true && (!parRes.some(v => e.value.indexOf(v) != -1) || !parRes.some(x => x.trim() == e.value))) ) {
          
  //           element.isSelected = false;
  //           this.surveyViewModel.sections.forEach((parobj, parindex) => {
  //             if(parobj.sectionId ==  this.selectedSection.sectionId){
  //               if (parobj["sectionName"] === element.que && element.isSelected == false) {
  //                 parobj["isSecParentQuestionVisible"] = false;
  
  //                 this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;// this.totalSections -1;
  //                 this.ToggleSections();
  //               }
  
  
  //               // method to set Display Mode for current question based on its parent's visibility and display mode
  //               this.ToggleQuestions(element, parobj);
  //               parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //               this.ToggleSections();
  //             }
  //             else if(parobj["sectionName"] === element.que){
  //               parobj["isSecParentQuestionVisible"] = true;  
  //               this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //               this.ToggleSections();
  //             }
              
           
  //           });
  //         }


  //       });
  //     });
  //   }

  //   this.resetQuestionIndex();
  // }
  // GetSectionChildDataAndSetVisibility(selectedChild) {
  
  //   if (this.questionCommentBackUp.find(x => x.questionId == selectedChild.questionId)) {
  //     this.questionCommentBackUp.find(item => item.questionId == selectedChild.questionId).questionReponse = selectedChild.responseText;
  //   }
  //   else {
  //     let quesComments = new QuestionResponsesdata();
  //     quesComments.questionId = selectedChild.questionId;
  //     quesComments.questionReponse = selectedChild.responseText;
  //     this.questionCommentBackUp.push(quesComments);
  //   }
  //   if (selectedChild.options != null && selectedChild.options.length > 0) {
  //     selectedChild.options.forEach((e) => {
  //       if (this.conditionQues.filter(x => x.parentQuestionGuid == selectedChild["questionGuid"]).length > 0) {
  //         this.newConditionalQuestions = this.conditionQues.filter(x => x.parentQuestionGuid == selectedChild["questionGuid"]);
  //       }
  //       else {
  //         this.newConditionalQuestions = [];
  //       }
       
  //       //Update value as selected in conditional ques arr
  //       this.newConditionalQuestions.forEach((element) => {
  //         let parRes = [];
  //         if (element.value) {
  //           parRes = element.value.split("||");
  //         }
  //         //let parQuesRespText = child.parentQuesResponse.split("||");
  //         //if( parentResp.some(v=> parQuesRespText.indexOf(v) == -1)
  //         if (parRes.some(v => e.value.split("||").indexOf(v) != -1)
  //           /* element.value == e.value */
  //           && e.selected == true && (selectedChild["isParentQuestionVisible"] == undefined || selectedChild["isParentQuestionVisible"] == true)) {
  //           element.isSelected = true;

  //           this.surveyViewModel.sections.forEach((parobj, parindex) => {
            
  //             // if(parobj.sectionId ==  this.selectedSection.sectionId){
  //             //   if (parobj["sectionName"] === element.que && element.isSelected == true) {                
  //             //     parobj["isSecParentQuestionVisible"] = true;  
  //             //     this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //             //     this.ToggleSections();
  //             //   }
  //             //   //method to set Display Mode for current question based on its parent's visibility and display mode
  //             //   this.ToggleQuestions(element, parobj);
  //             //   parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             //   this.ToggleSections();
  //             // }
  //             if(parobj["sectionName"] === element.que){
  //               parobj["isSecParentQuestionVisible"] = true;  
  //               this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //               this.ToggleSections();
  //             }  
             
  //             // this.ToggleQuestions(element, parobj);
  //             // parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             //this.ToggleSections();          
  //           });
  //         }
  //         else if (parRes.some(v => e.value.indexOf(v) != -1) /* element.value == e.value */
  //           && (e.selected == false || e.selected == undefined)) {
  //           element.isSelected = false;
  //           this.surveyViewModel.sections.forEach((parobj, parindex) => {
  //             // if(parobj.sectionId ==  this.selectedSection.sectionId){
  //             //   if (parobj["sectionName"] === element.que && element.isSelected == false) {
  //             //     parobj["isSecParentQuestionVisible"] = false;
  
  //             //     this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;// this.totalSections -1;
  //             //     this.ToggleSections();
  //             //   }
  
  
  //             //   // method to set Display Mode for current question based on its parent's visibility and display mode
  //             //   this.ToggleQuestions(element, parobj);
  //             //   parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  
  //             // }
  //             if(parobj["sectionName"] === element.que){
  //               parobj["isSecParentQuestionVisible"] = true;  
  //               this.totalSections = this.surveyViewModel.sections.filter(x => x["isSecParentQuestionVisible"] == true && x.IsAccessiibleInWFStep).length;
  //               this.ToggleSections();
  //             } 
  //            // this.ToggleQuestions(element, parobj);
  //             //parobj.totalQuestionVisible = parobj.questions.filter(x => x.isParentQuestionVisible).length;
  //             //this.ToggleSections();
  //           });
  //         }


  //       });
  //     });
  //   }

  //   this.resetQuestionIndex();
  // }
  // resetQuestionIndex() {
  //   this.surveyViewModel.sections.forEach(x => {
  //     this.lastQuestionIndex = 1;
  //     x.questions.forEach(question => {
  //       if (question.isParentQuestionVisible == true) {
  //         question.questionIndex = this.lastQuestionIndex;
  //         this.lastQuestionIndex++;
  //       }
  //     })

  //   })

  // }
  setAllOptionVisibleOnLoad(){
    try {
      if (!this.selectedSection || !this.selectedSection.questions || this.selectedSection.questions.length === 0) {
        console.warn('[IncidentComponent] setAllOptionVisibleOnLoad - selectedSection or questions is null/undefined/empty');
        return;
      }
      
      this.selectedSection.questions.forEach(ques => {
        if (!ques) {
          return;
        }
        
        if (ques.options && ques.options.length > 0) {
          ques.options.forEach(qOpt => {
            if (qOpt) {
              qOpt["isQuesOptionVisible"] = true;
            }
          });
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] setAllOptionVisibleOnLoad - Error:', error);
    }
  }

  async onClickOfSection(stepIndex: number, sectionIndex: number) {
    const container = document.querySelector('.drawer-content-bodyScroll');
    container.scrollTop = 0;
    this.showExtraComments = false;
    this.prevSelectedSectionIndex = this.selectedSectionIndex;
    this.prevSelectedStepIndex = this.selectedStepIndex;
    this.selectedStepIndex = stepIndex;
    this.selectedSectionIndex = sectionIndex;
    if(this.isSaveRequired){
      const res = await this.openSaveAndContinuePopup()      
    }
    this.isSaveAndClose = false; this.isSectionReadOnly = false;
    const prevSection = this.selectedSection;
    this.selectedSection = new SectionViewModel();
    if (this.surveyViewModel.isWorkflow || this.IsWorkflow) {
      if (this.wfSteps && this.wfSteps.length > 0) {
        this.wfSteps.forEach(x => {
        if (x.sectionsList && x.sectionsList.length > 0) {
          x.sectionsList.forEach(y => y.isSectionSelected = false);
          
        }
      });
      }
      // if (stepIndex == this.wfSteps.length - 1) {
      //   if (sectionIndex == this.wfSteps[stepIndex].sectionsList.length - 1) {
      //     this.isSaveAndClose = true;
      //   }
      // }

      //check for SubmitClose button visibility
      if(this.isLastStep() && this.isLastSection()) {
        this.isSaveAndClose = true;
      }

      //let secId = this.wfSteps[stepIndex].sectionsList[sectionIndex].sectionId;
      if (!this.wfSteps || !this.wfSteps[stepIndex] || !this.wfSteps[stepIndex].sectionsList) {
        return;
      }
      let visisbleSections = this.wfSteps[stepIndex].sectionsList.filter(x=> x["isSecParentQuestionVisible"] == true);
      if (!visisbleSections || visisbleSections.length === 0 || !visisbleSections[sectionIndex]) {
        return;
      }
      let nextSection :QuestionAnswer = visisbleSections[sectionIndex];
      // console.log(this.wfSteps);
      // console.log(this.surveyViewModel.sections);
      let filteredSections = this.surveyViewModel && this.surveyViewModel.sections ? this.surveyViewModel.sections.filter(x => x.sectionId == nextSection.sectionId && x["isSecParentQuestionVisible"] == true) : [];
      this.selectedSection = this.isSaveRequired ? prevSection : (filteredSections && filteredSections.length > 0 ? filteredSections[0] : new SectionViewModel());
      this.performConditionalToggle(); /* To set visibility of all level questions */

      if (this.selectedSection.questions.length == 0) {
        this.baseHttpService.get(this.constant.getSectionById + '/' + this.selectedSection.sectionId.toString() + '/' + this.surveyViewModel.surveyId).subscribe(async result => {
          if (result != null) {
            this.selectedSection.questions = result.questions;
            this.setAllOptionVisibleOnLoad();

            //this.selectedSection.gridQuestions = result.gridQuestions;
            this.surveyViewModel.sections.forEach(y => {
              if (y.sectionId == this.selectedSection.sectionId) {
                y.questions = result.questions;
                //  x.gridQuestions = result.gridQuestions



                // New Area
                result.gridQuestions.forEach(function (x) {

                  let gd = new GridViewModel();

                  gd.gridId = x.gridId;

                  gd.sequenceNumber = x.sequenceNumber;

                  gd.response = [];

                  let maxSeqResp = 1;


                  for (let i = 1; i <= maxSeqResp; i++) {

                    let response = new ResponseModel();

                    x.questions.forEach(function (childobj) {

                      let questions = new QuestionViewModel();

                      questions.questionId = childobj["questionId"];
                      questions.lookUpQuestionId = childobj["lookUpQuestionId"];

                      questions.sequenceNumber = childobj["sequenceNumber"];

                      questions.dataType = childobj["dataType"];

                      questions.inputType = childobj["inputType"];

                      questions.refTableName = childobj["refTableName"];

                      questions.questionText = childobj["questionText"];

                      questions.questionRichEditorText = childobj["questionRichEditorText"];

                      questions.questionTextShort = childobj["questionTextShort"];

                      questions.isQuestionRequired = childobj["isQuestionRequired"];

                      questions.questionToolTip = childobj["questionToolTip"];

                      questions.parentQuestionId = childobj["parentQuestionId"];

                      questions.parentQuesResponse = childobj["parentQuesResponse"];

                      questions.defaultResponse = childobj["defaultResponse"];

                      questions.maxLength = childobj["maxLength"];

                      questions.sectionId = childobj["sectionId"];

                      questions.options = childobj["options"];

                      questions.questionImage = childobj["questionImage"];

                      questions.questionImageName = childobj["questionImageName"];

                      questions.responseText = childobj["responseText"];

                      questions["initialText"] = childobj["initialText"];

                      questions["finalText"] = childobj["finalText"];

                      questions.validations = childobj["validations"];



                      questions.validationDetails = childobj["validationDetails"];

                      questions.futureDateEnabled = childobj["futureDateEnabled"];

                      questions.pastDateEnabled = childobj["pastDateEnabled"];

                      questions.todayDateEnabled = childobj["todayDateEnabled"];

                      questions.timeEnabled = childobj["timeEnabled"];

                      response.sequenceNumber = 1;





                      if (questions.isQuestionRequired == "Y" || (questions.validations != null && questions.validations.length > 0)) {

                        questions["IsValid"] = false;

                      }

                      else {

                        questions["IsValid"] = true;

                      }

                      if (questions.parentQuesResponse === "") {



                        questions["isParentQuestionVisible"] = true;

                      }

                      else {



                        questions["isParentQuestionVisible"] = false;

                      }

                      if (questions.displayMode == "ED") {

                        questions["isParentQuestionVisible"] = true;

                      }

                      if (response.questions == null) {

                        response.questions = [];

                      }

                      // if (IsBindUserResponse) {

                      //   let resultQques = bindResult.find(x => x.questionId == questions.questionId && x.sequenceNumber == i);

                      //   if (resultQques) {

                      //     questions.responseText = resultQques.responseText;

                      //     response.sequenceNumber = resultQques.sequenceNumber;

                      //     questions.comments = resultQques.comments;
                      //     questions.surveyResponseRelId = resultQques.surveyResponseRelId;
                      //     //questions["responseReadOnly"] = resultQques.responseReadOnly;

                      //     let quesComments = new QuestionResponsesdata();

                      //     quesComments.comments = resultQques.comments;

                      //     quesComments.questionId = resultQques.questionId;

                      //     quesComments.questionReponse = resultQques.responseText;
                      //     quesComments.surveyResponseRelId = resultQques.surveyResponseRelId;

                      //     //this.questionCommentBackUp.push(quesComments);                  

                      //   }

                      //   if (questions["isParentQuestionVisible"] == false) {

                      //     let parentQue = bindResult.find(x => x.questionGuid == questions["parentQuestionGuid"] && x.sequenceNumber == i);

                      //     if (parentQue) {

                      //       let parentResp = parentQue.responseText.split("||");

                      //       let parQuesRespText = questions.parentQuesResponse.split("||");



                      //       if (parentResp.some(v => parQuesRespText.indexOf(v) != -1)) {

                      //         questions["isParentQuestionVisible"] = true;

                      //         questions["IsValid"] = true;

                      //       }

                      //     }

                      //   }

                      // }



                      response.questions.push(questions);

                    });



                    //foreach ends here

                    response.isDefaultControl = true;

                    response.questions.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);

                    gd.response.push(response);



                  }

                  y.gridQuestions.push(gd);
                  //  this.selectedSection.gridQuestions.push(gd);

                });

                // Finish
                // x.gridQuestions.forEach(y => {
                //   y.response = [];
                //   let re = new ResponseModel();
                //   re.questions = y.
                //   y.response.push()

                // })
              }
            })

            //  this.bindSurveyViewModel(this.surveyViewModel, [], false, false);
            if (this.wfSteps && this.wfSteps[stepIndex] && this.wfSteps[stepIndex].sectionsList && this.wfSteps[stepIndex].sectionsList[sectionIndex]) {
              this.wfSteps[stepIndex].sectionsList[sectionIndex].isSectionSelected = true;
              this.selectedStep = this.wfSteps[stepIndex];
              this.isSectionReadOnly = this.selectedStep.sectionsList[sectionIndex].workflowStepSectionAccessLevel == "RW" ? false : true;
            }
            this.selectedSectionIndex = sectionIndex; this.selectedStepIndex = stepIndex;
            await this.lookupEntityDetails();
            this.getCondQuesForSelSection();

            if ((this.selectedSection.sectionLookUpEntityId != null && this.surveyInstanceId != null && this.surveyInstanceId.length > 0)
              || (this.selectedSection.sectionLookUpEntityId != null && this.selectedEntityInstanceId != null && this.selectedEntityInstanceId.length > 0)) {
              this.isSectionReadOnly = true;
            }

            let selStep :any = null;
            const stepNavigatedStr = this.storage.get("StepNavigated");
            if (stepNavigatedStr) {
              try {
                selStep = JSON.parse(stepNavigatedStr);
              } catch (e) {
                console.error('[IncidentComponent] Error parsing StepNavigated:', e);
              }
            }
            if(selStep != null && this.wfSteps && this.wfSteps[stepIndex] && this.wfSteps[stepIndex].workflowStepId != selStep.workflowStepId){
              this.showExtraComments = true;
            }
            // if(this.stepNavigated != null && this.wfSteps[stepIndex].workflowStepId != this.stepNavigated.workflowStepId){
            //   this.showExtraComments = true;
            // }

          }
          // this.spinnerService.hide();
        })
      } else {
        this.selectedSection.isSectionSelected = true;
        nextSection.isSectionSelected = true;
        if (this.wfSteps && this.wfSteps[stepIndex]) {
          this.selectedStep = this.wfSteps[stepIndex];
          //let findSec = this.selectedStep.fin
          if (this.selectedStep.sectionsList && this.selectedStep.sectionsList[sectionIndex]) {
            this.isSectionReadOnly = this.selectedStep.sectionsList[sectionIndex].workflowStepSectionAccessLevel == "RW" ? false : true;
          }
        }
        this.selectedSectionIndex = sectionIndex; this.selectedStepIndex = stepIndex;
        await this.lookupEntityDetails();
        this.getCondQuesForSelSection();

        if ((this.selectedSection.sectionLookUpEntityId != null && this.surveyInstanceId != null && this.surveyInstanceId.length > 0)
          || (this.selectedSection.sectionLookUpEntityId != null && this.selectedEntityInstanceId != null && this.selectedEntityInstanceId.length > 0)) {
          this.isSectionReadOnly = true;
        }

        let selStep :any = null;
        const stepNavigatedStr2 = this.storage.get("StepNavigated");
        if (stepNavigatedStr2) {
          try {
            selStep = JSON.parse(stepNavigatedStr2);
          } catch (e) {
            console.error('[IncidentComponent] Error parsing StepNavigated:', e);
          }
        }
        if(selStep != null && this.wfSteps && this.wfSteps[stepIndex] && this.wfSteps[stepIndex].workflowStepId != selStep.workflowStepId){
          this.showExtraComments = true;
        }
        // this.spinnerService.hide();
      }
      this.setParentSectionData();
      //this.setPareQuestionVisible();
    }
    else {
      if (this.surveyViewModel && this.surveyViewModel.sections && this.surveyViewModel.sections.length > 0 && sectionIndex == this.surveyViewModel.sections.length - 1) {
        this.isSaveAndClose = true;
      }
      if (this.surveyViewModel && this.surveyViewModel.sections) {
        this.surveyViewModel.sections.forEach(x => { x.isSectionSelected = false });
      }
      if (this.surveyViewModel && this.surveyViewModel.sections && this.surveyViewModel.sections[sectionIndex]) {
        this.selectedSection = this.surveyViewModel.sections[sectionIndex];
      if (this.selectedSection.questions.length == 0) {
        this.baseHttpService.get(this.constant.getSectionById + '/' + this.selectedSection.sectionId.toString() + '/' + this.surveyViewModel.surveyId).subscribe(async result => {
          if (result != null) {
            this.selectedSection.questions = result.questions;

            //this.selectedSection.gridQuestions = result.gridQuestions;
            this.surveyViewModel.sections.forEach(y => {
              if (y.sectionId == this.selectedSection.sectionId) {
                y.questions = result.questions;
                //  x.gridQuestions = result.gridQuestions

                this.getCondQuesForSelSection();


                // New Area
                result.gridQuestions.forEach(function (x) {

                  let gd = new GridViewModel();

                  gd.gridId = x.gridId;

                  gd.sequenceNumber = x.sequenceNumber;

                  gd.response = [];

                  let maxSeqResp = 1;


                  for (let i = 1; i <= maxSeqResp; i++) {

                    let response = new ResponseModel();

                    x.questions.forEach(function (childobj) {

                      let questions = new QuestionViewModel();

                      questions.questionId = childobj["questionId"];
                      questions.lookUpQuestionId = childobj["lookUpQuestionId"];

                      questions.sequenceNumber = childobj["sequenceNumber"];

                      questions.dataType = childobj["dataType"];

                      questions.inputType = childobj["inputType"];

                      questions.refTableName = childobj["refTableName"];

                      questions.questionText = childobj["questionText"];
                      
                      questions.questionRichEditorText = childobj["questionRichEditorText"];

                      questions.questionTextShort = childobj["questionTextShort"];

                      questions.isQuestionRequired = childobj["isQuestionRequired"];

                      questions.questionToolTip = childobj["questionToolTip"];

                      questions.parentQuestionId = childobj["parentQuestionId"];

                      questions.parentQuesResponse = childobj["parentQuesResponse"];

                      questions.defaultResponse = childobj["defaultResponse"];

                      questions.maxLength = childobj["maxLength"];

                      questions.sectionId = childobj["sectionId"];

                      questions.options = childobj["options"];

                      questions.questionImage = childobj["questionImage"];

                      questions.questionImageName = childobj["questionImageName"];

                      questions.responseText = childobj["responseText"];

                      questions["initialText"] = childobj["initialText"];

                      questions["finalText"] = childobj["finalText"];

                      questions.validations = childobj["validations"];



                      questions.validationDetails = childobj["validationDetails"];

                      questions.futureDateEnabled = childobj["futureDateEnabled"];

                      questions.pastDateEnabled = childobj["pastDateEnabled"];

                      questions.todayDateEnabled = childobj["todayDateEnabled"];

                      questions.timeEnabled = childobj["timeEnabled"];

                      response.sequenceNumber = 1;





                      if (questions.isQuestionRequired == "Y" || (questions.validations != null && questions.validations.length > 0)) {

                        questions["IsValid"] = false;

                      }

                      else {

                        questions["IsValid"] = true;

                      }

                      if (questions.parentQuesResponse === "") {



                        questions["isParentQuestionVisible"] = true;

                      }

                      else {



                        questions["isParentQuestionVisible"] = false;

                      }

                      if (questions.displayMode == "ED") {

                        questions["isParentQuestionVisible"] = true;

                      }

                      if (response.questions == null) {

                        response.questions = [];

                      }
                      response.questions.push(questions);

                    });





                    response.isDefaultControl = true;

                    response.questions.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);

                    gd.response.push(response);



                  }

                  y.gridQuestions.push(gd);


                });

              }
            })
            this.selectedSection.questions.sort((a, b) => a['sequenceNumber'] - b['sequenceNumber']);
            this.surveyViewModel.sections[sectionIndex].isSectionSelected = true;
            this.selectedSectionIndex = sectionIndex;

          }
          // this.spinnerService.hide();
        })
      } else {
        this.selectedSection.questions.sort((a, b) => a['sequenceNumber'] - b['sequenceNumber']);
        this.surveyViewModel.sections[sectionIndex].isSectionSelected = true;
        this.selectedSectionIndex = sectionIndex;
        this.getCondQuesForSelSection();

        // this.spinnerService.hide();
      }

      this.isSectionReadOnly = this.selectedSection.IsReadOnly;
      }
    }

   // 

    this.setSectionDotColor_NEW();
    this.getConsentQuestions();
  }

  async openSaveAndContinuePopup(): Promise<boolean> {
    try {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.position = { top: '5px' };
    dialogConfig.data = "There are unsaved changes on this page. Would you like to save before leaving?";

    const dialogRef = this.dialog.open(CommonMessageComponent, dialogConfig);
    // Return a Promise that resolves when the dialog is closed
    return new Promise((resolve,reject) => {
        dialogRef.afterClosed().subscribe((res) => {
          var error
          this.isScrolled = false;
          if(res){
            if (!this.raiseDisputeMode) {
              this.incidentCreateShouldLog = this.surveyInstanceId == null || this.surveyInstanceId.length == 0;
              error = this.sectionalSave('SavePopUp', SurveySubmissionStatus.Save);
            } else {
              this.saveDispute('SavePopUp');
            }
           
            if(error === false){
              reject()
              this.selectedStepIndex = this.prevSelectedStepIndex
              this.selectedSectionIndex = this.prevSelectedSectionIndex
            }
            else{
              resolve(res);
            }
          }
          else{
            //reset to old Responses of section and reset old step and sec index and no need to show save pop up
            this.isSaveRequired = false;
            this.selectedStepIndex = this.prevSelectedStepIndex
            this.selectedSectionIndex = this.prevSelectedSectionIndex
            if(!this.raiseDisputeMode) {
              this.resetToPreviousSectionResponses(this.selectedSection);
            }
            else {
              this.resetToPreviousQuestionDispute(this.selectedSection);
            }
            this.spinnerService.hide()
          }
        });
    });
    } catch (error) {
      console.error('[IncidentComponent] openSaveAndContinuePopup - Error:', error);
      this.spinnerService.hide();
      return Promise.reject(error);
    }
  } 

  getConsentQuestions() {
    try {
      this.consentQuestions = [];
      
      if (!this.wfSteps || this.wfSteps.length === 0) {
        console.warn('[IncidentComponent] getConsentQuestions - wfSteps is null/undefined/empty');
        return;
      }
      
      this.wfSteps.forEach(step => {
        if (!step || !step.sectionsList || step.sectionsList.length === 0) {
          return;
        }
        
        step.sectionsList.forEach(section => {
          if (!section || section.isSecParentQuestionVisible === false) {
            return;
          }
          
          let filteredSections = this.surveyViewModel && this.surveyViewModel.sections 
            ? this.surveyViewModel.sections.filter(x => x && x.sectionId == section.sectionId) 
            : [];
            
          let findSec = filteredSections.length > 0 ? filteredSections[0] : null;
          
          if (findSec && findSec.questions && findSec.questions.length > 0) {
            let consentQuesList = findSec.questions.filter(q => q && q.isConsentQuestion === true);
            if (consentQuesList && consentQuesList.length > 0) {
              this.consentQuestions.push(...consentQuesList);
            }
          }
        });
      });
    } catch (error) {
      console.error('[IncidentComponent] getConsentQuestions - Error:', error);
    }
  }
  getVisibleSectionIndex(sectionsList: any[], currentIndex: number): number {
    try {
      if (!sectionsList || sectionsList.length === 0) {
        console.warn('[IncidentComponent] getVisibleSectionIndex - sectionsList is null/undefined/empty');
        return 0;
      }
      
      if (currentIndex < 0 || currentIndex >= sectionsList.length) {
        console.warn('[IncidentComponent] getVisibleSectionIndex - currentIndex is out of bounds');
        return 0;
      }
      
      let visibleCount = 0;
      
      for (let i = 0; i <= currentIndex; i++) {
        if (sectionsList[i] && sectionsList[i].isSecParentQuestionVisible) {
          if (i === currentIndex) {
            return visibleCount;
          }
          visibleCount++;
        }
      }
      
      return visibleCount;
    } catch (error) {
      console.error('[IncidentComponent] getVisibleSectionIndex - Error:', error);
      return 0;
    }
  }

  saveAndContinue(action:string='') {
    try {
    this.isSaveAndClose = false;
    let reqNotAnswered =action=='SavePopUp'?false:this.checkAllReqQuesAnswered();
    if (!reqNotAnswered) {
      if (this.surveyViewModel.isWorkflow || this.IsWorkflow) {
        if (this.wfSteps && this.wfSteps[this.selectedStepIndex] && this.wfSteps[this.selectedStepIndex].sectionsList) {
          let visisbleSections = this.wfSteps[this.selectedStepIndex].sectionsList.filter(x=> x["isSecParentQuestionVisible"] == true);
        if (this.selectedSectionIndex === visisbleSections.length - 1) {
          action=='SavePopUp'?this.selectedStepIndex:this.selectedStepIndex++;  //step increment
          action=='SavePopUp'?this.selectedSectionIndex:this.selectedSectionIndex = 0;
        }
        else {
          this.selectedSectionIndex = action=='SavePopUp'?this.selectedSectionIndex : this.selectedSectionIndex + 1; //section increment
        }
        }
        this.isSaveRequired = false;
        //submit & close btn in last step and last section   
        // if (this.selectedStepIndex == this.wfSteps.length - 1) {
        //   if (this.selectedSectionIndex == this.wfSteps[this.selectedStepIndex].sectionsList.length - 1) {
        //     this.isSaveAndClose = true;
        //   }
        // }

        // //check for SubmitClose button visibility
        // if(this.isLastStep() && this.isLastSection()) {
        //   this.isSaveAndClose = true;
        // }

        this.onClickOfSection(this.selectedStepIndex, this.selectedSectionIndex);


       
      }
      else {
        //submit & close btn in  last section 
        if (this.selectedSectionIndex == this.surveyViewModel.sections.length - 1) {
          this.isSaveAndClose = true;
        }
        else {
          this.selectedSectionIndex++; //section increment
        }
        this.onClickOfSection(0, this.selectedSectionIndex);
      }
    }
    else {   
      this.isSaveRequired = false;
       return this.notificationService.showError("The form contains incomplete information.", "Error");
    }
    } catch (error) {
      console.error('[IncidentComponent] saveAndContinue - Error:', error);
      this.spinnerService.hide();
    }
  }
  // resetSectionResponses() {
  //   //pending for sign,upload
  //   //make selected section question responses empty
  //   let index = this.surveyViewModel.sections.indexOf(this.selectedSection);
  //   let section = this.surveyViewModel.sections.filter(x => x.sectionId == this.selectedSection.sectionId)[0];
  //   section.questions.forEach(que => {
  //     que.resetFlag = true;
  //      que["responseText"] = "";
  //     // delete que["responseText"];
  //     if (que.inputType == 'mul' || que.inputType == 'chk' || que.inputType == 'cmb') {
  //       if (que.options.length > 0) {
  //         que.options.forEach(opt => {
  //           opt["selected"] = false;
  //           delete opt["selected"];
  //         })
  //       }
  //     }
  //     else if(que.inputType == 'dte'){
  //       this.cardservice.triggerResetDateOrTime();
  //     }
  //     else if(que.inputType == 'rating'){
  //       this.cardservice.triggerResetDateOrTime();
  //     }
      
  //     else if(que.inputType == 'table') {
  //       que.subQuestions.forEach(subQue => {
  //         subQue.subQuestions.forEach(subSubQue => {
  //           subSubQue.responseText = "";
  //         });
  //       });
  //     }
  //     else if(que.inputType == 'fileupload') {
  //       this.cardservice.triggerResetFile();
  //     }
  //     else if(que.inputType == 'rdo') {

  //       this.GetChildDataAndSetVisibility_NEW(que);
  //     }
  //     else if(que.inputType == 'sign'){
  //       delete que["responseText"];
  //     }

  //     // else if(que.inputType == 'sign'){
  //     //   delete que["responseText"];
  //     // }
  //     else  {       
  //       delete que["responseText"];
  //       //delete que["IsValid"];

  //      // delete  que["selectedDate"];  delete  que["selectedTime"];
        
       
  //     }        

  //     if (que.subQuestions != null && que.subQuestions.length > 0) {
  //       que.subQuestions.forEach(subque => {
  //         subque["responseText"] = "";
  //         if (que.inputType == 'mul' || que.inputType == 'chk' || que.inputType == 'cmb') {
  //           if (subque.options.length > 0) {
  //             subque.options.forEach(subQopt => {
  //               subQopt["selected"] = false;
  //               delete subQopt["selected"];
  //             })
  //           }
  //         }
  //       });
  //     }
  //   });

  //   //make selected section if any grid questions then make grid responses empty
  //   if (section.gridQuestions != null && section.gridQuestions.length > 0) {
  //     section.gridQuestions.forEach(x => {
  //       x["responseText"] = "";
  //     })
  //   }


  //   if (index !== -1) {
  //     this.surveyViewModel.sections[index] = section;
  //   }
  //   this.changeDetectorRef.detectChanges();
  //   this.ToggleSections();
  //   this.isSaveRequired = true;
  // }

  toggleComment($event, question) {
  try{
    if ($event.checked == true) {
      let existingQue = this.questionCommentBackUp.find(x => x.questionId == question.questionId);
      if (existingQue) {
        question.comments = existingQue.comments;
      }
      if (question.comments == null || question.comments == undefined) {
        question.comments = "";
      }
    }
    else {
      question.comments = null;
    }
  }
  catch(ex){
    console.error("Error in toggling comment: ", ex); 
  }
  }
  // saveContinueStep(status: string, selectedbuttontype: string) {
  //   this.buttontype = selectedbuttontype;
  //   this.saveSubmitIncident(status);
  // }
  // saveSubmitIncident(status: string) {
    
  //   this.incidentCreateShouldLog = false; 
  //   this.spinnerService.show();
  //   if (this.isStandaloneSurvey == true) {
  //     this.standaloneSurveyStatus = status;
  //     this.startSurvey();
  //   }
  //   else {
  //     if (this.surveyInstanceId == null || this.surveyInstanceId.length == 0) {
  //       this.incidentCreateShouldLog = true; 
  //       this.createInstanceEntries("", status);
  //     }
  //     else {
  //       this.save(status);
  //     }
  //   }
  // }
  closeDisclaimerPopup() {
    this.hideDisclaimerPopUp = true;
  }
  submitWithDisclaimer() {
    this.hideDisclaimerPopUp = true;
    if (!this.isStandaloneSurvey) {
      // Use current sectional save flow, skip consent check since user already accepted
      this.apiCallForSectionSave('Submit', SurveySubmissionStatus.Submit, true);
    }
    else if (this.isStandaloneSurvey && this.standaloneSurveyDetails != null) {
      this.submitStandaloneSurveyResponse(SurveySubmissionStatus.Submit);
    }
  }
  // submitNew(status: string) {
  //   this.spinnerService.show();
  //   this.surveyResponseClass.surveyId = this.surveyViewModel.surveyId;
  //   this.surveyResponseClass.surveyResponseID = this.surveyResponseId;
  //   this.surveyResponseClass.surveyInstanceId = this.surveyInstanceId;
  //   this.surveyResponseClass.surveySubmissionStatus = status;
  //   this.addedsurveyResponses.forEach(r => {
  //     this.surveyResponseClass.questionResponses.forEach(q => {
  //       if (r["questionId"] == q.questionId) {
  //         q.surveyResponseRelId = r["surveyReponseID"];
  //       }
  //     })
  //   })
  //   // this.surveyResponseClass.lookupInstances = this.lookupInstances;
  //   if (this.surveyViewModel.isWorkflow == true || this.IsWorkflow) {
  //     this.surveyResponseClass.workflowStepId = this.pendingStepId;
  //   }
  //   this.surveyResponseClass.isAnonymousResponse = this.isAnonymusUser;

  //   this.surveyResponseClass.incidentCreateShouldLog = this.incidentCreateShouldLog;
  //   if(this.surveyResponseClass.questionResponses.length > 0){
  //     this.baseHttpService.post(this.constant.SubmitIncidentResponse, this.surveyResponseClass).subscribe((result) => {
  //       if (result != null) {
  //         if (status == 'R') {
  //           this.addedsurveyResponses = result.surveyResponses;
  //           this.notificationService.showSuccess("You have successfully saved your business process.", "Business process Saved!");
  //         }
  //         else {
  //           this.notificationService.showSuccess("You have successfully submitted your business process.", "Business process Submitted!");
  //           this.router.navigate(["/businessProcess"]);
  //           return;
  //           // if (this.isAnonymusUser) {
  //           //   this.router.navigate(["/survey/-99"]);
  //           //   return;
  //           // }
  //         }
  //         if (this.buttontype == "S&C") {
  //           this.saveAndContinue();
  //           this.buttontype = "";
  
  //         }
  //         //  this.onClickOfSection(this.selectedStepIndex,this.selectedSectionIndex);
  //         this.spinnerService.hide();
  //       }
  //       else {
         
  //       }
        
  //     });
  //   }
  //   else{
  //     this.addedsurveyResponses = [];
  //     this.saveAndContinue();
  //     this.buttontype = "";
  //     this.spinnerService.hide();
  //   }
   
  // }

 
  // save(status: string) {
  //   this.signAvailable = false;
  //   let errorFlag = false; let loop = "continue"; this.AllFieldsValid = true;
  //   let errorResponeFlag = false; this.AllResponsesValid = true;

  //   this.surveyViewModel.sections.forEach(sec => {
  //     if (sec.sectionId == this.selectedSection.sectionId) {
  //       sec.questions.forEach(que => {
  //         if (que.isQuestionRequired == 'Y') {
  //           if (que.inputType == 'matrix') {
  //             que.subQuestions.forEach(subQue => {
  //               if (status == 'S' && (subQue.responseText == null || subQue.responseText == undefined || subQue.responseText.length == 0)) {
  //                 errorFlag = true;
  //               }
  //             });
  //           }
  //           else if(que.inputType == 'table') {
  //             que.subQuestions.forEach(subQue => {
  //               subQue.subQuestions.forEach(subSubQue => {
  //                 if ((status == 'S' || status == 'R') && que.isQuestionRequired && (subSubQue.responseText == null || subSubQue.responseText == undefined || subSubQue.responseText.length == 0)) {
  //                   errorFlag = true;
  //                 }
  //               });
  //             });
  //           }
  //           else if(que.inputType == 'fileupload') {
  //             if ((status == 'S' || status == 'R') && (que.responseText == null || que.responseText == undefined || que.responseText.length == 0)) {       
  //               errorFlag = true;
  //             }
  //           }
  //           else {
  //             if ((status == 'S' || status == 'R') && (que.responseText == null || que.responseText == undefined || que.responseText.length == 0)) {
  //               errorFlag = true;
  //             }
  //           }

  //           if (!errorFlag) {
  //             this.AllFieldsValid = this.AllFieldsValid && true;
  //             que.errorMessage = null; que["IsValid"] = true;
  //           }
  //           else {
  //             this.AllFieldsValid = this.AllFieldsValid && false;
  //             que.errorMessage = "Input is mandatory"; que["IsValid"] = false;
  //           }
  //         }
  //         else if(que["IsValid"] == false){
  //           errorResponeFlag = true;        
  
  
  //           if (!errorResponeFlag) {
  //             this.AllResponsesValid = this.AllResponsesValid && true;
  //             que.errorMessage = null; que["IsValid"] = true;
  //           }
  //           else {
  //             this.AllResponsesValid = this.AllResponsesValid && false;
  //             que.errorMessage = "Response is not valid"; que["IsValid"] = false;
  //           }
  //         }
  //       });
  //     }
  //   });

 

  //   if (status == 'S') {
  //     if (this.isStandaloneSurvey || (!this.isStandaloneSurvey && !this.IsWorkflow)) {
  //       let secNotAns = this.surveyViewModel.sections.filter(x => x.sectionDotColor == 'yellow');
  //       if (secNotAns == null || secNotAns.length == 0) {
  //         this.AllFieldsValid = this.AllFieldsValid && true;
  //       }
  //       else {
  //         this.AllFieldsValid = this.AllFieldsValid && false;
  //       }
  //     }
  //     else if (!this.isStandaloneSurvey && this.IsWorkflow) {
  //       let secList: SectionViewModel[] = [];
  //       this.wfSteps.forEach(w => {
  //         w.sectionsList.forEach(s => {
  //           let secFound = this.surveyViewModel.sections.find(x => x.sectionId == s.sectionId);
  //           secList.push(secFound);
  //         })
  //       })
  //       let secNotAns = secList.filter(x => x.sectionDotColor == 'yellow');
  //       if (secNotAns == null || secNotAns.length == 0) {
  //         this.AllFieldsValid = this.AllFieldsValid && true;
  //       }
  //       else {
  //         this.AllFieldsValid = this.AllFieldsValid && false;
  //       }
  //     }
  //   }




  //   if (!this.AllFieldsValid) {
  //     //this.notificationService.showError("There is one or more error on the page", "Error");
  //     this.notificationService.showError("All mandatory questions need to be answered", "Error");
  //     this.spinnerService.hide();
  //     return;
  //   }

  //   if (!this.AllResponsesValid) {   
  //     this.notificationService.showError("Few answered responses are not valid", "Error");
  //     this.spinnerService.hide();
  //     return;
  //   }

  //   //bind user give responses
  //   this.surveyResponseClass.questionResponses = [];
  //   this.surveyViewModel.sections.forEach((obj, index) => {

  //     if (obj.sectionId == this.selectedSection.sectionId) {

  //       obj.questions.forEach((childobj, index) => {
  //         if (((childobj.isParentQuestionVisible == true && childobj.comments != null && childobj.comments != undefined && childobj.comments.trim() != "") || childobj["responseText"] != null && childobj["responseText"] != "") || childobj['rating'] || (childobj["inputType"] == 'matrix')) {
  //           let questionresponsesdata = new QuestionResponsesdata();
  //           questionresponsesdata.questionId = childobj["questionId"];
  //           questionresponsesdata.surveyResponseRelId = childobj["surveyResponseRelId"];
  //           questionresponsesdata.comments = childobj.comments;
  //           if (questionresponsesdata.comments != null && questionresponsesdata.comments.trim() == "") {
  //             questionresponsesdata.comments = null;
  //           }
  //           questionresponsesdata.sequenceNumber = 1;

  //           if (childobj["inputType"] == 'matrix') {
  //             questionresponsesdata.questionReponse = "";
  //           }
  //           questionresponsesdata.questionReponse = childobj["responseText"] ? childobj["responseText"] : childobj['rating'];
  //           this.surveyResponseClass.questionResponses.push(questionresponsesdata);
  //           childobj.subQuestions.forEach(y => {
  //             if (y.responseText) {
  //               let questionresponsesdata = new QuestionResponsesdata();
  //               questionresponsesdata.questionId = y["questionId"];
  //               questionresponsesdata.sequenceNumber = 1;
  //               questionresponsesdata.questionReponse = y["responseText"] ? y["responseText"] : y['rating'];

  //               this.surveyResponseClass.questionResponses.push(questionresponsesdata);
  //             }
  //           });
  //         }

  //         //if (status == "S" && childobj["inputType"] == 'sign' && (childobj["isQuestionRequired"] == "Y" || childobj["isQuestionRequired"] == "true")) {
  //         if (status == "S" && childobj["inputType"] == 'sign') {
  //           if (!childobj["responseText"] && childobj.responseText == undefined && childobj.responseText.length == 0) {
  //             this.signAvailable = false;
  //             this.notificationService.showError("Please provide e-signature", "Error");
  //             return;
  //           }
  //           else {
  //             this.signAvailable = true;
  //           }

  //         }
  //       });
  //       // }     

  //       if (obj.gridQuestions.length > 0) {
  //         obj.gridQuestions.forEach((gridobj, indexgrid) => {
  //           gridobj.response.forEach((responseObj, indexresponse) => {

  //             //if(responseObj["sequenceNumber"]==gridobj.response.length)
  //             //{
  //             responseObj.questions.forEach((childobj, indexque) => {

  //               if ((childobj["responseText"] != null && childobj["responseText"] != "") || childobj['rating'] || (childobj["inputType"] == 'matrix')) {
  //                 let questionresponsesdata = new QuestionResponsesdata();

  //                 if (childobj["inputType"] == 'sign') {
  //                   this.IsAnyESignPresent = true;
  //                   this.signAvailable = true;
  //                 }
  //                 if (childobj["inputType"] == 'matrix') {
  //                   questionresponsesdata.questionReponse = "";
  //                 }
  //                 questionresponsesdata.comments = childobj.comments;
  //                 questionresponsesdata.sequenceNumber = responseObj.sequenceNumber;
  //                 //questionresponsesdata.surveyResponseRelId = responseObj.surveyResponseRelId;
  //                 questionresponsesdata.questionId = gridobj.response[0].questions[indexque].questionId;//childobj["questionId"];
  //                 questionresponsesdata.questionReponse = childobj["responseText"] ? childobj["responseText"] : childobj['rating'];
  //                 questionresponsesdata.surveyResponseRelId = childobj["surveyResponseRelId"];
  //                 this.surveyResponseClass.questionResponses.push(questionresponsesdata);
  //               }
  //             })
  //             // }
  //           })
  //         });
  //       }


  //     }
  //   });


  //   this.surveyResponseClass.surveySubmissionStatus = status;
  //   if (this.IsAnyESignPresent && status != 'R') {
  //     this.hideDisclaimerPopUp = false;
  //   }
  //   else if (this.signAvailable) {
  //     if (status === 'R') {
  //       //this.surveyResponseClass.surveySubmissionStatus = 'R';
  //       this.submitNew(status);
  //     }
  //     else {
  //       this.hideDisclaimerPopUp = false;
  //       this.spinnerService.hide();
  //     }

  //   }
  //   else {
  //     this.submitNew(status);
  //   }
  // }


  submitStandaloneResponse(status: SurveySubmissionStatus) {
    try{
    let errorFlag = false;
    let loop = "continue";
    this.AllFieldsValid = true; this.signAvailable = false;
    let errorResponeFlag = false; this.AllResponsesValid = true;

    this.surveyViewModel.sections.forEach(sec => {
      sec.questions.forEach(que => {
        if (que.isQuestionRequired == 'Y') {
          if (que.inputType == 'matrix') {
            que.subQuestions.forEach(subQue => {
              if (status === SurveySubmissionStatus.Submit && (subQue.responseText == null || subQue.responseText == undefined || subQue.responseText.length == 0)) {
                errorFlag = true;
              }
            });
          }
          else {
            if (status === SurveySubmissionStatus.Submit && (que.responseText == null || que.responseText == undefined || que.responseText.length == 0)) {
              errorFlag = true;
            }
          }

          if (!errorFlag) {
            this.AllFieldsValid = this.AllFieldsValid && true;
            que.errorMessage = null; que["IsValid"] = true;
          }
          else {
            this.AllFieldsValid = this.AllFieldsValid && false;
            que.errorMessage = "Input is mandatory"; que["IsValid"] = false;
          }
        }
        else if(que["IsValid"] == false){
          errorResponeFlag = true;        


          if (!errorResponeFlag) {
            this.AllResponsesValid = this.AllResponsesValid && true;
            que.errorMessage = null; que["IsValid"] = true;
          }
          else {
            this.AllResponsesValid = this.AllResponsesValid && false;
            que.errorMessage = "Response is not valid"; que["IsValid"] = false;
          }
        }
      });
    });

    if (status === SurveySubmissionStatus.Submit) {
      if (this.isStandaloneSurvey) {
        let secNotAns = this.surveyViewModel.sections.filter(x => x.sectionDotColor == 'yellow');
        if (secNotAns == null || secNotAns.length == 0) {
          this.AllFieldsValid = this.AllFieldsValid && true;
        }
        else {
          this.AllFieldsValid = this.AllFieldsValid && false;
        }      

      }
    }

    if (!this.AllFieldsValid) {
      //this.notificationService.showError("There is one or more error on the page", "Error");
      this.notificationService.showError("The form contains incomplete information.", "Error");
      this.spinnerService.hide();
      return;
    }

    if (!this.AllResponsesValid) {   
      this.notificationService.showError("The form contains invalid information", "Error");
      this.spinnerService.hide();
      return;
    }

    if (this.surveyViewModel.isEsignReq) {
      if ((this.signaturePad == undefined || this.signaturePad.isEmpty()) && this.selectedUser.length <= 0) {
        this.notificationService.showError("Please provide e-signature", "Error");
        return;        
      }
      this.IsAnyESignPresent = true;
      if (this.OptionSelectedToDrawSign) {
        this.surveyResponseClass.surveyUserESign = this.signaturePad.toDataURL();
      }
      else {
        let context1 = (this.canvasEl.nativeElement as HTMLCanvasElement);
        this.surveyResponseClass.surveyUserESign = context1.toDataURL();
      }
    }
    
    else {
      this.surveyResponseClass.surveyUserESign = null;
    }

    this.surveyResponseClass.surveyId = this.surveyViewModel.surveyId;
    this.surveyResponseClass.surveyResponseID = this.surveyResponseId;
    this.surveyResponseClass.questionResponses = [];
    this.surveyViewModel.sections.forEach((obj, index) => {

      obj.questions.forEach((childobj, index) => {

        if (((childobj.isParentQuestionVisible == true && childobj.comments != null && childobj.comments != undefined && childobj.comments.trim() != "") || childobj["responseText"] != null && childobj["responseText"] != "") || childobj['rating'] || (childobj["inputType"] == 'matrix')) {
          let questionresponsesdata = new QuestionResponsesdata();
          questionresponsesdata.questionId = childobj["questionId"];
          questionresponsesdata.comments = childobj.comments;
          if (questionresponsesdata.comments != null && questionresponsesdata.comments.trim() == "") {
            questionresponsesdata.comments = null;
          }
          questionresponsesdata.sequenceNumber = 1;
          if (childobj["inputType"] == 'sign') {
            this.IsAnyESignPresent = true; this.signAvailable = true;
          }
          if (childobj["inputType"] == 'matrix') {
            questionresponsesdata.questionReponse = "";
          }
          questionresponsesdata.questionReponse = childobj["responseText"] ? childobj["responseText"] : childobj['rating'];
          questionresponsesdata.surveyResponseRelId = childobj.surveyResponseRelId;

          this.surveyResponseClass.questionResponses.push(questionresponsesdata);
          childobj.subQuestions.forEach(y => {
            if (y.responseText) {
              let questionresponsesdata = new QuestionResponsesdata();
              questionresponsesdata.questionId = y["questionId"];
              questionresponsesdata.sequenceNumber = 1;
              questionresponsesdata.questionReponse = y["responseText"] ? y["responseText"] : y['rating'];
              questionresponsesdata.surveyResponseRelId = y.surveyResponseRelId;
              this.surveyResponseClass.questionResponses.push(questionresponsesdata);
            }
          });
        };

        if (status === SurveySubmissionStatus.Submit && childobj["inputType"] == 'sign') {
          if (!childobj["responseText"] && childobj.responseText == undefined && childobj.responseText.length == 0) {
            this.signAvailable = false;
            this.notificationService.showError("Please provide e-signature", "Error");
            return;
          }
          else {
            this.signAvailable = true;
          }

        }
      });

      obj.gridQuestions.forEach((gridobj, indexgrid) => {
        gridobj.response.forEach((responseObj, indexresponse) => {

          if (responseObj["sequenceNumber"] != gridobj.response.length) {
            responseObj.questions.forEach((childobj, indexque) => {
              if ((childobj["responseText"] != null && childobj["responseText"] != "") || childobj['rating'] || (childobj["inputType"] == 'matrix')) {
                let questionresponsesdata = new QuestionResponsesdata();

                if (childobj["inputType"] == 'sign') {
                  this.IsAnyESignPresent = true; this.signAvailable = true;
                }
                if (childobj["inputType"] == 'matrix') {
                  questionresponsesdata.questionReponse = "";
                }
                questionresponsesdata.comments = childobj.comments;
                questionresponsesdata.sequenceNumber = responseObj.sequenceNumber;
                if (gridobj.response && gridobj.response.length > 0 && gridobj.response[0] && gridobj.response[0].questions && gridobj.response[0].questions.length > indexque) {
                  questionresponsesdata.questionId = gridobj.response[0].questions[indexque].questionId;//childobj["questionId"];
                }
                questionresponsesdata.questionReponse = childobj["responseText"] ? childobj["responseText"] : childobj['rating'];
                questionresponsesdata.surveyResponseRelId = childobj.surveyResponseRelId;
                this.surveyResponseClass.questionResponses.push(questionresponsesdata);
              }
            })
          }
        })
      });
    });

    this.surveyResponseClass.surveySubmissionStatus = status;
    // if (this.IsAnyESignPresent && status != SurveySubmissionStatus.Save) {
    //   this.hideDisclaimerPopUp = false;
    // }   
    if (this.signAvailable) {
      if (status === SurveySubmissionStatus.Save) {
        //this.surveyResponseClass.surveySubmissionStatus = SurveySubmissionStatus.Save;
        this.submitStandaloneSurveyResponse(status);
      }
      else {
        this.hideDisclaimerPopUp = false;
        this.spinnerService.hide();
      }
      //this.submitStandaloneSurveyResponse(status);
    }
    else {
      this.submitStandaloneSurveyResponse(status);
    }}
    catch(ex){ 
      console.error("Error in submitStandaloneResponse: ", ex);
      this.spinnerService.hide();
     }

  }

  submitStandaloneSurveyResponse(status: SurveySubmissionStatus) {
    try{
    this.surveyResponseClass.isAnonymousResponse = this.isAnonymous; /* this.sessionHandleService.getAnonymousUser(); */
    this.addedStandalonesurveyResponses.forEach(r => {
      this.surveyResponseClass.questionResponses.forEach(q => {
        if (r["questionId"] == q.questionId) {
          q.surveyResponseRelId = r["surveyReponseID"];
        }
      })
    })
    //user activity log
    let userActivityObj = this.buildUserActivityOject("Select", (status === SurveySubmissionStatus.Save ? "Survey Responses Save" : "Survey Responses Submit"));
    this.surveyResponseClass.userActivityLog = (userActivityObj != null ? userActivityObj : null);

    this.baseHttpService.post(this.constant.SubmitSurveyResponse, this.surveyResponseClass/* , {observe: 'response',withCredentials: true} */).subscribe((result) => {
      if (result != null) {
        if (status === SurveySubmissionStatus.Save) {
          this.addedStandalonesurveyResponses = result.surveyResponses;
          this.notificationService.showSuccess("You have successfully saved your assessment / survey.", "Assessment / Survey Saved!");
        }
        else {
          this.notificationService.showSuccess("You have successfully submitted your assessment / survey.", "Assessment / Survey Submitted!");
          this.router.navigate(["/dashboard/mysurveydashboard"]);
          // if (this.surveyViewModel.redirectionUrl != null) {
          //   window.location.href = this.surveyViewModel.redirectionUrl;
          //   //this.router.navigateByUrl(this.surveyViewModel.redirectionUrl);
          //   return;
          // }
          // if (this.globalSession.getAnonymousUser() == true) {

          //   this.router.navigate(["/survey/-99"]);
          //   return;
          // }
          return;

        }
        if (this.buttontype == "S&C") {
          this.saveAndContinue();
          this.buttontype = "";

        }

      }
      this.spinnerService.hide();
    });
  }
  catch(ex){
    console.error("Error in submitStandaloneResponse: ", ex);
    this.spinnerService.hide();
  }
  }
  buildUserActivityOject(action: string, actionItem: string): UserActivityLogModel {
    let userActivity = new UserActivityLogModel();
    userActivity.action = action;
    userActivity.actionItem = actionItem;
    return userActivity;
  }

  startSurvey() {
    try{
    if (this.surveyId != null && this.surveyId != "") {
      this.surveyresponseclass.surveyId = this.surveyId;
      //      this.surveyresponseclass.surveyResponseID=this.surveyDetails.res;
      this.surveyresponseclass.groupId = this.globalSession.getGroupId();
      // 
      this.surveyresponseclass.isAnonymousResponse = this.globalSession.getAnonymousUser();

      const httpOptions = {
        // headers: new HttpHeaders({ 'AnonymousId': this.surveyUrlService.getToken() }),
        observe: 'response', withCredentials: true
      };

      this.baseHttpService.post(this.constant.initiateSurveyResponse, this.surveyresponseclass,
        httpOptions /* { observe: 'response', withCredentials : true} */).subscribe((result) => {

          if (result != null) {
            this.surveyResponseId = result.body;
            this.submitStandaloneResponse(this.standaloneSurveyStatus);
          }
        });
    }
  }
  catch(ex){
    console.error("Error in startSurvey: ", ex);
  }
}

  checkAllReqQuesAnswered(): boolean {
    try {
    if (this.isStandaloneSurvey || (!this.isStandaloneSurvey && !this.IsWorkflow)) {
      if (!this.surveyViewModel || !this.surveyViewModel.sections || !this.surveyViewModel.sections[this.selectedSectionIndex]) {
        return false;
      }
      let req = this.surveyViewModel.sections[this.selectedSectionIndex].questions ? this.surveyViewModel.sections[this.selectedSectionIndex].questions.filter(x =>
        x.isQuestionRequired == "Y" &&
        x.inputType !== 'displaytext' &&
        x.inputType !== 'table' &&
        (x.responseText == null || x.responseText == undefined || (typeof x.responseText === 'string' && x.responseText.trim().length === 0))
      ) : [];

      if (this.surveyViewModel.sections[this.selectedSectionIndex].questions && this.surveyViewModel.sections[this.selectedSectionIndex].questions.length > 0) {
        this.surveyViewModel.sections[this.selectedSectionIndex].questions.forEach(q => {
          if (
            q.isQuestionRequired == "Y" &&
            q.inputType !== 'displaytext' &&
            q.inputType !== 'table' &&
            (q.responseText == null || q.responseText == undefined || (typeof q.responseText === 'string' && q.responseText.trim().length === 0))
          ) {
            q.errorMessage = 'Input is Manadatory';
          }
        });
      }

      let gridreq: any = [];
      if (this.surveyViewModel.sections[this.selectedSectionIndex].gridQuestions && this.surveyViewModel.sections[this.selectedSectionIndex].gridQuestions.length > 0) {
        this.surveyViewModel.sections[this.selectedSectionIndex].gridQuestions.forEach(g => {
          if (g.response && g.response.length > 0) {
            g.response.forEach(r => {
              if (r.questions && r.questions.length > 0) {
                r.questions.forEach(q => {
                  if (
                    q.isQuestionRequired == "Y" &&
                    q.inputType !== 'displaytext' &&
                    r.sequenceNumber > 0 &&
                    (q.responseText == null || q.responseText == undefined || (typeof q.responseText === 'string' && q.responseText.trim().length === 0))
                  ) {
                    q.errorMessage = 'Input is Manadatory';
                    gridreq.push(q);
                  }
                })
              }
            })
          }
        });
      }

      return ((req != null && req.length > 0) || (gridreq != null && gridreq.length > 0)) ? true : false;
    }
    else if (!this.isStandaloneSurvey && this.IsWorkflow) {
      if (!this.wfSteps || !this.wfSteps[this.selectedStepIndex] || !this.wfSteps[this.selectedStepIndex].sectionsList || !this.wfSteps[this.selectedStepIndex].sectionsList[this.selectedSectionIndex]) {
        return false;
      }
      let secId = this.wfSteps[this.selectedStepIndex].sectionsList[this.selectedSectionIndex].sectionId;
      let section = this.surveyViewModel.sections.find(s => s.sectionId == secId);
      if (!section || !section.questions) {
        return false;
      }
      let visibleQuestions = section.questions.filter(x=> x.isParentQuestionVisible == true);

      if (!visibleQuestions || visibleQuestions.length === 0) {
        return false;
      }

      let req = visibleQuestions.filter(x =>
        x.isQuestionRequired == "Y" &&
        x.inputType !== 'displaytext' &&
        x.inputType !== 'table' &&
        (x.responseText == null || x.responseText == undefined || (typeof x.responseText === 'string' && x.responseText.trim().length === 0))
      );

      visibleQuestions.forEach(q => {
        if (
          q.isQuestionRequired == "Y" &&
          q.inputType !== 'displaytext' &&
          q.inputType !== 'table' &&
          (q.responseText == null || q.responseText == undefined || (typeof q.responseText === 'string' && q.responseText.trim().length === 0))
        ) {
          q.errorMessage = 'Input is Manadatory';
        }
      });

      /** Grid questions no more stored inside section.gridQuestions **/ 
      // let gridreq: any = [];
      // if (section.gridQuestions.length > 0) {
      //   section.gridQuestions.forEach(g => {
      //     g.response.forEach(r => {
      //       r.questions.forEach(q => {
      //         if (
      //           q.isQuestionRequired == "Y" &&
      //           q.dataType !== 'displaytext' &&
      //           r.sequenceNumber > 0 &&
      //           (q.responseText == null ||q.responseText.trim().length === 0|| q.responseText.length == 0 || q.responseText == undefined)
      //         ) {
      //           q.errorMessage = 'Input is Manadatory';
      //           gridreq.push(q);
      //         }
      //       })
      //     })
      //   });
      // }

      // return ((req != null && req.length > 0) || (gridreq != null && gridreq.length > 0)) ? true : false;

      return (req != null && req.length > 0) ? true : false;

    }
    return false;
    } catch (error) {
      console.error('[IncidentComponent] checkAllReqQuesAnswered - Error:', error);
      return false;
    }
  }
  // setSectionDotColor() {
  //   let secFlag: boolean = false; let finalFlag = true;
  //   if (this.isStandaloneSurvey || (!this.isStandaloneSurvey && !this.IsWorkflow)) {
  //     if (this.surveyViewModel != null && this.surveyViewModel.sections.length > 0) {

       
  //       this.surveyViewModel.sections.forEach(s => {
  //         secFlag = false; finalFlag = true;
  //         s.questions.forEach(c => {
  //           if (c.isQuestionRequired == 'Y') {
  //             if (c.inputType == 'matrix') {
  //               c.subQuestions.forEach(sub => {
  //                 if ((sub.responseText == null || sub.responseText.length == 0 || sub.responseText == undefined)) {
  //                   secFlag = true;
  //                 }
  //                 else {
  //                   c.errorMessage = "";
  //                 }
  //               })
  //             }
  //             else {
  //               if ((c.responseText == null || c.responseText.length == 0 || c.responseText == undefined)) {
  //                 secFlag = true;
  //               }
  //               else {
  //                 if (c.inputType == 'fileupload') {
  //                   let resp = JSON.parse(c.responseText); let listFiles: any = [];
  //                   if (resp.ContainerName != undefined && resp.ContainerName.length > 0) {
  //                     listFiles = resp['Files'];
  //                   }
  //                   else {
  //                     listFiles = resp;
  //                   }


  //                   if (listFiles.length == 0) {
  //                     secFlag = true;
  //                   }
  //                 }
  //               }

  //             }


  //             if (!secFlag) {
  //               finalFlag = finalFlag && true;
  //             }
  //             else {
  //               finalFlag = finalFlag && false;
  //             }

  //           }
  //         })
  //         // let req = s.questions.filter(q=> q.isQuestionRequired == 'Y'&& (q.responseText == null || q.responseText.length == 0 || q.responseText == undefined));       
  //         // s.sectionDotColor = (req != null && req.length > 0) ? "red" : "green";

  //         s.gridQuestions.forEach(g => {
  //           g.response.forEach(r => {
  //             secFlag = false; finalFlag = true;
  //             r.questions.forEach(c => {
  //               if (c.isQuestionRequired == 'Y') {
  //                 if (r.sequenceNumber > 0 && (c.responseText == null || c.responseText.length == 0 || c.responseText == undefined)) {
  //                   secFlag = true;
  //                 }
  //                 else {
  //                   if (c.inputType == 'fileupload') {
  //                     let resp = JSON.parse(c.responseText); let listFiles: any = [];
  //                     if (resp.ContainerName != undefined && resp.ContainerName.length > 0) {
  //                       listFiles = resp['Files'];
  //                     }
  //                     else {
  //                       listFiles = resp;
  //                     }


  //                     if (listFiles.length == 0) {
  //                       secFlag = true;
  //                     }
  //                   }
  //                 }


  //                 if (!secFlag) {
  //                   finalFlag = finalFlag && true;
  //                 }
  //                 else {
  //                   finalFlag = finalFlag && false;
  //                 }

  //               }
  //             })
  //           })
  //         })

  //         s.sectionDotColor = (!finalFlag) ? "yellow" : "green";
  //       });
  //     }
  //   }
  //   else if (!this.isStandaloneSurvey && this.IsWorkflow) {
      
  //     if (this.wfSteps.length > 0) {
  //       this.wfSteps.forEach(w => {
  //         w.sectionsList.forEach(s => {
  //           if (this.surveyInstanceId == null || this.surveyInstanceId.length == 0) {
  //             s.sectionDotColor = (s.hasValidation) ? "yellow" : "green";
  //           }
  //           else if (this.globalSession.getViewIconFlag()) {
  //             s.sectionDotColor = "green";
  //           }
  //           else if (this.surveyInstanceId != null && this.surveyInstanceId.length > 0) {
  //             let secFound = this.surveyViewModel.sections.find(x => x.sectionId == s.sectionId);
  //             secFlag = false; finalFlag = true;
  //             if (secFound != null) {
  //               secFound.questions.forEach(e => {
  //                 if (e.isQuestionRequired == "Y") {
  //                   if (e.inputType == 'matrix') {
  //                     e.subQuestions.forEach(sub => {
  //                       if ((sub.responseText == null || sub.responseText.length == 0 || sub.responseText == undefined)) {
  //                         secFlag = true;
  //                       }
  //                       else {
  //                         e.errorMessage = "";
  //                       }
  //                     })
  //                   }
  //                   else if (e.inputType == 'fileupload') {
  //                     let resp = JSON.parse(e.responseText); let listFiles: any = [];
  //                     if (resp.ContainerName != undefined && resp.ContainerName.length > 0) {
  //                       listFiles = resp['Files'];
  //                     }
  //                     else {
  //                       listFiles = resp;
  //                     }
  //                     secFlag = (listFiles.length == 0) ? true : false;
  //                   }
  //                   else {
  //                     secFlag = ((e.responseText == null || e.responseText.length == 0 || e.responseText == undefined)) ? true : false;
  //                   }
  //                   finalFlag = (!secFlag) ? (finalFlag && true) : (finalFlag && false);
  //                 }
  //                 else {
  //                   s.sectionDotColor = "green";
  //                 }
  //               })

  //               if (secFound.gridQuestions.length > 0) {
  //                 this.selectedSection.gridQuestions.forEach(g => {
  //                   g.response.forEach(r => {
  //                     secFlag = false; finalFlag = true;
  //                     r.questions.forEach(e => {
  //                       if (e.isQuestionRequired == "Y") {
  //                         if (e.inputType == 'matrix') {
  //                           e.subQuestions.forEach(sub => {
  //                             if ((sub.responseText == null || sub.responseText.length == 0 || sub.responseText == undefined)) {
  //                               secFlag = true;
  //                             }
  //                             else {
  //                               e.errorMessage = "";
  //                             }
  //                           })
  //                         }
  //                         else if (e.inputType == 'fileupload') {
  //                           let resp = JSON.parse(e.responseText); let listFiles: any = [];
  //                           if (resp.ContainerName != undefined && resp.ContainerName.length > 0) {
  //                             listFiles = resp['Files'];
  //                           }
  //                           else {
  //                             listFiles = resp;
  //                           }
  //                           secFlag = (listFiles.length == 0) ? true : false;
  //                         }
  //                         else {
  //                           secFlag = ((e.responseText == null || e.responseText.length == 0 || e.responseText == undefined)) ? true : false;
  //                         }
  //                         finalFlag = (!secFlag) ? (finalFlag && true) : (finalFlag && false);
  //                       }
  //                       else {
  //                         s.sectionDotColor = "green";
  //                       }
  //                     })
  //                   })
  //                 })
  //               }
  //             }

  //             s.sectionDotColor = (!finalFlag) ? "yellow" : "green";
  //           }



  //           if (this.selectedSection != null && s.sectionId == this.selectedSection.sectionId) {
  //             secFlag = false; finalFlag = true;

  //             this.selectedSection.questions.forEach(e => {
  //               if (e.isQuestionRequired == "Y") {
  //                 if (e.inputType == 'matrix') {
  //                   e.subQuestions.forEach(sub => {
  //                     if ((sub.responseText == null || sub.responseText.length == 0 || sub.responseText == undefined)) {
  //                       secFlag = true;
  //                     }
  //                     else {
  //                       e.errorMessage = "";
  //                     }
  //                   })
  //                 }
  //                 else if (e.inputType == 'fileupload') {
  //                   let resp = JSON.parse(e.responseText); let listFiles: any = [];
  //                   if (resp.ContainerName != undefined && resp.ContainerName.length > 0) {
  //                     listFiles = resp['Files'];
  //                   }
  //                   else {
  //                     listFiles = resp;
  //                   }
  //                   secFlag = (listFiles.length == 0) ? true : false;
  //                 }
  //                 else {
  //                   secFlag = ((e.responseText == null || e.responseText.length == 0 || e.responseText == undefined)) ? true : false;
  //                 }
  //                 finalFlag = (!secFlag) ? (finalFlag && true) : (finalFlag && false);
  //               }
  //               else {
  //                 s.sectionDotColor = "green";
  //               }
  //             })

  //             if (this.selectedSection.gridQuestions.length > 0) {
  //               this.selectedSection.gridQuestions.forEach(g => {
  //                 g.response.forEach(r => {
  //                   secFlag = false; finalFlag = true;
  //                   r.questions.forEach(e => {
  //                     if (e.isQuestionRequired == "Y") {
  //                       if (e.inputType == 'matrix') {
  //                         e.subQuestions.forEach(sub => {
  //                           if ((sub.responseText == null || sub.responseText.length == 0 || sub.responseText == undefined)) {
  //                             secFlag = true;
  //                           }
  //                           else {
  //                             e.errorMessage = "";
  //                           }
  //                         })
  //                       }
  //                       else if (e.inputType == 'fileupload') {
  //                         let resp = JSON.parse(e.responseText); let listFiles: any = [];
  //                         if (resp.ContainerName != undefined && resp.ContainerName.length > 0) {
  //                           listFiles = resp['Files'];
  //                         }
  //                         else {
  //                           listFiles = resp;
  //                         }
  //                         secFlag = (listFiles.length == 0) ? true : false;
  //                       }
  //                       else {
  //                         secFlag = ((e.responseText == null || e.responseText.length == 0 || e.responseText == undefined)) ? true : false;
  //                       }
  //                       finalFlag = (!secFlag) ? (finalFlag && true) : (finalFlag && false);
  //                     }
  //                     else {
  //                       s.sectionDotColor = "green";
  //                     }
  //                   })
  //                 })
  //               })
  //             }
  //             s.sectionDotColor = (!finalFlag) ? "yellow" : "green";
  //           }
  //         })
  //       })
  //     }
  //   }

  // }

  setSectionDotColor_NEW() {  
    try{
    let secFlag: boolean = false; let finalFlag = true;
    if (this.isStandaloneSurvey || (!this.isStandaloneSurvey && !this.IsWorkflow)) {
      if (this.surveyViewModel != null && this.surveyViewModel.sections && this.surveyViewModel.sections.length > 0) {

        this.surveyViewModel.sections.forEach(s => {
          secFlag = false; finalFlag = true;
          if(s.questions && s.questions.length > 0){
            s.questions.forEach(c => {
              if (c.isQuestionRequired == 'Y') {
                if (c.inputType == 'matrix' && c.subQuestions && c.subQuestions.length > 0) {
                  c.subQuestions.forEach(sub => {
                    if ((sub.responseText == null || sub.responseText.length == 0 || sub.responseText == undefined)) {
                      secFlag = true;
                    }
                    else {
                      c.errorMessage = "";
                    }
                  })
                }
                if(c.inputType == 'table') {
                  c.subQuestions.forEach(sub => {
                    sub.subQuestions.forEach(subsub => {
                      if ((subsub.responseText == null || subsub.responseText.length == 0 || subsub.responseText == undefined)) {
                        secFlag = true;
                      }
                    });
                  });
                }
                else {
                  if ((c.responseText == null || c.responseText.length == 0 || c.responseText == undefined)) {
                    secFlag = true;
                  }
                  else {
                    if (c.inputType == 'fileupload' && c.responseText) {
                      try {
                        let resp = JSON.parse(c.responseText); let listFiles: any = [];
                        if (resp && resp.ContainerName != undefined && resp.ContainerName.length > 0) {
                        listFiles = resp['Files'];
                      }
                      else {
                        listFiles = resp;
                      }
  
  
                      if (listFiles.length == 0) {
                        secFlag = true;
                      }
                      } catch (e) {
                        console.error('[IncidentComponent] Error parsing file upload response:', e);
                        secFlag = true;
                      }
                    }
                  }
  
                }
  
  
                if (!secFlag) {
                  finalFlag = finalFlag && true;
                }
                else {
                  finalFlag = finalFlag && false;
                }
  
              }
            })
            if(s.gridQuestions && s.gridQuestions.length > 0){
              s.gridQuestions.forEach(g => {
                g.response.forEach(r => {
                  secFlag = false; finalFlag = true;
                  r.questions.forEach(c => {
                    if (c.isQuestionRequired == 'Y') {
                      if (r.sequenceNumber > 0 && (c.responseText == null || c.responseText.length == 0 || c.responseText == undefined)) {
                        secFlag = true;
                      }
                      else {
                        if (c.inputType == 'fileupload' && c.responseText) {
                          try {
                            let resp = JSON.parse(c.responseText); let listFiles: any = [];
                            if (resp && resp.ContainerName != undefined && resp.ContainerName.length > 0) {
                              listFiles = resp['Files'];
                            }
                            else {
                              listFiles = resp;
                            }
      
      
                            if (listFiles.length == 0) {
                              secFlag = true;
                            }
                          } catch (e) {
                            console.error('[IncidentComponent] Error parsing file upload response:', e);
                            secFlag = true;
                          }
                        }
                      }
    
                      if (!secFlag) {
                        finalFlag = finalFlag && true;
                      }
                      else {
                        finalFlag = finalFlag && false;
                      }
    
                    }
                  })
                })
              })
            }
          }         
          else{
            finalFlag = s.hasValidation ? false : true;
          }        
          s.sectionDotColor = (!finalFlag) ? "yellow" : "green";
        });
      }
    }
    else if (!this.isStandaloneSurvey && this.IsWorkflow) {
      if (this.wfSteps && this.wfSteps.length > 0) {
        this.wfSteps.forEach(w => {
          if (w && w.sectionsList && w.sectionsList.length > 0) {
            w.sectionsList.forEach(s => {
            let secFound = this.surveyViewModel.sections.find(x => x.sectionId == s.sectionId);
            // let req = secFound.questions.filter(q=> q.isQuestionRequired == 'Y' && (q.responseText == null || q.responseText.length == 0 || q.responseText == undefined));  
            // s.sectionDotColor = (req != null && req.length > 0) ? "red" : "green";

            secFlag = false; finalFlag = true;
            if (secFound != null) {
              if(secFound.questions.length > 0){
                let visibleQuestions = secFound.questions.filter(x=> x.isParentQuestionVisible == true);
                visibleQuestions.forEach(c => {
                  if(c.inputType != 'displaytext') {
                  if (c.isQuestionRequired == 'Y') {
                    if (c.inputType == 'matrix') {
                      c.subQuestions.forEach(sub => {
                        if ((sub.responseText == null || sub.responseText.length == 0 || sub.responseText == undefined)) {
                          secFlag = true;
                        }
                      })
                    }
                if(c.inputType == 'table') {
                     
                      if(c.responseText && c.responseText.length > 0){
                        c.responses = JSON.parse(c.responseText);
                      }

                      if (c.dataType == 'dynamic-grid') {
                        if((!c.responses || c.responses.length == 0)){
                          secFlag = true;
                        }
                        else {
                          c.responses.forEach(row => {
                            row.questions.forEach(subQue => {
                              if ((subQue.isQuestionRequired === 'Y') && (!subQue.responseText || subQue.responseText.trim().length === 0)) {
                                secFlag = true;
                              }
                              else if(subQue.responseText && subQue.responseText.trim().length > 0 && subQue["IsValid"] === false){
                                secFlag = true;
                              }
                            });
                          });
                        }
                      }
                      else {
                        // fixed-grid
                        c.subQuestions.forEach(sub => {
                          sub.subQuestions.forEach(subsub => {
                            if ((subsub.responseText == null || subsub.responseText.length == 0 || subsub.responseText == undefined)) {
                              secFlag = true;
                            }
                          });
                        });
                      }
                  }
                    else {
                      if ((c.responseText == null || c.responseText.length == 0 || c.responseText == undefined)) {
                        secFlag = true;
                      }
                      else {
                        if (c.inputType == 'fileupload') {
                          let resp = JSON.parse(c.responseText); let listFiles: any = [];
                          if (resp.ContainerName != undefined && resp.ContainerName.length > 0) {
                            listFiles = resp['Files'];
                          }
                          else {
                            listFiles = resp;
                          }
  
  
                          if (listFiles.length == 0) {
                            secFlag = true;
                          }
                        }
                      }
                    }
  
                    finalFlag = (!secFlag) ? (finalFlag && true) : (finalFlag && false);
                  }
                  else if(c.inputType === 'table' && (!c.parentQuestionGuid || c.isParentQuestionVisible)){
                    if(c.dataType == 'fixed-grid' && c.subQuestions && c.subQuestions.length > 0){
                      c.subQuestions.forEach(sub => {
                        sub.subQuestions.forEach(subsub => {
                          if (subsub.isQuestionRequired == 'Y' &&(subsub.responseText == null || subsub.responseText.length == 0 || subsub.responseText == undefined)) {
                            secFlag = true;
                          }
                        });
                      });
                    }
                    else if(c.dataType === 'dynamic-grid' && c.isQuestionRequired !='C'){
                     
                       if(c.responseText && c.responseText.length > 0){
                        c.responses = JSON.parse(c.responseText);
                      }

                      // Additionally check subQuestion-level required flags
                      if(c.responses && c.responses.length > 0) {
                        c.responses.forEach(sub => {
                          sub.questions.forEach(subsub => {
                            if (subsub.isQuestionRequired == 'Y' &&(subsub.responseText == null || subsub.responseText.length == 0 || subsub.responseText == undefined)) {
                              secFlag = true;
                            }
                          });
                        });
                      }
                    }
                  }
                }
                })     

              }             
              else{
                finalFlag = secFound.hasValidation ? false : true;
              }             
            }
            s.sectionDotColor = (!finalFlag) ? "yellow" : "green";

          });
          }
        });     
      }     
    }}
    catch(ex){
      console.error("Error in setSectionDotColor_NEW: ", ex);
    }

    // Override dot color to red for sections with unmet measures (dispute mode only)
    this.applyFailedMeasureRedDots();
  }

  async checkEntityInstances() {
    try{
    //this.spinnerService.show();
    this.dataEntityInstanceSource = new MatTableDataSource([]);
    this.noLookUpInstances = false; this.showEntityInstancePopUp = false;
    //console.log(this.selectedSection);
    if (this.selectedSection != null && this.selectedSection.sectionLookUpEntityId != null && this.selectedSection.sectionLookUpEntityId.length > 0) {
      this.showEntityInstancePopUp = true;
      this.entitySearchModel = new entitySearchModel();
      this.entitySearchModel.entityId = this.selectedSection.sectionLookUpEntityId;
      this.entitySearchModel.pageNumber = this.pageIndex;
      this.entitySearchModel.pageSize = 5;//this.size;
      //await this.GetLookUpEntityDetails(this.entitySearchModel);
      await this.lookupEntityInstances(this.entitySearchModel);
      //get instances
      // await this.baseHttpService.getById(this.constant.getEntityInstancesList, this.selectedSection.sectionLookUpEntityId).subscribe(result => {
      //   console.log(result);
      //   if (result != null && result.length > 0) {
      //     this.lookUpEntityInstancesList = result;
      //   }
      //   else {
      //     this.noLookUpInstances = true;
      //   }
      //   this.spinnerService.hide();
      // });
    }
    else {
      this.spinnerService.hide();
      this.notificationService.showError("Cannot show instances, as look up entity doesn't have any instances created yet.", "Error!");
    }
  }
  catch(ex){
    console.error("Error in checkEntityInstances: ", ex);
    this.spinnerService.hide();}

  }
  // onChangeEntityInstance(event, i) {
  //   this.selectedEntityInstance = this.lookUpEntityInstancesList[i];
  // }
  ok() {
    try {
    this.spinnerService.show();
    this.lookupInstances = [];
    this.showEntityInstancePopUp = false; this.lookUpDisplayInfo = false;
    
    if (!this.selectedEntityInstanceElement || !this.selectedEntityInstanceElement.value) {
      console.warn('[IncidentComponent] ok - selectedEntityInstanceElement or value is null/undefined');
      this.spinnerService.hide();
      return;
    }
    
    let instanceSurveyId = this.selectedEntityInstanceElement.value['SurveyId'];
    if (this.selectedEntityInstanceId != null && this.selectedEntityInstanceId.length > 0
      && instanceSurveyId != null && instanceSurveyId.length > 0) {
      //navigate to edit page with responses 
      // this.editSurveyInstance(this.selectedEntityInstance.surveyInstance.surveyInstanceId);
      this.editSurveyInstance(this.selectedEntityInstanceId, instanceSurveyId);
      
      if (this.selectedEntityInstanceElement.value['EntityInstanceId']) {
        this.lookupInstances.push(this.selectedEntityInstanceElement.value['EntityInstanceId']);
      }


      // //store display info details
      // if (this.infoBarFields.length > 0 && this.selectedEntityInstanceElement != null) {
      //   let elementCopy = this.selectedEntityInstanceElement;
      //   let keyslist = Object.keys(this.selectedEntityInstanceElement.value);
      //   let fieldNameList: string[] = [];
      //   this.infoBarFields.forEach(x => fieldNameList.push(x.entityFieldName));
      //   keyslist.forEach(x => {
      //     if (!fieldNameList.includes(x)) {
      //       delete elementCopy.value[x];
      //     }
      //   })
      //   this.cardservice.getDisplayInfoBarDetails(elementCopy);
      //   this.isStandaloneSurvey = false;this.surveyInstanceId = elementCopy.label;
      //   this.lookUpDisplayInfo = true;
      //   this.getDisplayInfoDetails();
      // }

    }
    else {
      this.spinnerService.hide();
    }
    } catch (error) {
      console.error('[IncidentComponent] ok - Error:', error);
      this.spinnerService.hide();
    }
  }
  closeInstancePopUp() {
    this.showEntityInstancePopUp = false; this.selectedEntityInstanceElement = null;
    this.selectedEntityInstanceId = "";
  }
  editSurveyInstance(selectedSurveyInstanceId: string, instSurveyId: string) {
    try {
    // this.baseHttpService.getById(this.constant.getProcessIncidentResponses, this.entitySurveyId + "/" + false + "/" + selectedSurveyInstanceId).subscribe(results => {
    this.baseHttpService.getById(this.constant.getProcessIncidentResponses, instSurveyId + "/" + false + "/" + selectedSurveyInstanceId).subscribe(results => {
      let response = new SurveyUserResponse();
      if (results != null) {
        let filteredResponses = results.userResponses.filter(x => x.surveyInstanceId == selectedSurveyInstanceId);
        response = filteredResponses.length > 0 ? filteredResponses[0] : null;
        if (response) {
          this.MapLookUpsectionResponses(response);
        }
        // this.spinnerService.hide();
      }

      //store display info details
      if (this.infoBarFields.length > 0 && this.selectedEntityInstanceElement != null) {
        let elementCopy = this.selectedEntityInstanceElement;
        let keyslist = Object.keys(this.selectedEntityInstanceElement.value);
        let fieldNameList: string[] = [];
        this.infoBarFields.forEach(x => fieldNameList.push(x.entityFieldName));
        keyslist.forEach(x => {
          if (!fieldNameList.includes(x)) {
            delete elementCopy.value[x];
          }
        })
        this.cardservice.getDisplayInfoBarDetails(elementCopy);
        this.isStandaloneSurvey = false;//this.surveyInstanceId = elementCopy.label;
        this.lookUpDisplayInfo = true;
        this.getDisplayInfoDetails();
      }
      this.spinnerService.hide();
    });
    } catch (error) {
      console.error('[IncidentComponent] editSurveyInstance - Error:', error);
      this.spinnerService.hide();
    }
  }
  async GetLookUpEntityDetails(entitySearchModel) {
    try {
    this.spinnerService.show();
    const entityDetails$ = this.baseHttpService.getById(this.constant.getProcessEntities, this.businessProcessId);
    const entityInstances$ = this.baseHttpService.post(this.constant.getEntityInstancesList, entitySearchModel);

    forkJoin([entityDetails$, entityInstances$]).subscribe(results => {
      if (results != null) {
        if (results[0] != null && results[0].length > 0 && this.selectedSection) {
          this.entityDetails = results[0].find(x => x.entityID == this.selectedSection.sectionLookUpEntityId);
          if (this.entityDetails && this.entityDetails.entityFields) {
            this.entityFields = this.entityDetails.entityFields;
            this.searchableFields = []; this.resultFields = []; this.infoBarFields = [];
            if (this.entityFields && this.entityFields.length > 0) {
              this.entityFields.forEach(ef => {
                if (ef && ef.fieldProperties && ef.fieldProperties.length > 0) {
                  ef.fieldProperties.forEach(p => {
                    if (p && p.propertyDetails) {
                      if (p.propertyDetails.propertyName == "Searchable" && p.propertyValue == "1") {
                        let filteredSearch = this.searchableFields.filter(x => x.entityFieldID == ef.entityFieldID);
                        let itemFoundSearch = filteredSearch.length > 0 ? filteredSearch[0] : null;
                        if (itemFoundSearch == null) {
                          this.searchableFields.push(ef);
                        }
                      }
                      if (p.propertyDetails.propertyName == "Display In Results" && p.propertyValue == "1") {
                        let filteredResult = this.resultFields.filter(x => x.entityFieldID == ef.entityFieldID);
                        let itemFound = filteredResult.length > 0 ? filteredResult[0] : null;
                        if (itemFound == null) {
                          this.resultFields.push(ef);
                        }
                      }
                      if (p.propertyDetails.propertyName == "Display in info-bar" && p.propertyValue == "1") {
                        let filteredInfoBar = this.infoBarFields.filter(x => x.entityFieldID == ef.entityFieldID);
                        let itemFound = filteredInfoBar.length > 0 ? filteredInfoBar[0] : null;
                        if (itemFound == null) {
                          this.infoBarFields.push(ef);
                        }
                      }
                    }
                  });
                }
              });
            }
          }
        }


        if (results[1] != null) {
          //this.lookUpEntityInstancesList = results[1];
          this.instancesFieldData = results[1].elementList;
          if (results[1].elementList != null && results[1].elementList.length > 0) {
            this.totalItems = this.instancesFieldData.pageCount * this.size;

            this.displayedEntityInstanceColumns = this.resultFields.map(s => s.entityFieldName);
            //this.displayedEntityInstanceColumns.push("EntityInstanceId");
            //this.displayedEntityInstanceColumns.push("EntityInstanceName");
            this.displayedEntityInstanceColumns.push("CreatedByUserName");
            this.displayedEntityInstanceColumns.push("Created On");
            this.displayedEntityInstanceColumns.push("Icon");
            //console.log("instancesFieldData", this.instancesFieldData);
            this.dataEntityInstanceSource = new MatTableDataSource(this.instancesFieldData);
          }
          else {
            this.displayedEntityInstanceColumns = [];
            this.dataEntityInstanceSource = new MatTableDataSource([]);
          }
        }
        else {
          this.noLookUpInstances = true;
        }
        this.spinnerService.hide();
      }
    });
    } catch (error) {
      console.error('[IncidentComponent] GetLookUpEntityDetails - Error:', error);
      this.spinnerService.hide();
    }
  }
  MapLookUpsectionResponses(response) {
    try {
    if (!this.surveyViewModel || !this.surveyViewModel.sections || !this.selectedSection) {
      console.warn('[IncidentComponent] MapLookUpsectionResponses - surveyViewModel, sections, or selectedSection is null/undefined');
      return;
    }
    
    let lookUpsec = this.surveyViewModel.sections.find(x => x.sectionId == this.selectedSection.sectionId);
    if (lookUpsec != null && response != null && response.responses) {
      this.isSectionReadOnly = true;
      
      if (lookUpsec.questions && lookUpsec.questions.length > 0) {
        lookUpsec.questions.forEach(q => {
          let qResponse: any;
          if (this.selectedEntityInstanceElement && this.selectedEntityInstanceElement.value && this.selectedEntityInstanceElement.value['IsLookUpInstance'] == true) {
            qResponse = response.responses.find(x => x.questionId == q.lookUpQuestionId);
          }
          else {
            qResponse = response.responses.find(x => x.entityFieldId == q.entityFieldId);
          }

          if (qResponse) {
            q["responseText"] = qResponse.responseText;
            q["comments"] = qResponse.comments;
            q["surveyResponseRelId"] = qResponse.surveyResponseRelId;
            //q["responseReadOnly"] = qResponse.responseReadOnly;
            //q["responseReadOnly"] = true;

            let quesComments = new QuestionResponsesdata();
            quesComments.comments = qResponse.comments;
            quesComments.questionId = qResponse.questionId;
            quesComments.questionReponse = qResponse.responseText;
            quesComments.surveyResponseRelId = qResponse.surveyResponseRelId;
            this.questionCommentBackUp.push(quesComments);
          }
        })
      }
    }
    } catch (error) {
      console.error('[IncidentComponent] MapLookUpsectionResponses - Error:', error);
    }
  }
  onSelectingEntityInstance(event, element) {
    //console.log(element);
    this.selectedEntityInstanceId = "";
    if (element.label != null && element.label.length > 0) {
      this.selectedEntityInstanceId = element.label;
      this.selectedEntityInstanceElement = element;
    }
  }
  onSearch(event, field: EntityField) {
    try {
    if (!event || !event.target || !field || !this.entitySearchModel) {
      console.warn('[IncidentComponent] onSearch - event, event.target, field, or entitySearchModel is null/undefined');
      return;
    }
    
    //set search model selected filters
    this.entitySearchModel.entityId = field.entityId;
    if (this.entitySearchModel.filters == undefined || this.entitySearchModel.filters.length == 0) {
      this.entitySearchModel.filters = [];
      if (event.target.value && event.target.value.length > 0) {
        let filt = new SearchFilter();
        filt.key = field.entityFieldName; filt.value = event.target.value;
        this.entitySearchModel.filters.push(filt);
      }
    }
    else if (this.entitySearchModel.filters.length > 0) {
      let itemIndex = this.entitySearchModel.filters.findIndex(x => x.key == field.entityFieldName);
      if (itemIndex != -1) {
        this.entitySearchModel.filters[itemIndex].value = event.target.value;
      }
      else {
        let filt = new SearchFilter();
        filt.key = field.entityFieldName; filt.value = event.target.value;
        this.entitySearchModel.filters.push(filt);
      }
    }
    } catch (error) {
      console.error('[IncidentComponent] onSearch - Error:', error);
    }
  }
  applySearch(event) {
    try {
      if (!this.entitySearchModel) {
        return;
      }
      
      let filteredData: any = [];
      if (this.entitySearchModel.filters != undefined && this.entitySearchModel.filters.length > 0) {

        let itemsFoundList: any = [];
        if (this.instancesFieldData && this.instancesFieldData.length > 0) {
          this.instancesFieldData.forEach(dt => {
            if (!dt || !dt.value) {
              return;
            }
            
            let trueCount: number = 0;
            this.entitySearchModel.filters.forEach(entry => {
              if (!entry || !entry.key) {
                return;
              }
              
              let ss: string = dt.value[entry.key];
              if (ss != undefined && entry.value != undefined && (ss.toLowerCase() === entry.value.toLowerCase() || ss.toLowerCase().includes(entry.value.toString().toLowerCase()))) {
                trueCount++;
              }
            })
            if (trueCount == this.entitySearchModel.filters.length) {
              let index = itemsFoundList.findIndex(x => x == dt);
              if (index == -1) {
                itemsFoundList.push(dt);
              }
            }
            if (itemsFoundList != null && itemsFoundList.length > 0) {
              filteredData.push(itemsFoundList);
            }
          })
        }
      }


      if (this.dataEntityInstanceSource) {
        if (filteredData.length > 0) {
          this.dataEntityInstanceSource.data = filteredData[0];
          this.dataEntityInstanceSource = new MatTableDataSource(filteredData[0]);
        }
        else {
          this.dataEntityInstanceSource = new MatTableDataSource([]);
        }
      }
    } catch (error) {
      console.error('[IncidentComponent] applySearch - Error:', error);
    }
  }
  resetSearch(event) {
    try {
      if (!event || !event.target) {
        return;
      }
      
      event.target.value = "";
      
      if (this.entitySearchModel && this.entitySearchModel.filters && this.entitySearchModel.filters.length > 0) {
        this.entitySearchModel.filters = [];
      }
      
      if (this.searchableFields && this.searchableFields.length > 0) {
        this.searchableFields.forEach(element => {
          if (element && element.questionMasters && element.questionMasters.questionId) {
            const elementId = element.questionMasters.questionId.toString();
            const domElement = document.getElementById(elementId);
            if (domElement) {
              (<HTMLFormElement>domElement).value = "";
            }
          }
        });
      }
      
      if (this.dataEntityInstanceSource && this.instancesFieldData) {
        this.dataEntityInstanceSource = new MatTableDataSource(this.instancesFieldData);
      }
    } catch (error) {
      console.error('[IncidentComponent] resetSearch - Error:', error);
    }
  }

  async lookupEntityInstances(entitySearchModel) {
    try {
    this.spinnerService.show();
    
    if (!entitySearchModel) {
      console.warn('[IncidentComponent] lookupEntityInstances - entitySearchModel is null/undefined');
      this.spinnerService.hide();
      return;
    }
    
    this.baseHttpService.post(this.constant.getEntityInstancesList, entitySearchModel).subscribe(data => {
      if (data != null) {
        this.instancesFieldData = data.elementList;
        if (data.elementList != null && data.elementList.length > 0) {
          this.totalItems = data.pageCount * this.size;
          this.displayedEntityInstanceColumns = [];
          this.displayedEntityInstanceColumns.push("Icon");
          //this.displayedEntityInstanceColumns = this.resultFields.map(s => s.entityFieldName);
          if (this.resultFields && this.resultFields.length > 0) {
            this.resultFields.forEach(x => {
              if (x && x.entityFieldName) {
                this.displayedEntityInstanceColumns.push(x.entityFieldName);
              }
            })
          }

          //this.displayedEntityInstanceColumns.push("EntityInstanceId");
          //this.displayedEntityInstanceColumns.push("EntityInstanceName");
          this.displayedEntityInstanceColumns.push("CreatedByUserName");
          this.displayedEntityInstanceColumns.push("Created On");

          //console.log("instancesFieldData", this.instancesFieldData);
          this.dataEntityInstanceSource = new MatTableDataSource(this.instancesFieldData);
        }
        else {
          this.displayedEntityInstanceColumns = [];
          this.dataEntityInstanceSource = new MatTableDataSource([]);
        }
      }
      else {
        this.noLookUpInstances = true;
      }
      this.spinnerService.hide();
    })
    } catch (error) {
      console.error('[IncidentComponent] lookupEntityInstances - Error:', error);
      this.spinnerService.hide();
    }
  }

  async lookupEntityDetails() {
    try {
      // this.spinnerService.show();
      if (!this.selectedSection || !this.selectedSection.sectionLookUpEntityId || this.selectedSection.sectionLookUpEntityId.length === 0) {
        console.warn('[IncidentComponent] lookupEntityDetails - selectedSection or sectionLookUpEntityId is invalid');
        // this.spinnerService.hide();
        return;
      }
      
      this.baseHttpService.getById(this.constant.getProcessEntities, this.businessProcessId).subscribe(dt => {
        if (dt != null) {
          this.entityDetails = dt.find(x => x.entityID == this.selectedSection.sectionLookUpEntityId);
          
          if (this.entityDetails) {
            this.entitySurveyId = (this.entityDetails.surveyModel != null) ? this.entityDetails.surveyModel.surveyId : "";
            this.entityFields = this.entityDetails.entityFields;
            this.searchableFields = []; this.resultFields = []; this.infoBarFields = [];
            
            if (this.entityFields && this.entityFields.length > 0) {
              this.entityFields.forEach(ef => {
                if (ef && ef.fieldProperties && ef.fieldProperties.length > 0) {
                  ef.fieldProperties.forEach(p => {
                    if (!p || !p.propertyDetails) {
                      return;
                    }
                    
                    if (p.propertyDetails.propertyName == "Searchable" && p.propertyValue == "1") {
                      let filteredSearchFields = this.searchableFields.filter(x => x.entityFieldID == ef.entityFieldID);
                      let itemFoundSearch = filteredSearchFields.length > 0 ? filteredSearchFields[0] : null;
                      if (itemFoundSearch == null) {
                        this.searchableFields.push(ef);
                      }
                    }
                    if (p.propertyDetails.propertyName == "Display In Results" && p.propertyValue == "1") {
                      let filteredResults = this.resultFields.filter(x => x.entityFieldID == ef.entityFieldID);
                      let itemFound = filteredResults.length > 0 ? filteredResults[0] : null;
                      if (itemFound == null) {
                        this.resultFields.push(ef);
                      }
                    }
                    if (p.propertyDetails.propertyName == "Display in info-bar" && p.propertyValue == "1") {
                      let filteredInfoBar = this.infoBarFields.filter(x => x.entityFieldID == ef.entityFieldID);
                      let itemFound = filteredInfoBar.length > 0 ? filteredInfoBar[0] : null;
                      if (itemFound == null) {
                        this.infoBarFields.push(ef);
                      }
                    }
                  })
                }
              })
            }
          }
        }
        this.spinnerService.hide();
      })
    } catch (error) {
      console.error('[IncidentComponent] lookupEntityDetails - Error:', error);
      this.spinnerService.hide();
    }
  }

  paginate(event: any) {
    if (event == 0) {
      event = 1;
    }
    this.pageIndex = event;
    this.checkEntityInstances();
    //this.dataSource.data = this.data.slice(event * this.size - this.size, event * this.size);
  }

  // closeClearResponsesPopup(question:any) {
  //   this.showClearResponsesPopUp = false;
  //   this.clearResponsesSelected = false;
  //   this.ResetElement(question);
  // }
  // clearResponses(selectedElement:any) {
  //   this.showClearResponsesPopUp = false;
  //   this.clearResponsesSelected = true;
  //   //this.GetChildDataAndSetVisibility(selectedElement);
  //   this.GetChildDataAndSetVisibility_NEW(selectedElement);
  // }
  // ResetElement(selectedChild: any) {

  //   this.surveyViewModel.sections.forEach((parobj, parindex) => {
  //     // this.ResetSection(selectedChild);

  //     let currentQues = parobj.questions.find(x => x.questionId == selectedChild.questionId);
  //     if (currentQues) {
  //       let currentQuesCh = parobj.questions.filter(x => x.parentQuestionGuid == currentQues.questionGuid);
  //       if (currentQuesCh) {
  //         currentQuesCh.forEach(element => {
  //           if (currentQues.inputType == "mul" || currentQues.inputType == "chk") {
  //             if (selectedChild.responseText == "") {
  //               let response = this.questionCommentBackUp.find(x => x.questionId == selectedChild.questionId);
  //               selectedChild.responseText += response.questionReponse;
  //               //selectedChild.responseText += element.parentQuesResponse;
  //               //let selectedch = response.questionReponse.split("||");
  //               let selectedch = element.parentQuesResponse.split("||");
  //               selectedch.forEach(item => {
  //                 selectedChild.options.forEach(ele => {

  //                   if (ele.value == item) {
  //                     ele.selected = true;
  //                     return;
  //                   }

  //                 });
  //               })


  //               return;
  //             }
  //             else {

  //               // if (element.responseText != null && selectedChild.responseText.includes(element.parentQuesResponse)) {
  //                 let response = this.questionCommentBackUp.find(x => x.questionId == selectedChild.questionId)
  //                 selectedChild.responseText += "||" + response.questionReponse;

  //                 //selectedChild.responseText += "||"+element.parentQuesResponse;
  //                 //let selected = response.questionReponse.split("||");
  //                 let selected = element.parentQuesResponse.split("||");
  //                 selected.forEach(item => {
  //                   selectedChild.options.forEach(ele => {

  //                     if (ele.value == item) {
  //                       ele.selected = true;
  //                       return;
  //                     }

  //                   });
  //                 })
  //                 return;
  //               // }
  //             }

  //           }
  //           else {
  //            let response = this.questionCommentBackUp.find(x => x.questionId == selectedChild.questionId)
  //               selectedChild.responseText = response.questionReponse;

  //               // selectedChild.responseText = element.parentQuesResponse;
  //               if (selectedChild.inputType == "rdo") {
  //                 selectedChild.options.forEach(ele => {
  //                   if (ele.value == element.parentQuesResponse) {
  //                     ele.selected = true;
  //                     return;
  //                   }
  //                   else if (ele.value != element.parentQuesResponse) {
  //                     ele.selected = false;
  //                   }
  //                 });
  //               }
  //               if (selectedChild.inputType == "rating") {
  //                 selectedChild.rating = element.parentQuesResponse;

  //                 return;
  //               }
  //           }
  //         });
  //       }
  //     }
  //   }
  //   );
  // }
  // ResetSection(selectedChild: any) {
  //   this.surveyViewModel.sections.forEach((parobj, parindex) => {
  //     if (parobj.ParentSectionGuid) {
  //       let sec = this.surveyViewModel.sections.find(x => x.SectionGuid == parobj.ParentSectionGuid);
  //       let parQues = sec.questions.find(x => x.questionGuid == parobj.parentQuestionGuid);
  //       let childSec = this.surveyViewModel.sections.find(x => x.ParentSectionGuid == sec.SectionGuid);
  //       if (selectedChild.questionId == parQues.questionId) {
  //         if (parQues.inputType == "mul" || parQues.inputType == "chk") {
  //           if (selectedChild.responseText == "") {
  //             selectedChild.responseText += childSec.parentQuesResponse;
  //             selectedChild.options.forEach(ele => {
  //               if (ele.value == childSec.parentQuesResponse) {
  //                 ele.selected = true;
  //                 return;
  //               }
  //             });
  //           }
  //           else {
  //             let response = this.questionCommentBackUp.find(x => x.questionId == selectedChild.questionId)
  //             selectedChild.responseText = response.questionReponse;
  //             var resp = childSec.parentQuesResponse.split("||")
  //             selectedChild.options.forEach(ele => {
  //               if (response.questionReponse.split("||").includes(ele.value)) {
  //                 ele.selected = true;
  //               }
  //             });
  //             // resp.forEach(item => {
  //             //       selectedChild.options.forEach(ele => {

  //             //         if (ele.value == item) {
  //             //           ele.selected = true;
  //             //           return;
  //             //         }

  //             //       });
  //             //     })
  //             return;
  //           }
  //         }
  //         else {
  //           childSec.questions.forEach(item => {
  //             if (item.responseText != null) {
  //               selectedChild.responseText = childSec.parentQuesResponse;
  //               if (selectedChild.inputType == "rdo") {
  //                 selectedChild.options.forEach(ele => {
  //                   if (ele.value == childSec.parentQuesResponse) {
  //                     ele.selected = true;
  //                     return;
  //                   }
  //                   else if (ele.value != childSec.parentQuesResponse) {
  //                     ele.selected = false;
  //                   }
  //                 });
  //               }
  //               if (selectedChild.inputType == "rating") {
  //                 selectedChild.rating = childSec.parentQuesResponse;

  //                 return;
  //               }
  //             }
  //           });
  //         }
  //       }
  //     }
  //   });
  // }
  // SetQuestionOldResponse(currentQues: any, oldResponseObj : QuestionResponsesdata) {
  //   if (oldResponseObj) {
  //     currentQues.responseText = oldResponseObj.questionReponse;
  //     currentQues.comments = oldResponseObj.comments;
  //     currentQues.surveyResponseRelId = oldResponseObj.surveyResponseRelId;
      
  //     if (currentQues.inputType == "mul" || currentQues.inputType == "chk" || currentQues.inputType == "rdo") {
  //       currentQues.responseText = oldResponseObj.questionReponse;
  //       let response = currentQues.responseText.split("||");
  //       response.forEach(item => {
  //         currentQues.options.forEach(ele => {
  //           if (ele.value == item) {
  //             ele["selected"] = true;              
  //           }
  //           else {
  //             ele["selected"] = false;  
  //           }
  //           return;
  //         });
  //       });
  //     }
  //     else  if (currentQues.inputType == "rating") {
  //       currentQues.rating = oldResponseObj.questionReponse;
  //       return;
  //     }
  //     /** Handle for other question types if needed **/
     
  //   }
  // }
  // ResetQuestion(currentQues: QuestionViewModel) {    
  //   // Find the section containing the current question
  //   const currSec = this.surveyViewModel.sections.find(x => x.sectionId == currentQues.sectionId);
  //   if (!currSec) return;

  //   // Reset the current question
  //   this.ProcessQuestionAndChildren(currentQues, currSec);
  // }
  // ProcessQuestionAndChildren(question: QuestionViewModel, section: any) {
  //   // Reset current question
  //   const existingResponse = this.questionCommentBackUp.find(x => x.questionId == question.questionId);
  //   this.SetQuestionOldResponse(question, existingResponse);

  //   // Reset direct child questions from parent question
  //   const childQuestions = section.questions.filter(x => x.parentQuestionGuid == question.questionGuid);
  //   childQuestions?.forEach(childQ => {
  //     this.ProcessQuestionAndChildren(childQ, section);
  //   });

  //   // Reset sub-questions recursively
  //   question.subQuestions?.forEach(subQ => {
  //     this.ProcessQuestionAndChildren(subQ, section);
  //   });
  // }
  //New save methods
  savebtnClick(btnName: string, status: SurveySubmissionStatus) {
    try {
      this.incidentCreateShouldLog = false;
      // this.isSaveRequired = false;
      this.spinnerService.show();
      this.getConsentQuestions();

      if (this.isStandaloneSurvey == true) {
        this.standaloneSurveyStatus = status;
        this.startSurvey();
      }
      else {
        // SaveAndSubmit creates the instance (when surveyInstanceId is empty) and
        // persists responses in the same request - no separate create call needed.
        this.incidentCreateShouldLog = this.surveyInstanceId == null || this.surveyInstanceId.length == 0;
        if(btnName == "Submit"){
          this.openConsentOtherQuestionsPopUp(btnName, status);
        }
        else{
          this.sectionalSave(btnName, status);
        }
      }
      this.isScrolled = false;
    } catch (error) {
      console.error('[IncidentComponent] savebtnClick - Error:', error);
      this.spinnerService.hide();
    }
  }
 sectionalSave(btnName: string, status: SurveySubmissionStatus) {
    try {
      if(this.isSurveyExpired(this.surveyDueDate)){
        this.notificationService.showError("Survey is expired", "Error");
        this.spinnerService.hide();
        this.router.navigate(["/businessProcess"]);
        return;
      }
      
      const { mandatoryError, invalidResponse } = this.validateSectionQuestions(btnName, status);
      if (mandatoryError) {
        this.notificationService.showError("The form contains incomplete information.", "Error");
        this.spinnerService.hide();
        // Scroll to the first question with error with a delay to ensure DOM updates
        setTimeout(() => this.scrollToFirstQuestionWithError(), 100);
        return false;
      }
      if (invalidResponse) {
        this.notificationService.showError("The form contains invalid information", "Error");
        this.spinnerService.hide();
        // Scroll to the first question with error with a delay to ensure DOM updates
        setTimeout(() => this.scrollToFirstQuestionWithError(), 100);
        return false;
      }
      
      let allRequiredSectionsValid = this.checkIfAllFieldsValid(status);
      if (!allRequiredSectionsValid) {
        this.notificationService.showError("The form contains invalid information", "Error");
        this.spinnerService.hide();
        return;
      }

      if(btnName == "SaveAndContinue"){
        this.updateConsentSignQuestions();
      }
      // Detect signatures before binding responses
      this.detectSignaturesInCurrentSection();
      this.bindResponsesToSectionalSavePostObj(status);
      this.apiCallForSectionSave(btnName, status);
    } catch (error) {
      console.error('[IncidentComponent] sectionalSave - Error:', error);
      this.spinnerService.hide();
    }
  }

  updateConsentSignQuestions(){
    this.consentQuestions.forEach(que => {
      //Perform update for consent sign question
      if(que.inputType === 'sign' && que.responseText && que.responseText.length > 0) {
        que.responseText = "";
        delete que.responseText;
      }
    });
  }

  // moveScrollToFirstError(){
  //   const errorElement = document.getElementsByClassName("errormsg");
  //     if(errorElement.length > 0){
  //       errorElement[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
  //     }
  // }

  /**
   * Scrolls to the first question with error using existing errormsg class
   * Enhanced with delay to ensure DOM is updated and better visual feedback
   */
  scrollToFirstQuestionWithError(): void {
    // Small delay to ensure error messages are rendered in DOM
    setTimeout(() => {
      const errorElement = document.querySelector('.errormsg');
      if (errorElement) {
        // Enhanced scroll behavior for better visibility
        errorElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center',
          inline: 'nearest'
        });
        
        // Add temporary highlight to the error message for better visibility
        errorElement.classList.add('error-highlight');
        setTimeout(() => {
          errorElement.classList.remove('error-highlight');
        }, 3000);
      }
    }, 200);
  }

   validateSectionQuestions(btnName: string, status: string): { mandatoryError: boolean, invalidResponse: boolean } {
    try {
      let mandatoryError = false;
      let invalidResponse = false;

      if (!this.wfSteps || !this.surveyViewModel || !this.surveyViewModel.sections || !this.selectedSection) {
        console.warn('[IncidentComponent] validateSectionQuestions - wfSteps, surveyViewModel, sections, or selectedSection is null/undefined');
        return { mandatoryError: false, invalidResponse: false };
      }
      
      if (this.selectedStepIndex === undefined || this.selectedStepIndex === null || !this.wfSteps[this.selectedStepIndex]) {
        console.warn('[IncidentComponent] validateSectionQuestions - selectedStepIndex is invalid or wfSteps[selectedStepIndex] is null');
        return { mandatoryError: false, invalidResponse: false };
      }
      
      let visisbleSections = this.wfSteps[this.selectedStepIndex].sectionsList?.filter(x=> x["isSecParentQuestionVisible"] == true);
      
      if (!visisbleSections || visisbleSections.length === 0) {
        console.warn('[IncidentComponent] validateSectionQuestions - no visible sections found');
        return { mandatoryError: false, invalidResponse: false };
      }
      
      if (btnName == "SaveAndContinue" || btnName == "Save" || btnName == "SavePopUp") {
        visisbleSections = visisbleSections.filter(x => x.sectionId == this.selectedSection.sectionId);
      }
      
      
      if(visisbleSections && visisbleSections.length > 0){
        visisbleSections.forEach(secTnStep => {
         let findSecInList = this.surveyViewModel.sections.find(x => x.sectionId == secTnStep.sectionId);
          if (findSecInList && findSecInList.questions) { 
            let visibleQuestions = findSecInList.questions.filter(x=> x.isParentQuestionVisible == true);
            let sectionNeedsUpdate = false;

            if (visibleQuestions && visibleQuestions.length > 0) {
              visibleQuestions.forEach((que, queIndex) => {
              const isTable = que.inputType === 'table';
              const isDisplayText = que.inputType === 'displaytext';
              let questionNeedsUpdate = false;
          
        // handle validation for table or grid type questions
        if(isTable){
            if( que.dataType === 'fixed-grid' && que.isQuestionRequired !='C'  && que.subQuestions && que.subQuestions.length > 0) {
              que.subQuestions.forEach(row => {
                row.subQuestions.forEach(subQue => {
                  if ((subQue.isQuestionRequired === 'Y') && (!subQue.responseText || subQue.responseText.trim().length === 0) && btnName !== 'Save' && btnName!='SavePopUp') {
                    subQue.errorMessage = "Input is mandatory";
                    mandatoryError = true;
                    questionNeedsUpdate = true;
                  }
                  else if(subQue.responseText && subQue.responseText.trim().length > 0 && subQue["IsValid"]===false){
                    subQue.errorMessage = "Response is not valid";
                    invalidResponse = true;
                    questionNeedsUpdate = true;
                  }
                  else {
                    subQue.errorMessage = null;
                    subQue["IsValid"] = true; // Mark as valid if no error
                  }
                });
              });
            }
            else if(que.dataType === 'dynamic-grid' && que.isQuestionRequired !='C') {
              // Validate responses if they exist
              if (que.responses && que.responses.length > 0) {
                // First: Check if main question is required - first row must have at least one cell with data
                
                if (que.isQuestionRequired === 'Y' && btnName !== 'Save' && btnName!='SavePopUp') {
                  
                  const firstRow = que.responses[0];
                  if (firstRow.questions && firstRow.questions.length > 0) {
                    firstRow.questions.forEach(subQue => {
                      if (!subQue.responseText || subQue.responseText.trim().length == 0) {
                        subQue.isQuestionRequired = 'Y';  // Set required flag so child component validates 
                      }
                    });
                  }
                }
                
                // Then: Validate each cell's individual required flag
                que.responses.forEach(row => {
                  row.questions.forEach(subQue => {
                    if ((subQue.isQuestionRequired === 'Y') && (!subQue.responseText || subQue.responseText.trim().length === 0) && btnName !== 'Save' && btnName!='SavePopUp') {
                      subQue.errorMessage = "Input is mandatory";
                      mandatoryError = true;
                      questionNeedsUpdate = true;
                    }
                    else if(subQue.responseText && subQue.responseText.trim().length > 0 && subQue["IsValid"]===false){
                      subQue.errorMessage = "Response is not valid";
                      invalidResponse = true;
                      questionNeedsUpdate = true;
                    }
                    else{
                      // Only clear error if this cell doesn't need validation OR has valid data
                      subQue.errorMessage = null;
                      subQue["IsValid"] = true; // Mark as valid if no error
                    }
                  });
                });
              }
              // Handle case when main question is required but no responses exist
             if (que.isQuestionRequired === 'Y' && btnName !== 'Save' && btnName!='SavePopUp' && (!que.responses || que.responses.length === 0)) {
                que["IsValid"] = false;
                que.errorMessage = "Input is mandatory";
                mandatoryError = true;
                questionNeedsUpdate = true;
              }
              else{
                que.errorMessage = null;
                que["IsValid"] = true; // Mark as valid if no error
              }
            }
        }
        else{
          const isResponseMissing = (!que.responseText || que.responseText.trim().length === 0);
          const isEsignConsentQues = que.inputType == 'sign' && que.isConsentQuestion;
          if (!isTable && !isDisplayText) {
            if (isResponseMissing && isEsignConsentQues && btnName!='Submit') {
              que.errorMessage = null;
              que["IsValid"] = true;
            }
            else if (isResponseMissing && que.isQuestionRequired === 'Y' && btnName !== 'Save' && btnName!='SavePopUp') {
              que.errorMessage = "Input is mandatory";
              que["IsValid"] = false;
              mandatoryError = true;
              questionNeedsUpdate = true;
            }
            else if (
              !isResponseMissing &&
              que.responseText &&
              que.responseText.trim().length > 0 &&
              que["IsValid"] === false
            ) {
              if (que.parentQuestionGuid && que.isQuestionRequired === 'N') {
                que.errorMessage = null;
                que["IsValid"] = true;
              }
              else {
                que.errorMessage = "Response is not valid";
                invalidResponse = true;
                questionNeedsUpdate = true;
              }

            }
            else {
              que.errorMessage = null;
              que["IsValid"] = true; // Mark as valid if no error
            }
          }
        } 

          // Create new question object reference to trigger ngOnChanges in child components
          if (questionNeedsUpdate) {
            // Find the original question index in the full questions array
            const originalQueIndex = findSecInList.questions.findIndex(q => q.questionId === que.questionId);
            if (originalQueIndex !== -1) {
              // Create a new question object to trigger change detection
              findSecInList.questions[originalQueIndex] = { ...que };
              sectionNeedsUpdate = true;
            }
          }
        });

        // Update selectedSection if this is the current section and questions were updated
        if (sectionNeedsUpdate && this.selectedSection && findSecInList.sectionId === this.selectedSection.sectionId) {
          // Create a new selectedSection reference with updated questions
          this.selectedSection = { 
            ...this.selectedSection, 
            questions: [...findSecInList.questions] 
          };
        }
            }
          }
       });
      }
      
      return { mandatoryError, invalidResponse };
    } catch (error) {
      console.error('[IncidentComponent] validateSectionQuestions - Error:', error);
      return { mandatoryError: false, invalidResponse: false };
    }
  }
  // Detect signature questions in current section for e-consent popup
detectSignaturesInCurrentSection(): void {
  try {
    this.IsAnyESignPresent = false;
    
    if (!this.surveyViewModel || !this.surveyViewModel.sections || !this.selectedSection) {
      console.warn('[IncidentComponent] detectSignaturesInCurrentSection - surveyViewModel, sections, or selectedSection is null/undefined');
      return;
    }
    
    this.surveyViewModel.sections.forEach((obj, index) => {
      if (!obj || obj.sectionId != this.selectedSection.sectionId) {
        return;
      }
      
      // Check regular questions for signatures
      if (obj.questions && obj.questions.length > 0) {
        obj.questions.forEach((childobj, index) => {
          if (!childobj) {
            return;
          }
          
          let allQuestions = this.getAllQuestions(childobj);
          if (allQuestions && allQuestions.length > 0) {
            allQuestions.forEach((question) => {
              if (question && question["inputType"] == 'sign') {
                this.IsAnyESignPresent = true;
              }
            });
          }
        });
      }
      
      // Check grid questions for signatures
      if (obj.gridQuestions && obj.gridQuestions.length > 0) {
        obj.gridQuestions.forEach((gridobj) => {
          if (!gridobj || !gridobj.response || gridobj.response.length === 0) {
            return;
          }
          
          gridobj.response.forEach((responseObj) => {
            if (!responseObj || !responseObj.questions || responseObj.questions.length === 0) {
              return;
            }
            
            responseObj.questions.forEach((childobj) => {
              if (childobj && childobj["inputType"] == 'sign') {
                this.IsAnyESignPresent = true;
              }
            });
          });
        });
      }
    });
  } catch (error) {
    console.error('[IncidentComponent] detectSignaturesInCurrentSection - Error:', error);
  }
}
  openConsentOtherQuestionsPopUp(btnName: string, status: SurveySubmissionStatus) {
    try {
      this.spinnerService.hide();

      if (!this.consentQuestions || this.consentQuestions.length === 0) {
        console.warn('[IncidentComponent] openConsentOtherQuestionsPopUp - consentQuestions is null/undefined or empty');
        this.sectionalSave(btnName, status);
        return;
      }

      const { mandatoryError, invalidResponse } = this.validateSectionQuestions('Validation', status);
      if (mandatoryError) {
        this.notificationService.showError("The form contains incomplete information.", "Error");
        this.spinnerService.hide();
        // Scroll to the first question with error with a delay to ensure DOM updates
        setTimeout(() => this.scrollToFirstQuestionWithError(), 100);
        return false;
      }
      if (invalidResponse) {
        this.notificationService.showError("The form contains invalid information", "Error");
        this.spinnerService.hide();
        // Scroll to the first question with error with a delay to ensure DOM updates
        setTimeout(() => this.scrollToFirstQuestionWithError(), 100);
        return false;
      }

      const anySignQues = this.consentQuestions.some(x => x && x.inputType === "sign");
      const nonSignQues = this.consentQuestions.filter(x => x && x.inputType !== "sign");

      if (nonSignQues && nonSignQues.length > 0) {
        if (!this.dialog) {
          this.sectionalSave(btnName, status);
          return;
        }
        
        const dialogRef = this.dialog.open(ConsentDialogComponent, {
          width: '650px',
          autoFocus:false,
          data: {
            surveyViewModel: this.surveyViewModel,
            consentQuestions: this.consentQuestions,
            selectedChild: null,
            agencyDetails: this.agencyDetails,
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result?.isConsentAccepted) {
            anySignQues
              ? this.openConsentSignQuesPopUpAndSave(btnName, status)
              : this.sectionalSave(btnName, status);
          }
        });
      } else if (anySignQues) {
        this.openConsentSignQuesPopUpAndSave(btnName, status);
      } else {
        this.sectionalSave(btnName, status);
      }
    } catch (error) {
      console.error('[IncidentComponent] openConsentOtherQuestionsPopUp - Error:', error);
      this.spinnerService.hide();
    }
  }

  openConsentSignQuesPopUpAndSave(btnName: string, status: SurveySubmissionStatus) {
    this.spinnerService.hide();   
    const dialogRef = this.dialog.open(ConsentSignDialogComponent, {
      width: '750px', 
      height: 'auto',
      autoFocus: false,      
      data: {
        surveyViewModel : this.surveyViewModel, 
        consentQuestions :  this.consentQuestions,         
        selectedChild: null 
      }
    });

    // Listen for response changes
    dialogRef.componentInstance.responseChanged.subscribe(selectedChild => {
      this.GetChildData(selectedChild);
    });

    // Listen for dialog close (submit)
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.isConsentAccepted) {
        this.sectionalSave(btnName, status);
      }
    });
    
  }


  checkIfAllFieldsValid(status: SurveySubmissionStatus): boolean {
    try {
      if (!this.surveyViewModel || !this.surveyViewModel.sections) {
        console.warn('[IncidentComponent] checkIfAllFieldsValid - surveyViewModel or sections is null/undefined');
        return true;
      }
      
      let allFieldsValid = true;
      
      if (status === SurveySubmissionStatus.Submit) {
        if (this.isStandaloneSurvey || (!this.isStandaloneSurvey && !this.IsWorkflow)) {
          let secNotAns = this.surveyViewModel.sections.filter(x => x && x.sectionDotColor == 'yellow');
          allFieldsValid = !secNotAns || secNotAns.length === 0;
        }
        else if (!this.isStandaloneSurvey && this.IsWorkflow) {
          if (!this.wfSteps || this.wfSteps.length === 0) {
            console.warn('[IncidentComponent] checkIfAllFieldsValid - wfSteps is null/undefined/empty in workflow mode');
            return true;
          }
          
          let secList: SectionViewModel[] = [];
          
          this.wfSteps.forEach(w => {
            if (!w || !w.sectionsList) {
              return;
            }
            
            w.sectionsList.forEach(s => {
              if (!s) {
                return;
              }
              
              let secFound = this.surveyViewModel.sections.find(x => x && x.sectionId == s.sectionId);
              if (secFound) {
                secList.push(secFound);
              }
            });
          });
          
          let secNotAns = secList.filter(x => x && x.sectionDotColor == 'yellow');
          allFieldsValid = !secNotAns || secNotAns.length === 0;
        }
      }
      
      return allFieldsValid;
    } catch (error) {
      console.error('[IncidentComponent] checkIfAllFieldsValid - Error:', error);
      return true;
    }
  }
  checkIfAllResponsesValid(status: string): boolean {
    try {
      if (!this.surveyViewModel || !this.surveyViewModel.sections) {
        console.warn('[IncidentComponent] checkIfAllResponsesValid - surveyViewModel or sections is null/undefined');
        return true;
      }
      
      if (!this.selectedSection) {
        console.warn('[IncidentComponent] checkIfAllResponsesValid - selectedSection is null/undefined');
        return true;
      }
      
      let allResponsesValid = true;
      
      this.surveyViewModel.sections.forEach(sec => {
        if (!sec || !sec.questions) {
          return;
        }
        
        if (sec.sectionId == this.selectedSection.sectionId) {
          sec.questions.forEach(que => {
            if (!que) {
              return;
            }
            
            if (que["IsValid"] === false) {
              allResponsesValid = false;
              que.errorMessage = "Response is not valid";
              que["IsValid"] = false;
            } else {
              que.errorMessage = null;
              que["IsValid"] = true;
            }
          });
        }
      });
      
      return allResponsesValid;
    } catch (error) {
      console.error('[IncidentComponent] checkIfAllResponsesValid - Error:', error);
      return true;
    }
  }
  checkRequiredValidations(status: string): boolean {
    try {
      let errorFlag = false; let errorResponeFlag = false; 
      let validFieldsFlag = true;

      if (!this.surveyViewModel || !this.surveyViewModel.sections || !this.selectedSection) {
        console.warn('[IncidentComponent] checkRequiredValidations - surveyViewModel, sections, or selectedSection is null/undefined');
        return true;
      }

      this.surveyViewModel.sections.forEach(sec => {
        if (!sec || sec.sectionId != this.selectedSection.sectionId) {
          return;
        }
        
        if (!sec.questions || sec.questions.length === 0) {
          return;
        }
        
        sec.questions.forEach(que => {
          if (!que) {
            return;
          }
          
          let errorFlag = false; // Reset errorFlag for each question
          if (que.isQuestionRequired == 'Y') {
            if (que.inputType == 'matrix') {
              if (que.subQuestions && que.subQuestions.length > 0) {
                que.subQuestions.forEach(subQue => {
                  if (!subQue) {
                    return;
                  }
                  
                  if (status === SurveySubmissionStatus.Submit && (subQue.responseText == null || subQue.responseText == undefined || subQue.responseText.length == 0 || (typeof subQue.responseText === 'string' && subQue.responseText.trim().length === 0))) {
                    errorFlag = true;
                  }
                  else {
                    que["IsValid"] = true;
                    que.errorMessage = null;
                  }
                });
              }
            }
            else if(que.inputType == 'table') {
              if (que.subQuestions && que.subQuestions.length > 0) {
                que.subQuestions.forEach(subQue => {
                  if (!subQue || !subQue.subQuestions || subQue.subQuestions.length === 0) {
                    return;
                  }
                  
                  subQue.subQuestions.forEach(subSubQue => {
                    if (!subSubQue) {
                      return;
                    }
                    
                    if ((status === SurveySubmissionStatus.Submit || status === SurveySubmissionStatus.Save) && que.isQuestionRequired && que.isQuestionRequired && (subSubQue.responseText == null || subSubQue.responseText == undefined || subSubQue.responseText.length == 0)) {
                      errorFlag = true;
                    }
                    else {
                      que["IsValid"] = true;
                      que.errorMessage = null;
                    }
                  });
                });
              }
            }
            else if(que.inputType == 'fileupload') {
              if ((status === SurveySubmissionStatus.Submit || status === SurveySubmissionStatus.Save) && (que.responseText == null || que.responseText == undefined || que.responseText.length == 0)) {       
                errorFlag = true;
              }
              else{
                que["IsValid"] = true;
                que.errorMessage = null;
              }
            }
            else {
              if ((status === SurveySubmissionStatus.Submit || status === SurveySubmissionStatus.Save) && (que.responseText == null || que.responseText == undefined || que.responseText.length == 0 || (typeof que.responseText === 'string' && que.responseText.trim().length === 0))) {
                errorFlag = true;
              }
              else{
                que["IsValid"] = true;
                que.errorMessage = null;
              }
            }

            if (!errorFlag) {
              this.AllFieldsValid = this.AllFieldsValid && true;
              que.errorMessage = null; que["IsValid"] = true;
            }
            else {
              this.AllFieldsValid = this.AllFieldsValid && false;
              que.errorMessage = "Input is mandatory"; 
              que["IsValid"] = false;
              errorResponeFlag = true;
              validFieldsFlag = false;
            }
          }
          else {
            if (status === SurveySubmissionStatus.Submit && (que.responseText == null || que.responseText == undefined || que.responseText.length == 0 || (typeof que.responseText === 'string' && que.responseText.trim().length === 0))) {
              errorFlag = true;
            }
            if (!errorFlag) {
              this.AllFieldsValid = this.AllFieldsValid && true;
              que.errorMessage = null; que["IsValid"] = true;
            }
            else if(que["IsValid"] == false) {
              validFieldsFlag = validFieldsFlag && false;
              que.errorMessage = "Response is not valid";
              que["IsValid"] = false;
            }
            else {
              que.errorMessage = null; que["IsValid"] = true;
            }
          }
        });
      });

      return validFieldsFlag;
    } catch (error) {
      console.error('[IncidentComponent] checkRequiredValidations - Error:', error);
      return true;
    }
  }
  bindResponsesToSectionalSavePostObj(status: SurveySubmissionStatus) {
    try {
      //bind user give responses
      /* TODO1 :  Handle Signature , matrix, rating question responses in individual concrete methods before submitting later */
      if (!this.surveyResponseClass) {
        console.warn('[IncidentComponent] bindResponsesToSectionalSavePostObj - surveyResponseClass is null/undefined');
        return;
      }
      
      this.surveyResponseClass.questionResponses = [];
      
      if (!this.surveyViewModel || !this.surveyViewModel.sections || !this.selectedSection) {
        console.warn('[IncidentComponent] bindResponsesToSectionalSavePostObj - surveyViewModel, sections, or selectedSection is null/undefined');
        return;
      }
      
      this.surveyViewModel.sections.forEach((obj, index) => {
        if (!obj || obj.sectionId != this.selectedSection.sectionId) {
          // Check for consent e-sign in all sections
          if (obj && obj.questions && obj.questions.length > 0) {
            let esignquestion = obj.questions.find(x => x && x.isConsentQuestion && x.inputType == 'sign');
            if (esignquestion && esignquestion.responseText != undefined && esignquestion.responseText.length > 0 && this.surveyResponseClass.questionResponses.findIndex(x => x.questionId == esignquestion.questionId) == -1) {
              let questionresponsesdata = new QuestionResponsesdata();
              questionresponsesdata.questionId = esignquestion["questionId"];
              questionresponsesdata.surveyResponseRelId = esignquestion["surveyResponseRelId"];
              questionresponsesdata.comments = esignquestion.comments;
              questionresponsesdata.sequenceNumber = 1;
              questionresponsesdata.questionReponse = esignquestion["responseText"] ? esignquestion["responseText"] : "";
              questionresponsesdata.sectionId = esignquestion.sectionId;
              this.surveyResponseClass.questionResponses.push(questionresponsesdata);
            }
          }
          return;
        }

        if (obj.questions && obj.questions.length > 0) {
          obj.questions.forEach((_childobj, index) => {
            if (!_childobj) {
              return;
            }
            
            //get all questions
            let allQuestions = this.getAllQuestions(_childobj);
            if (allQuestions && allQuestions.length > 0) {
              allQuestions.forEach((childobj, index) => {
                if (childobj) {
                  this.AddtoSurveyResponses(obj, childobj, status);
                }
              });
            }
          });
        }
        // }

        //check child Sections
        let allChildSections = this.surveyViewModel.sections.filter(x => x && x.ParentSectionGuid == obj.SectionGuid);
        if (allChildSections && allChildSections.length > 0) {
          allChildSections.forEach((childSec, index) => {
            if (!childSec || !childSec.questions || childSec.questions.length === 0) {
              return;
            }
            
            childSec.questions.forEach((_childobj, index) => {
              if (!_childobj) {
                return;
              }
              
              //get all questions
              let allQuestions = this.getAllQuestions(_childobj);
              if (allQuestions && allQuestions.length > 0) {
                allQuestions.forEach((childobj, index) => {
                  if (childobj) {
                    this.AddtoSurveyResponses(childSec, childobj, status);
                  }
                });
              }
            });
          });
        }

        //check for consent e-sign
        if (obj.questions && obj.questions.length > 0) {
          let esignquestion = obj.questions.find(x => x && x.isConsentQuestion && x.inputType == 'sign');
          if (esignquestion && esignquestion.responseText != undefined && esignquestion.responseText.length > 0 && this.surveyResponseClass.questionResponses.findIndex(x => x.questionId == esignquestion.questionId) == -1) {
            let questionresponsesdata = new QuestionResponsesdata();
            questionresponsesdata.questionId = esignquestion["questionId"];
            questionresponsesdata.surveyResponseRelId = esignquestion["surveyResponseRelId"];
            questionresponsesdata.comments = esignquestion.comments;
            questionresponsesdata.sequenceNumber = 1;
            questionresponsesdata.questionReponse = esignquestion["responseText"] ? esignquestion["responseText"] : "";
            questionresponsesdata.sectionId = esignquestion.sectionId;
            this.surveyResponseClass.questionResponses.push(questionresponsesdata);
          }
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] bindResponsesToSectionalSavePostObj - Error:', error);
    }
  }

  AddtoSurveyResponses(section : SectionViewModel, childobj : QuestionViewModel, status :string) {
    try {
      if (!section || !childobj || !this.surveyResponseClass) {
        console.warn('[IncidentComponent] AddtoSurveyResponses - section, childobj, or surveyResponseClass is null/undefined');
        return;
      }
      
      if (((childobj.isParentQuestionVisible == true && childobj.comments != null && childobj.comments != undefined && typeof childobj.comments === 'string' && childobj.comments.trim() != "")
      || childobj["responseText"] != null && childobj["responseText"] != "") || childobj['rating'] || (childobj["inputType"] == 'matrix') || childobj.surveyResponseRelId) {
        let questionresponsesdata = new QuestionResponsesdata();
        questionresponsesdata.questionId = childobj["questionId"];
        questionresponsesdata.surveyResponseRelId = childobj["surveyResponseRelId"];
        questionresponsesdata.comments = childobj.comments;
        if (questionresponsesdata.comments != null && typeof questionresponsesdata.comments === 'string' && questionresponsesdata.comments.trim() == "") {
          questionresponsesdata.comments = null;
        }
        questionresponsesdata.sequenceNumber = 1;
        questionresponsesdata.inputType = childobj["inputType"]; 
        if (childobj["inputType"] == 'matrix') {
          questionresponsesdata.questionReponse = "";
        }
        questionresponsesdata.questionReponse = childobj["responseText"] ? childobj["responseText"] : childobj['rating'];
        questionresponsesdata.sectionId = section.sectionId;
        this.surveyResponseClass.questionResponses.push(questionresponsesdata);
        
        if (childobj.subQuestions && childobj.subQuestions.length > 0) {
          childobj.subQuestions.forEach(y => {
            if (!y) {
              return;
            }
            
            if (y.surveyResponseRelId ||  y.responseText) {
              let questionresponsesdata = new QuestionResponsesdata();
              questionresponsesdata.questionId = y["questionId"];
              questionresponsesdata.sequenceNumber = 1;
              questionresponsesdata.inputType = y["inputType"];
              questionresponsesdata.questionReponse = y["responseText"] ? y["responseText"] : y['rating'];

              questionresponsesdata.sectionId = section.sectionId;
              this.surveyResponseClass.questionResponses.push(questionresponsesdata);
            }
          });
        }
      }

      //if (status == "S" && childobj["inputType"] == 'sign' && (childobj["isQuestionRequired"] == "Y" || childobj["isQuestionRequired"] == "true")) {
      if (status === SurveySubmissionStatus.Submit && childobj["inputType"] == 'sign') {
        if (!childobj["responseText"] && childobj.responseText == undefined && childobj.responseText.length == 0) {
          this.signAvailable = false;
          this.notificationService.showError("Please provide e-signature", "Error");
          return;
        }
        else {
          this.signAvailable = true;
        }
      }
    } catch (error) {
      console.error('[IncidentComponent] AddtoSurveyResponses - Error:', error);
    }
  }

getAllQuestions(mainQuestion: QuestionViewModel): QuestionViewModel[] {
  try {
    let allQuestions: QuestionViewModel[] = [];

    if (!mainQuestion) {
      console.warn('[IncidentComponent] getAllQuestions - mainQuestion is null/undefined');
      return allQuestions;
    }

    //handle dynamic grid responses
    if (mainQuestion.inputType == 'table' && mainQuestion.dataType == 'dynamic-grid') {
      if (mainQuestion.responses) {
        mainQuestion.responseText = JSON.stringify(mainQuestion.responses);
      }
      return [mainQuestion];
    }

    const traverseQuestions = (question: QuestionViewModel) => {
      if (!question) {
        return;
      }
      
      allQuestions.push(question);
      if (question.subQuestions && question.subQuestions.length > 0) {
        question.subQuestions.forEach((subQues: QuestionViewModel) => {
          if (subQues) {
            traverseQuestions(subQues);
          }
        });
      }
    };

    traverseQuestions(mainQuestion);
    let responsedQuestions = allQuestions.filter(q => q && (q.surveyResponseRelId || (q.responseText != null && q.responseText != undefined && typeof q.responseText === 'string' && q.responseText.trim() != "")));

    return responsedQuestions;
  } catch (error) {
    console.error('[IncidentComponent] getAllQuestions - Error:', error);
    return [];
  }
}



  apiCallForSectionSave(btnName: string, status: SurveySubmissionStatus, skipConsentCheck: boolean = false) {
    try {
      this.spinnerService.show();

      if (!this.surveyResponseClass || !this.surveyViewModel) {
        console.warn('[IncidentComponent] apiCallForSectionSave - surveyResponseClass or surveyViewModel is null/undefined');
        this.spinnerService.hide();
        return;
      }

      // true when no instance exists yet - SaveAndSubmit creates it in this same call
      const isNewInstance = this.surveyInstanceId == null || this.surveyInstanceId.length === 0;

      // Set survey response properties (includes the create-path fields previously
      // only sent by the now-removed separate createInstanceEntries call)
      Object.assign(this.surveyResponseClass, {
          surveySubmissionStatus: status,
          surveyId: this.surveyViewModel.surveyId,
          surveyResponseID: this.surveyResponseId,
          surveyInstanceId: this.surveyInstanceId,
          isAnonymousResponse: this.isAnonymusUser,
          incidentCreateShouldLog: this.incidentCreateShouldLog,
        workflowStepId: (this.surveyViewModel.isWorkflow || this.IsWorkflow) ? this.pendingStepId ?? this.selectedStep?.workflowStepId : 0,
          groupId: this.groupId,
          businessProcessId: this.businessProcessId,
          lookupInstances: this.lookupInstances,
          fingerprint: this.surveyResponseClass.fingerprint ?? "",
      });
     
      // Check for e-signature consent requirement (skip if called after consent given)
      // if (!skipConsentCheck && this.IsAnyESignPresent && status != 'R') {
      //   this.hideDisclaimerPopUp = false; // Show e-consent popup
      //   this.spinnerService.hide();
      //   return; // Stop processing until user accepts/declines consent
      // }
      
      //call api for sectional save or submit - also runs when creating the instance
      // for the first time, even with zero answered questions, so the response row
      // always gets created regardless of what the user has filled in so far
      if (isNewInstance || (this.surveyResponseClass.questionResponses && this.surveyResponseClass.questionResponses.length > 0)) {

        if (this.addedsurveyResponses && this.addedsurveyResponses.length > 0) {
          this.addedsurveyResponses.forEach(r => {
            if (!r) {
              return;
            }
            
            if (this.surveyResponseClass.questionResponses && this.surveyResponseClass.questionResponses.length > 0) {
              this.surveyResponseClass.questionResponses.forEach(q => {
                if (q && r["questionId"] == q.questionId) {
                  q.surveyResponseRelId = r["surveyReponseID"];
                }
              })
            }
          })
        }

        this.baseHttpService.post(this.constant.saveAndSubmit, this.surveyResponseClass).subscribe((result) => {
          if (result != null) {
            this.surveyResponseId = result.userSurveyResponseId;
            this.surveyInstanceId = result.surveyInstanceId;
            this.surveyResponseClass.surveyResponseID = this.surveyResponseId;
            this.surveyResponseClass.surveyInstanceId = this.surveyInstanceId;
            if (status === SurveySubmissionStatus.Save) {
              this.addedsurveyResponses = result.surveyResponses;
              this.prepareOrUpdateResponsesBackUp(result.surveyResponses, "AfterSave");
              this.notificationService.showSuccess("Form saved successfully.", "Success");
              this.isSaveRequired = false;
            }
            else {
              this.notificationService.showSuccess("Form submitted successfully.", "Success");
              this.isSaveRequired = false;
              this.apiCallForIntakeDataExportNew(this.surveyId, this.surveyResponseId);
              
              this.router.navigate(["/businessProcess"]);
              return;          
            }
            if(btnName=="Save"){
              // this.router.navigateByUrl("/businessProcess")
              this.router.navigateByUrl("/homePage");
            }
            if (btnName == "SaveAndContinue" || btnName == 'SavePopUp') {
              this.saveAndContinue(btnName);
            }
            this.spinnerService.hide();
          }
          else {
            this.notificationService.showError("Couldn't save your business process.", "Business process Error!");
          }
        }, error => {
          this.spinnerService.hide();
          this.notificationService.showApiError(error);
        });
      }
      else {
        this.spinnerService.hide();

        //this.addedsurveyResponses = [];
        if(btnName == "SaveAndContinue"){
          this.saveAndContinue(btnName);
        }
        else{
          this.notificationService.showSuccess("Form submitted successfully.", "Success");
          this.router.navigate(["/businessProcess"]);
          return;          
        }
      }
    } catch (error) {
      console.error('[IncidentComponent] apiCallForSectionSave - Error:', error);
      this.spinnerService.hide();
    }
  }

  apiCallForIntakeDataExport(surveyId: string, surveyResponseId: number) {
    try {
      this.spinnerService.show();
      let payload = {
        "AccessKey": environment.exportApiAccessKey,
        "SurveyId":[surveyId],
        "SurveyResponseId":surveyResponseId
      }
      this.baseHttpService.post(this.constant.invokeGetQuestionAndResponseExportForScheduler, payload).subscribe({
        next: (result) => {
          //console.log("Export result:", result);
          if (result != null) {
            if(environment.REALTIME_SURVEY_EXPORT_ENABLED){
              if (this.consentQuestions && this.consentQuestions.length > 0) {
                // Generate attestation PDFs asynchronously (no dependency for save)
                this.syncAttestationPdfData(result);
              } else {
                console.log("No consent questions available for attestation PDF generation");
                  // Immediately save intake data (independent of attestation workflow)
                  this.apiCallForSaveSurveyData(result);
              }
            
            }
          }
          else {
            console.log("Else Export Result:");
          }
          this.spinnerService.hide();
        },
        error: (error) => {
          this.spinnerService.hide();
          if (error && error.status === 500) {
           // Silently handle 500 errors without showing notification banner
            console.log("Export API returned 500 error - no notification shown");
          }
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] apiCallForIntakeDataExport - Error:', error);
      this.spinnerService.hide();
    }
  }

 apiCallForIntakeDataExportNew(surveyId: string, surveyResponseId: number) {
    this.spinnerService.show();
    let payload = {
      "AccessKey": environment.exportApiAccessKey,
      "SurveyId":[surveyId],
      "SurveyResponseId":surveyResponseId
    }
    this.baseHttpService.post(this.constant.GetQuestionAndResponseExportForDatSync, payload).subscribe({
      next: (result) => {
        if (result != null) {
          if(environment.REALTIME_SURVEY_EXPORT_ENABLED){
            if (this.consentQuestions && this.consentQuestions.length > 0) {
              // Generate attestation PDFs and Excel, then save
              this.syncAttestationPdfDataNew(result);
            } else {
              console.log("No consent questions available for attestation PDF generation");
                // Generate Excel, upload it, then save intake data
                this.generateAndUploadExcel(result, () => this.apiCallForSaveSurveyDataNew(result));
            }
          
          }
        }
        else {
          console.log("Else Export Result:");
        }
        this.spinnerService.hide();
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error.status === 500) {
         // Silently handle 500 errors without showing notification banner
          console.log("Export API returned 500 error - no notification shown");
        }
      }
    });
  }

  /**
   * Generates user response Excel, uploads it to S3, and sets the path on exportData.
   * Calls the provided callback after completion (even if Excel upload fails).
   */
  generateAndUploadExcel(exportData: any, onComplete: () => void): void {
    this.downloadService.generateExcelForUpload(this.surveyId, [this.surveyResponseId]).subscribe({
      next: ({ blob, fileName }) => {
        this.syncSurveyService.uploadExcelToS3(blob, fileName, this.surveyId, this.surveyResponseId).subscribe({
          next: (uploadResult) => {
            if (uploadResult && exportData.surveyIntake && exportData.surveyIntake.length > 0 && exportData.surveyIntake[0]) {
              exportData.surveyIntake[0].userResponseExcel = `{"filePath": "${uploadResult.filePath}", "name": "${uploadResult.name}"}`;
            }
            onComplete();
          },
          error: () => {
            console.warn('[IncidentComponent] Excel upload to S3 failed; proceeding without blocking save.');
            onComplete();
          }
        });
      },
      error: () => {
        console.warn('[IncidentComponent] Excel generation failed; proceeding without blocking save.');
        onComplete();
      }
    });
  }

  apiCallForSaveSurveyData(exportData: any) {
    try {
    this.spinnerService.show();
    
    this.baseHttpService.post(this.constant.invokeCopyToIdd, exportData, {"Content-Type": "application/json"}).subscribe((result) => {
      
      if (result != null) {
        this.spinnerService.hide();
      }
      else {
        this.spinnerService.hide();
      }
    });
    } catch (error) {
      console.error('[IncidentComponent] apiCallForSaveSurveyData - Error:', error);
      this.spinnerService.hide();
    }
  }

  apiCallForSaveSurveyDataNew(exportData: any) {
    try {
    this.spinnerService.show();
    
    this.baseHttpService.post(this.constant.SyncDataToIdd, exportData, {"Content-Type": "application/json"}).subscribe((result) => {
      
      if (result != null) {
        this.spinnerService.hide();
      }
      else {
        this.spinnerService.hide();
      }
    });
    } catch (error) {
      console.error('[IncidentComponent] apiCallForSaveSurveyDataNew - Error:', error);
      this.spinnerService.hide();
    }
  }
syncAttestationPdfData(exportData:any):void {
    try {
      // Attestation workflow only; saving occurs outside.
      if (!exportData || !this.downloadService || !this.syncSurveyService) {
        console.warn('[IncidentComponent] syncAttestationPdfData - exportData, downloadService, or syncSurveyService is null/undefined');
        return;
      }

      this.downloadService.mapAttestationData([this.surveyResponseId], false, this.surveyId).subscribe({
        next: (attestationFiles: any[]) => {
          if(attestationFiles && attestationFiles.length > 0){
            this.syncSurveyService.uploadAttestationPdfToS3(attestationFiles, this.surveyId).subscribe({
              next: (uploadResponse: {responseId: string, filePath: string, name: string}[]) => {
                if (uploadResponse && uploadResponse.length > 0 && uploadResponse[0]) {
                  if (exportData.surveyIntake && exportData.surveyIntake.length > 0 && exportData.surveyIntake[0]) {
                    exportData.surveyIntake[0].surveyAttestationPdf = `{"filePath": "${uploadResponse[0].filePath}", "name": "${uploadResponse[0].name}"}`
                  }
                }
                this.apiCallForSaveSurveyData(exportData);
              },
              error: () => {
                this.apiCallForSaveSurveyData(exportData);
                console.warn('[IncidentComponent] Upload to S3 failed; proceeding without blocking save.');
              }
            });
          } else {
            console.info('[IncidentComponent] No attestation files generated; nothing to upload/sync.');
            this.apiCallForSaveSurveyData(exportData);
          }
        },
        error: () => {
          this.apiCallForSaveSurveyData(exportData);
          console.warn('[IncidentComponent] Attestation generation failed; continuing without blocking save.');
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] syncAttestationPdfData - Error:', error);
    }
}

syncAttestationPdfDataNew(exportData:any):void {
    try {
      // Attestation workflow only; saving occurs outside.
      if (!exportData || !this.downloadService || !this.syncSurveyService) {
        console.warn('[IncidentComponent] syncAttestationPdfDataNew - exportData, downloadService, or syncSurveyService is null/undefined');
        return;
      }

      this.downloadService.mapAttestationData([this.surveyResponseId], false, this.surveyId).subscribe({
        next: (attestationFiles: any[]) => {
          if(attestationFiles && attestationFiles.length > 0){
            this.syncSurveyService.uploadAttestationPdfToS3(attestationFiles, this.surveyId).subscribe({
              next: (uploadResponse: {responseId: string, filePath: string, name: string}[]) => {
                if(uploadResponse && uploadResponse.length > 0 && uploadResponse[0]){
                  if (exportData.surveyIntake && exportData.surveyIntake.length > 0 && exportData.surveyIntake[0]) {
                    exportData.surveyIntake[0].surveyAttestationPdf = `{"filePath": "${uploadResponse[0].filePath}", "name": "${uploadResponse[0].name}"}`
                  }
                }
                // Generate and upload Excel before saving
                this.generateAndUploadExcel(exportData, () => this.apiCallForSaveSurveyDataNew(exportData));
              },
              error: () => {
                console.warn('[IncidentComponent] Upload to S3 failed; proceeding without blocking save.');
                this.generateAndUploadExcel(exportData, () => this.apiCallForSaveSurveyDataNew(exportData));
              }
            });
          } else {
            console.info('[IncidentComponent] No attestation files generated; nothing to upload/sync.');
            this.generateAndUploadExcel(exportData, () => this.apiCallForSaveSurveyDataNew(exportData));
          }
        },
        error: () => {
          console.warn('[IncidentComponent] Attestation generation failed; continuing without blocking save.');
          this.generateAndUploadExcel(exportData, () => this.apiCallForSaveSurveyDataNew(exportData));
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] syncAttestationPdfDataNew - Error:', error);
    }
}



  resetSectionWithPopUp(){
    try {
      if (!this.dialog || !this.selectedSection) {
        console.warn('[IncidentComponent] resetSectionWithPopUp - dialog or selectedSection is null/undefined');
        return;
      }

      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '350px';
      dialogConfig.position = {top:'5px'}
      dialogConfig.data = "Are you sure you want to reset ?";

      const logoutRef = this.dialog.open(CommonMessageComponent,dialogConfig);

      if (!logoutRef) {
        console.warn('[IncidentComponent] resetSectionWithPopUp - logoutRef is null/undefined');
        return;
      }

      logoutRef.afterClosed().subscribe(res=>{
        if(res){
          //this.resetSectionResponses();
          /* Reset the current section and toggle questions and sections and its dependents */
          if (this.selectedSection) {
            this.clearSectionResponses(this.selectedSection);
            if (this.selectedSection.questions && this.selectedSection.questions.length > 0) {
              this.selectedSection.questions.forEach(question => {
                if (!question) return;
                //this.ToggleQuestions(question, this.selectedSection);
                this.selectedSection.questions.forEach(q => { 
                  if (q) {
                    q.isParentQuestionVisible = true; 
                  }
                });
                this.selectedSection.questions.forEach(q => {
                  if (!q) return;
                  //this.ToggleQuestions(question, this.selectedSection);
                  this.ToggleConditionalQuestions(q, this.selectedSection);
                });
              });
            }
            this.ToggleConditionalSections(this.selectedSection);
          }
          this.isScrolled = false;
          this.isSaveRequired = true;
        }      
      })
    } catch (error) {
      console.error('[IncidentComponent] resetSectionWithPopUp - Error:', error);
    }
  }

  prepareOrUpdateResponsesBackUp(newOrSavedResponses: any, action: string){    
    try {
      if (!newOrSavedResponses || !Array.isArray(newOrSavedResponses) || !this.responsesBackUp) {
        console.warn('[IncidentComponent] prepareOrUpdateResponsesBackUp - newOrSavedResponses is not an array or responsesBackUp is null/undefined');
        return;
      }

      newOrSavedResponses.forEach(r => { 
        if (!r) return;
        
        let found = this.responsesBackUp.find(x=> x && x.questionId == r.questionId);
        if(found != null){
          found.surveyResponseRelId = (action == "BeforeSave") ? r.surveyResponseRelId : r.surveyReponseID;/**From api coming as surveyReponseID property check spelling */
          found.questionReponse = (action == "BeforeSave") ? r.responseText : r.response;
          found.comments = r.comments;
        }
        else{
          found = new QuestionResponsesdata();
          found.questionId = r.questionId;
          found.surveyResponseRelId = (action == "BeforeSave") ? r.surveyResponseRelId : r.surveyResponseID;
          found.questionReponse = (action == "BeforeSave") ? r.responseText : r.response;
          found.comments = r.comments;
          this.responsesBackUp.push(found);
        }
      });   
    } catch (error) {
      console.error('[IncidentComponent] prepareOrUpdateResponsesBackUp - Error:', error);
    }
  }

  resetToPreviousSectionResponses(currentSection: any) {
    try {
      if (!currentSection || !this.surveyViewModel || !this.responsesBackUp || !this.selectedSection) {
        console.warn('[IncidentComponent] resetToPreviousSectionResponses - currentSection, surveyViewModel, responsesBackUp, or selectedSection is null/undefined');
        return;
      }
      
      // Helper function to update question with backup response
      const updateQuestionWithBackup = (question: any) => {
        if (!question) {
          return null;
        }
        
        const updatedQuestion = { ...question };
        updatedQuestion.responseText = "";
        updatedQuestion.responses = [];
        
        const foundResponse = this.responsesBackUp.find(x => x && x.questionId === question.questionId);
        if (foundResponse) {
          Object.assign(updatedQuestion, {
            responseText: foundResponse.questionReponse,
            comments: foundResponse.comments,
            IsValid: foundResponse["IsValid"],
            _updateToken: Date.now()
          });
        }
        
        return updatedQuestion;
      };

      // Process questions recursively
      const processQuestions = (questions: any[]) => {
        if (!questions || !Array.isArray(questions)) {
          return [];
        }
        
        return questions.map(question => {
          if (!question) return null;
          
          const updatedQuestion = updateQuestionWithBackup(question);
          if (!updatedQuestion) return null;
          
          if (question.subQuestions?.length > 0) {
            updatedQuestion.subQuestions = processQuestions(question.subQuestions);
          }
          
          return updatedQuestion;
        }).filter(q => q !== null);
      };

      // Update section questions
      if (currentSection.questions && Array.isArray(currentSection.questions)) {
        this.selectedSection.questions = processQuestions(currentSection.questions);
      }

      if (this.surveyViewModel.sections) {
        const allChildSections = this.surveyViewModel.sections.filter(s => s && s.ParentSectionGuid === currentSection.SectionGuid);
        if (allChildSections && allChildSections.length > 0) {
          allChildSections.forEach(childSection => {
            if (childSection && childSection.questions && Array.isArray(childSection.questions)) {
              childSection.questions = processQuestions(childSection.questions);
            }
          });
        }
      }

      // Trigger change detection
      if (this.zone && this.cdr) {
        this.zone.run(() => {
          this.selectedSection = { ...currentSection };
          if (this.surveyViewModel.sections) {
            let secIndex = this.surveyViewModel.sections.findIndex(s => s && s.sectionId === this.selectedSection.sectionId);
            if(secIndex !== -1){
              this.surveyViewModel.sections[secIndex] = { ...this.selectedSection }; //As setSectionDotColor_NEW using surveyViewModel.sections to set color dot
            }
          }
          this.cdr.detectChanges();
        });
      }

      //check for SubmitClose button visibility
      if(this.isLastStep && this.isLastSection) {
        if(this.isLastStep() && this.isLastSection()) {
          this.isSaveAndClose = true;
        }
      }
      //Reset section color dot
      if (this.setSectionDotColor_NEW) {
        this.setSectionDotColor_NEW();
      }
    } catch (error) {
      console.error('[IncidentComponent] resetToPreviousSectionResponses - Error:', error);
    }
  }

 
  applyFailedMeasureRedDots(): void {
    if (!this.raiseDisputeMode || !this.mappedMeasuresMap) {
      return;
    }

    // Get failed section IDs using existing function
    const failedSectionIds = this.getFailedSectionIds();

    if (failedSectionIds.size === 0) {
      return;
    }

    // Apply red to wfSteps sectionsList (workflow nav)
    if (this.wfSteps && this.wfSteps.length > 0) {
      this.wfSteps.forEach(w => {
        if (w && w.sectionsList) {
          w.sectionsList.forEach(s => {
            if (failedSectionIds.has(s.sectionId)) {
              s.sectionDotColor = 'red';
            }
          });
        }
      });
    }

    // Force Angular to re-render the nav dots immediately
    if (this.cdr) {
      this.cdr.detectChanges();
    }
  }

  // Check if a specific measure is failed
  isFailedMeasure(questionId: number): boolean {
    const entry = this.mappedMeasuresMap[questionId];
    return entry?.measures?.some((m: any) => m.reviewReasons && m.reviewReasons.length > 0) ?? false;
  }

  // Get all section IDs that have failed measures
  getFailedSectionIds(): Set<number> {
    const failedSectionIds = new Set<number>();
    
    if (this.mappedMeasuresMap) {
      Object.values(this.mappedMeasuresMap).forEach((entry: any) => {
        if (entry.measures?.some((m: any) => m.isMet === false)) {
          failedSectionIds.add(entry.sectionId);
        }
      });
    }
    
    return failedSectionIds;
  }

  // Check if current section has failed measures
  hasFailedMeasuresInSection(sectionId: number): boolean {
    const failedSectionIds = this.getFailedSectionIds();
    return failedSectionIds.has(sectionId);
  }

  // Check if dispute should be shown for question (based on section having failed measures)
  showDisputeForQuestion(): boolean {
    return this.raiseDisputeMode && 
           this.selectedSection &&
           this.hasFailedMeasuresInSection(this.selectedSection.sectionId);
  }

  setDisputeDetailsonLoad(){
    try {
      if (!this.globalSession || !this.appConstants) {
        console.warn('[IncidentComponent] setDisputeDetailsonLoad - globalSession or appConstants is null/undefined');
        return;
      }

      this.raiseDisputeMode = this.globalSession.getRaiseDisputeFlag();
      if(this.raiseDisputeMode){    
        this.dispute = this.globalSession.getDispute(); 
        this.surveyDisputeConfig = this.globalSession.getSurveyDisputeConfig();
        //this.IsReadOnly = (this.surveyDisputeConfig && this.surveyDisputeConfig.isFormEditable) ? false : true;
        this.IsReadOnly = true; // Dispute form is always read-only
        
        if (this.appConstants.disputeStatus) {
          this.isDisputeRaised = (this.dispute && this.dispute.disputeId > 0 && this.dispute.status === this.appConstants.disputeStatus.RAISED) ? true : false;
        } else {
          this.isDisputeRaised = false;
        }
        
        this.disputeQuestionBackup = [] as IDisputeQuestion[];

        if(this.dispute == null){
          this.dispute = {} as IDispute;
          this.isDisputeRaised = false;
        }

        
        if(this.dispute && this.dispute.disputeQuestions && this.dispute.disputeQuestions.length > 0){
          this.disputeQuestionBackup = this.dispute.disputeQuestions.map(d => d ? ({...d}) : null).filter(d => d !== null); // Create a shallow copy of dispute questions      
        }

        // Get initial mapped measures and keep syncing future updates.
        this.mappedMeasuresMap = this.globalSession.getMappedMeasureReviewDetails();
         this.prepareFailedQuetionIds(this.mappedMeasuresMap);
        this.globalSession
          .mappedMeasureReviewDetails$()
          .pipe(takeUntil(this.destroy$))
          .subscribe((mapped) => {
            this.mappedMeasuresMap = mapped || {};
            this.prepareFailedQuetionIds(mapped);
            this.applyFailedMeasureRedDots();
          });
      }       
    } catch (error) {
      console.error('[IncidentComponent] setDisputeDetailsonLoad - Error:', error);
    }
  }
  onDisputeRaised(disputeQues: IDisputeQuestion) {   
    try {
      if (!this.dispute) {
        console.warn('[IncidentComponent] onDisputeRaised - dispute is null/undefined');
        return;
      }

      if(this.dispute.disputeQuestions == null){
        this.dispute.disputeQuestions = [];
      }

      if (disputeQues && ((disputeQues.comments && typeof disputeQues.comments === 'string' && disputeQues.comments.trim().length > 0) || (disputeQues.files && disputeQues.files.length > 0) || disputeQues.disputePromptId > 0)) {
      

        // Check if dispute question for this questionId already exists
        const existingIndex = this.dispute.disputeQuestions.findIndex(d => d && d.questionId === disputeQues.questionId);
        if (existingIndex !== -1) {
          this.dispute.disputeQuestions[existingIndex] = disputeQues;
        } else {
          this.dispute.disputeQuestions.push(disputeQues);
        }
      }
    } catch (error) {
      console.error('[IncidentComponent] onDisputeRaised - Error:', error);
    }
  }

  onFileUploadInProgress(inProgress: boolean): void {
    if(inProgress){
      this.spinnerService.show();
    }
    else{
      this.spinnerService.hide();
    }
    this.FileUploading = inProgress;
  }

  saveDispute(action: string) {
    try {
      if (!action || !this.dispute) {
        console.warn('[IncidentComponent] saveDispute - action or dispute is null/undefined');
        return;
      }
        if(action == "Submit") {
          if(this.dispute && this.dispute.disputeQuestions && this.dispute.disputeQuestions.length > 0) {
            this.openDisputeSignature(action, this.dispute, (signResponse: IDisputeSignResponse) => {
              if(signResponse != null) {
                if (this.dispute) {
                  this.dispute.disputeSignResponse = signResponse;
                  this.proceedWithDisputeSubmission(action);   // Now proceed with submission after signature is captured
                }
              }
            });
          }
        }
        else {
             // For SaveAndContinue or SaveAndExit, proceed even without dispute data
              if(this.selectedSection && this.hasFailedMeasuresInSection(this.selectedSection.sectionId) && this.dispute && this.dispute.disputeQuestions && this.dispute.disputeQuestions.length > 0) {
                this.proceedWithDisputeSubmission(action);    // Save dispute data if exists
              } else {
                // No dispute data yet, just navigate
                if (action === "SaveAndContinue" || action === 'SavePopUp') {
                  this.saveAndContinue(action);
                } else if (action === "SaveAndExit") {
                  this.router.navigateByUrl("/homePage");
                }
              }
        }

      
     
    } catch (error) {
      console.error('[IncidentComponent] saveDispute - Error:', error);
    }
  }  
  proceedWithDisputeSubmission(action: string) {
    try {
      if (!action || !this.spinnerService || !this.notificationService) {
        console.warn('[IncidentComponent] proceedWithDisputeSubmission - action, spinnerService, or notificationService is null/undefined');
        return;
      }

      this.spinnerService.show();
      this.apiCallForDispute(action, (success: boolean) => {
        const message = (action === 'SaveAndContinue' || action === 'SaveAndExit') ? 'saved' : 'submitted';
        if (success) {
          if (this.notificationService) {
            this.notificationService.showSuccess(`Resolution response ${message} successfully.`, "Success!");
          }

          /** handle post save actions */
          if (action === "SaveAndExit") {
            if (this.router) {
              this.router.navigateByUrl("/homePage");
            }
          }
          if (action === "SaveAndContinue" || action=='SavePopUp') {
            if (this.saveAndContinue) {
              this.saveAndContinue(action);
            }
          }
           else if (action === "Submit") {
            this.isSaveRequired = false;
          //   this.apiCallForIntakeDataExport(this.surveyId, this.surveyResponseId);
            if (this.router) {
              this.router.navigate(["/businessProcess"]);
            }
          }
        } else {
          if (this.notificationService) {
            this.notificationService.showError(`Couldn't save content for resolution.`, "Failure!");
          }
        }        
        if (this.spinnerService) {
          this.spinnerService.hide();
        }
      });
    } catch (error) {
      console.error('[IncidentComponent] proceedWithDisputeSubmission - Error:', error);
      if (this.spinnerService) {
        this.spinnerService.hide();
      }
    }
  }
  apiCallForDispute(action: string, callback: (success: boolean) => void) {
    try {
      if (!callback || typeof callback !== 'function') {
        console.warn('[IncidentComponent] apiCallForDispute - callback is not a function');
        return;
      }

      if (!this.dispute || !this.appConstants || !this.disputeService) {
        console.warn('[IncidentComponent] apiCallForDispute - dispute, appConstants, or disputeService is null/undefined');
        callback(false);
        return;
      }

      if (this.dispute && this.dispute.disputeQuestions && this.dispute.disputeQuestions.length > 0) {
        this.dispute.surveyResponseId = this.surveyResponseId;
        
        if (this.appConstants.disputeStatus) {
          this.dispute.status = (action == "Submit") ? this.appConstants.disputeStatus.RAISED : this.appConstants.disputeStatus.NOT_RAISED;
        }
        
        if (this.appConstants.disputeAction) {
          this.dispute.disputeAction = (action == "Submit") ? this.appConstants.disputeAction.SUBMIT : this.appConstants.disputeAction.SAVE;
        }
        if (this.currStp && Array.isArray(this.currStp) && this.currStp.length > 0 && this.currStp[0]) {
          this.dispute.workflowStepName = this.currStp[0].stepName;
        } else if (this.currStp && typeof this.currStp === 'object' && 'stepName' in this.currStp) {
          this.dispute.workflowStepName = (this.currStp as any).stepName;
        }
        this.disputeService.saveDispute(this.dispute).subscribe({
          next: (result) => {
            if (result) {
              this.dispute = result;
            }
            if (this.dispute && this.dispute.disputeQuestions && this.dispute.disputeQuestions.length > 0) {
              this.disputeQuestionBackup = this.dispute.disputeQuestions.map(d => d ? ({...d}) : null).filter(d => d !== null); // Create a shallow copy of dispute questions s      
            }
            callback(!!result);
          },
          error: () => callback(false)
        });      
      } else {
        callback(true);
      }
    } catch (error) {
      console.error('[IncidentComponent] apiCallForDispute - Error:', error);
      if (callback && typeof callback === 'function') {
        callback(false);
      }
    }
  }
  openDisputeSignature(action: string, disputeInput: IDispute, callback: (result: IDisputeSignResponse) => void): void {
    this.spinnerService.hide();   
    const dialogRef = this.dialog.open(DisputeSignatureComponent, {
      width: '750px', 
      height: 'auto',      
      data: {
        disputeInput : disputeInput,
        disputeConfig: this.surveyDisputeConfig
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result : IDisputeSignResponse) => {
      callback(result);       // Call the callback with the result (could be null if user cancelled)
    });
  }

    prepareFailedQuetionIds(mappedMeasures:any):void{

     Object.values(this.mappedMeasuresMap).forEach((entry: any) => {
        let failedMeasures=entry.measures.filter(x=>!x.isMet);
        failedMeasures.forEach(element => {
          element?.questionIds?.map(x=>{
              this.failedQuestionIds.add(x);
          });
        });
})
}

  resetDisputeSectionWithPopUp() {
    try {
      if (!this.dialog || !this.selectedSection) {
        console.warn('[IncidentComponent] resetDisputeSectionWithPopUp - dialog or selectedSection is null/undefined');
        return;
      }

      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '350px';
      dialogConfig.position = {top:'5px'}
      dialogConfig.data = "Are you sure you want to reset ?";
      const rdDialogRef = this.dialog.open(CommonMessageComponent,dialogConfig);
      
      if (!rdDialogRef) {
        console.warn('[IncidentComponent] resetDisputeSectionWithPopUp - rdDialogRef is null/undefined');
        return;
      }

      rdDialogRef.afterClosed().subscribe(res=>{
        if(res) {       
          this.isSaveRequired = true;
          if(this.dispute && this.dispute.disputeQuestions && this.dispute.disputeQuestions.length > 0) {
            // Get all question IDs from the selected section (main questions only)
            const quesIds = new Set<number>();          
            if (this.selectedSection.questions && this.selectedSection.questions.length > 0) {
              this.selectedSection.questions.forEach(question => { 
                if (question) {
                  quesIds.add(question.questionId); 
                }
              });
            }

            // Create a new dispute object to trigger ngOnChanges
            this.dispute = { 
              ...this.dispute,
              disputeQuestions: this.dispute.disputeQuestions.map(dq => {
                if (!dq) return dq;
                
                // Only reset dispute questions that belong to the selected section
                if (quesIds.has(dq.questionId)) {
                  return { ...dq, comments: "", files: "" };
                }
                return dq;  // Keep dispute questions from other sections unchanged
              })
            };
          }
        }           
      })
    } catch (error) {
      console.error('[IncidentComponent] resetDisputeSectionWithPopUp - Error:', error);
    }
  }
  resetToPreviousQuestionDispute(selectedSection: SectionViewModel) {
    try{
      if (!selectedSection || !this.dispute) {
        console.warn('[IncidentComponent] resetToPreviousQuestionDispute - selectedSection or dispute is null/undefined');
        return;
      }

      if(this.dispute && this.dispute.disputeQuestions && this.disputeQuestionBackup && this.disputeQuestionBackup.length > 0) {
        const quesIds = new Set<number>();      
        
        if (selectedSection.questions && selectedSection.questions.length > 0) {
          selectedSection.questions.forEach(question => { 
            if (question) {
              quesIds.add(question.questionId); 
            }
          });
        }
        
        console.log("disputeQuestionBackup on reset:",this.disputeQuestionBackup);

        // Update only dispute questions that belong to the selected section and have backup data
        const updatedDisputeQuestions = this.dispute.disputeQuestions.map(disputeQuestion => {
          if (!disputeQuestion) return disputeQuestion;
          
          if (quesIds.has(disputeQuestion.questionId)) {
            const backup = this.disputeQuestionBackup.find(b => b && b.questionId === disputeQuestion.questionId);          
            if (backup) {
              return { ...disputeQuestion, comments: backup.comments, files: backup.files };          
            }
            else {
              return { ...disputeQuestion, comments: "", files: "" };
            }
          }        
          return disputeQuestion;  // Keep dispute questions from other sections unchanged
        });
        
        // Create a new dispute object to trigger ngOnChanges
        this.dispute = {...this.dispute, disputeQuestions: updatedDisputeQuestions };
      }
    }
    catch(err){
      console.error('[IncidentComponent] resetToPreviousQuestionDispute - Error:', err);
    }
  }
}







export class QuestionResponsesdata {
  sectionId: number;
  questionId: number;
  questionReponse: string;
  sequenceNumber: number;
  comments: string;
  surveyResponseRelId: number;
  inputType: string;
}
export class Templates {
  theme: string;
  backgorund: string;
  foreground: string;
  ischecked: boolean;
}
export class ConditionalQues {
  que: string;
  value: string;
  isSelected?: boolean = false;
  parentQuestionGuid: string;
  questionId: number;
}
export class ConditionalSections {
  sectionName: string;
  value: string;
  isSelected?: boolean = false;
}


export interface FieldElement {
  eventID: string;
  eventDate: string;
  primaryNature: string;
  secondaryNature: string;
  eventStatus: string;
  severity: string;
  serviceRecipient: string;
}
export class IncidentParam {
  sectionId: number;
  bussinessProcessId: String;
  //groupId?: string;
  questions: Question[];
  questionResponses: QuestionResponsesdata[];
  //incidentId? : number;
  incidentStatus: string;
  SurveyUserESign?: string;
  SurveyInstanceId?: string;
  workflowStepId: number;
  createdByUserId: string;
  UserSurveyResponseId: number;
}
export class EntityInstance {
  entityId: string;
  entityInstanceId: string;
  entityInstanceName: string;
  surveyInstance: SurveyInstance;
}
export class SurveyInstance {
  surveyInstanceId: string;
  surveyInstanceName: string;
  entityInstanceId: string;
}
export class ResponseChangeModel {
  constructor(
    public question: QuestionViewModel,
    public oldResponse: string,
    public newResponse: string,
    public proceed: (shouldProceed: boolean) => void
  ) {}
}